<template>
  <div class="live">
    <headWrapper
      ref="tongbutx"
      :login="login"
      v-on:send="showQrcode"
      :userLogin="userLogin"
      :imgsrc="imgsrc"
      :nicknc="nicknc"
      @geRendy="tanChuanghr"
    ></headWrapper>
    <div class="container">
      <div class="index_contain">
        <div class="head clearfix">
          <div class="text fl" style="display: flex; align-items: center">
            <h2 style="color: #ffffff">
              <span class="status" v-if="status == '回看'">回看</span>
              <span
                class="status"
                style="
                  background: linear-gradient(137deg, #73aaff 5%, #0053ff 93%);
                "
                v-else
                >直播</span
              >
              <span style="font-size: 16px">{{ direct.name }}</span>
            </h2>
            <div
              v-if="showPersonNum"
              style="margin-left: 20px; margin-top: 4px"
            >
              <!-- <span  class="time" style="color: white">直播时间：{{ this.zhioboTime }}</span> -->
              <img
                style="width: 20px; vertical-align: middle; margin-right: 1px"
                src="https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/wx-user/img/personicon.png"
              />
              <span style="color: white; vertical-align: middle">{{
                c_view_num
              }}</span>
            </div>
          </div>
          <div class="tips fr"></div>
        </div>
        <div class="playbox" v-if="isplay">
          <div class="player">
            <div
              class="player_content"
              v-show="isShowLivePage"
              v-if="!isyxinImLoginOut"
            >
              <template v-if="isThreeScreen">
                <div id="whiteBoardTopDiv"></div>
                <TFPlayer
                  id="whiteBoardDiv"
                  :isThreeScreen="isThreeScreen"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                  "
                  :isWhitebord="true"
                  ref="tfPlayer1"
                  :videoIndex="flag"
                  :initData="initAllData"
                  :fans_id="fans_id"
                  :ishanhu="true"
                  :isThird="isThird"
                  playerid="1"
                  @cutSwitch="cutSwitch"
                  @playerBtnClick="handlePlayerBtnClick('whiteBoard')"
                  :runObj="runObj"
                  :copyrightObj="copyrightObj"
                  :nick="userLogin.nick"
                  :remark="remark"
                >
                </TFPlayer>
              </template>
              <TFPlayer
                v-else
                ref="tfPlayer"
                :initData="initAllData"
                :fans_id="fans_id"
                :videoIndex="flag"
                :ishanhu="true"
                @playerListener="playerListener"
                @statusChange="playerStatusChange"
                @linkTypeChange="linkTypeChange"
                @isSupportRTC="isSupportRTCCallBack"
                @unAutoPlay="unAutoPlay"
                @playFailed="playFailed"
                :runObj="runObj"
                :copyrightObj="copyrightObj"
                :nick="userLogin.nick"
                :remark="remark"
                :isThird="isThird"
              >
              </TFPlayer>
            </div>
            <img
              class="teacherQr"
              v-if="showVideoQrCode"
              @click="isShowTeacherQrCode = true"
              src="https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/rad_heart.png"
            />
            <div class="bubble-wrap">
              <div
                class="bubble-welcome"
                v-for="(item, index) of bobbleUserList"
                :key="index"
              >
                <img :src="item.header" />
                <span>{{
                  hideNickFlag ? `${item.nick[0]}****` : item.nick
                }}</span>
                进入直播间
              </div>
            </div>
            <div v-if="isLive && exTime" class="appointmentTime">
              <p class="timeMessage" v-if="isShowCount">
                距{{ startTime.month }}月{{ startTime.day }}日{{ time }}开播还有
              </p>
              <p class="exactTime" v-if="isShowCount">
                <span>{{ timeData.days }}</span>
                天
                <span>{{ timeData.hours }}</span>
                时
                <span>{{ timeData.minutes }}</span>
                分
                <span>{{ timeData.seconds }}</span>
                秒
              </p>
            </div>
          </div>
          <!--评论列表-->
          <div
            class="comment"
            style="display: flex; flex-direction: column; margin-left: 10px"
            v-if="allow"
          >
            <div
              v-if="isThreeScreen"
              style="position: relative; padding-top: 56%; margin-bottom: 10px"
            >
              <div id="CameraVideoTopDiv"></div>
              <TFPlayer
                ref="tfPlayer"
                id="CameraVideoDiv"
                :isThreeScreen="isThreeScreen"
                style="position: absolute; top: 0; left: 0; right: 0; bottom: 0"
                :initData="initAllData"
                :ishanhu="true"
                :fans_id="fans_id"
                :videoIndex="flag"
                @playerListener="playerListener"
                @statusChange="playerStatusChange"
                @linkTypeChange="linkTypeChange"
                @playerBtnClick="handlePlayerBtnClick('camera')"
                @isSupportRTC="isSupportRTCCallBack"
                @unAutoPlay="unAutoPlay"
                @cutSwitch="cutSwitch"
                @playFailed="playFailed"
                :runObj="runObj"
                :copyrightObj="copyrightObj"
                :nick="userLogin.nick"
                :isThird="!isThird"
                :remark="remark"
              >
              </TFPlayer>
            </div>
            <div style="flex: 1; position: relative" v-if="interaction">
              <div class="commentHeader">
                <div
                  :class="{
                    select: commentTab == 1,
                    width100: !showTeacherTab,
                  }"
                  @click="changeCommentTab(1)"
                  class="item"
                >
                  公屏聊天
                </div>
                <div
                  v-if="showTeacherTab"
                  :class="{ select: commentTab == 2 }"
                  @click="changeCommentTab(2)"
                  class="item"
                >
                  咨询老师
                  <span v-if="unReadNum" class="redPoint"></span>
                </div>
              </div>
              <div
                ref="unReadMessageView"
                @click="changeCommentTab(2)"
                v-if="showUnReadView"
                class="unReadView unReadViewShowAni"
              >
                <img
                  class="header"
                  v-if="unReadMsgData"
                  :src="unReadMsgData.header"
                />
                {{ unReadMsgData ? unReadMsgData.nick : "" }}:
                {{ unReadMsgData ? unReadMsgData.content : "" }}
                <i class="sanjiao"></i>
              </div>
              <div
                v-show="commentTab == 2 && showTeacherTab"
                class="consultTeacher"
              >
                <ConsultTeacher
                  ref="consultTeacher"
                  :dsId="ds_id"
                  :channel_id="channel_REL_ID"
                  :fansId="fans_id"
                  :tid="tid"
                ></ConsultTeacher>
              </div>
              <div
                v-show="
                  showNewMsgTip && commentTab == 1 && !to_fans_idlist.length
                "
                @click="scrollToBottom()"
                class="new-comment-tipsmsg"
              >
                有新消息
              </div>
              <div
                v-if="
                  to_fans_idlist.length &&
                  to_fans_idlist[0].to_fans_id == fans_id
                "
                @click="at_to()"
                class="new-comment-tipsmsg"
              >
                {{ changeNick(to_fans_idlist[0].nick) }}提到了你
              </div>
              <div
                v-if="noticeObj.open && isNoitceTopShow && commentTab == 1"
                class="noticeBar noticeTop"
              >
                <div style="font-weight: 500">公告</div>
                <div style="flex: 1; margin-left: 3px">
                  {{ noticeObj.content }}
                </div>
              </div>
              <ul
                id="commentList"
                class="list"
                v-show="commentTab == 1"
                :style="{ bottom: login ? '139px' : '50px' }"
              >
                <div
                  v-if="noticeObj.open && isNoitceTopShow"
                  class="noticeBar"
                  style="visibility: hidden"
                >
                  <div style="font-weight: 500">公告</div>
                  <div style="flex: 1; margin-left: 3px">
                    {{ noticeObj.content }}
                  </div>
                </div>
                <template v-for="(item, index) in comlist">
                <!-- 成单喜报 -->
                <div :key="index" v-if="item.module == 'Buying_now'">
                  <div class="chengdan_xibao">
                    <span class="datihb">🔥🔥 恭喜
                      <span style="color: #A9C4FF" v-if="item.name.length <= 6">{{item.name}}</span>
                      <span style="color: #A9C4FF" v-if="item.name.length >= 7">{{item.name.slice(0, 6)}}...</span>
                    </span>
                    <span class="datihb">  成功购买【{{ item.spname }}】🎉🎉</span>
                  </div>
                  </div>
                  <li
                    :key="index"
                    style="padding: 10px 8px 10px 10px"
                    v-if="
                      item.module == 'text_comment' && item.fans_id != hostId
                    "
                    :ref="item.to_fans_id"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        color: white;
                      "
                    >
                      <div style="display: flex; align-items: center">
                        <img
                          style="width: 32px; height: 32px; border-radius: 16px"
                          :src="item.header"
                        />
                        <span
                          :style="{
                            color: item.to_fans_id ? '#027DB4' : 'white',
                          }"
                          style="margin-left: 10px; font-size: 13px"
                          >{{ changeNick(item.nick, item.showzhu == 1) }}</span
                        >
                        <span v-if="item.showzhu == 1" class="zhuTeacher"
                          >老师</span
                        >
                        <!-- <span style="color:#B8B6B6;margin-left:3px;font-size: 13px;" v-if="item.to_fans_id">回复你</span> -->
                        <!-- <span class="status" style="margin-left: 5px;" v-if="i == 1">主播</span> -->
                      </div>
                      <div
                        v-if="
                          !(
                            userConfigData &&
                            userConfigData.showCommentTime === 0
                          )
                        "
                        style="font-size: 13px; white-space: nowrap"
                      >
                        {{
                          item.create_time.substr(5, item.create_time.length)
                        }}
                      </div>
                    </div>
                    <div style="display: flex; flex-direction: column">
                      <div>
                        <div
                          style="
                            margin-bottom: 5px;
                            line-height: 20px;
                            margin-left: 40px;
                            display: inline-block;
                            padding: 10px;
                            border-radius: 5px;
                            background-color: #575455;
                            color: #ffffff;
                            max-width: 78%;
                            position: relative;
                          "
                        >
                          <div>
                            <div
                              style="
                                width: 100%;
                                word-wrap: break-word;
                                word-break: break-all;
                                overflow: hidden;
                                white-space: pre-line;
                              "
                              v-if="item.content"
                              v-dompurify-html="item.content"
                            ></div>
                          </div>

                          <el-image
                            class="commentimg"
                            style="margin-top: 10px"
                            v-if="item.pic_url"
                            :src="item.pic_url"
                            :preview-src-list="[item.pic_url]"
                          >
                          </el-image>
                          <span
                            v-if="item.showcopytext"
                            class="copyText"
                            @click="copyTextTap(item.content)"
                            >复制</span
                          >
                        </div>
                      </div>
                      <div>
                        <div
                          v-if="item.replyUserItem_content"
                          style="
                            line-height: 20px;
                            margin-left: 40px;
                            display: inline-block;
                            padding: 10px;
                            border-radius: 5px;
                            background-color: #575455;
                            color: #999999;
                            max-width: 78%;
                            position: relative;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              word-wrap: break-word;
                              word-break: break-all;
                              overflow: hidden;
                              /* white-space: pre-line; */
                            "
                          >
                            {{ item.to_nick }}：
                            <span
                              v-dompurify-html="item.replyUserItem_content"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </template>
              </ul>
              <div class="goods-list" v-if="showGoodsList">
                <goodsList
                  :goodsList="goodsList"
                  :fans_id="fans_id"
                  :channel_id="channel_id"
                  @showGoodsQrCode="showGoodsQrCode"
                ></goodsList>
                <img
                  class="close-btn"
                  @click="showGoodsList = false"
                  src="../assets/imgs/close.png"
                />
              </div>
              <!-- 优惠券 -->
              <div v-if="isShowCoupon" class="couponBox">
                <img
                  src="../assets/imgs/youhuijuangb.png"
                  @click="getCouponsList()"
                />
              </div>
              <div v-if="showCouponList" class="goods-list coupons-list">
                <couponsList
                  ref="couponList"
                  :dsId="ds_id"
                  :channelId="channel_id"
                  @gotoUse="gotoUseCouponGood"
                  @closeCouponsList="showCouponList = false"
                ></couponsList>
                <img
                  class="close-btn"
                  @click="showCouponList = false"
                  src="../assets/imgs/close.png"
                />
              </div>
              <!-- 达成条件的优惠券弹窗 -->
              <recommend
                ref="recommend"
                :dialogVisible="isRecommendVisible"
                :dsId="ds_id"
                :channelId="channel_id"
                :fans_id="fans_id"
                :couponTuijianData="couponTuijianData"
                @showGoodsQrCode="showGoodsQrCode"
                @close="recommendClose"
              />
              <!-- 未达成条件的优惠券弹窗 -->
              <NotAchieveCoupon
                :dialogVisible="noCouponVisible"
                :lookingTime="lookingTime"
                :couponTuijianData="couponTuijianData"
                @timeAchieved="timeAchievedFn"
                @close="recommendClose"
              />
              <!-- 优惠券中的商品列表 -->
              <div class="goods-list" v-if="showcouponsGoodList">
                <couponsProduct
                  :goodsList="couponsGoodList"
                  :fans_id="fans_id"
                  :channel_id="channel_id"
                  @showGoodsQrCode="showGoodsQrCode"
                ></couponsProduct>
                <img
                  class="close-btn"
                  @click="showcouponsGoodList = false"
                  src="../assets/imgs/close.png"
                />
              </div>

              <div class="publish" v-if="login && isShowLivePage">
                <div style="padding: 10px 0px 10px 0px">
                  <div>
                    <!-- v-show="imgcommentshow" -->
                    <!-- 伪直播添加快速评论 -->
                    <!-- <button
                    class="quick-button"
                    v-if="tid"
                    @click="showQuickMsgPanelAction"
                  >
                    快速评论
                  </button> -->

                    <el-popover placement="top" trigger="click">
                      <emotion @emotion="handleEmotion" :height="200"></emotion>
                      <div class="imgcommentbox" slot="reference">
                        <img
                          style="width: 17px"
                          src="../assets/imgs/moji.png"
                        />
                      </div>
                    </el-popover>

                    <!-- 鲜花 -->
                    <img
                      v-if="is_show_gift && flowers == 'true'"
                      style="width: 17px; margin-left: 5px"
                      @click="sendFllowerTap(1)"
                      src="../assets/imgs/follower.png"
                    />
                    <!-- 点赞 -->
                    <img
                      v-if="is_show_gift && flowers == 'true'"
                      style="width: 17px; margin-left: 5px"
                      @click="sendFllowerTap(2)"
                      src="../assets/imgs/dianzan.png"
                    />
                    <!-- 打赏 -->
                    <img
                      v-if="enabledDs == 'yes'"
                      style="width: 17px; margin-left: 5px"
                      @click="dialogVisibledas = true"
                      src="../assets/imgs/dashang.png"
                    />
                    <!-- 购物车 -->
                    <img
                      v-if="is_show_cart"
                      style="width: 17px; margin-left: 5px"
                      @click="getGoodsList()"
                      src="../assets/imgs/shopping-cart-fill.png"
                    />

                    <el-popover
                      placement="top"
                      trigger="manual"
                      v-model="visible"
                    >
                      <div
                        draggable="true"
                        @click="$refs.onkeyupdateBtn.click()"
                        style="width: 140px; height: 140px; margin: auto"
                        @dragover="dragoverAction"
                        @drop="dragAction"
                      >
                        <img
                          v-if="occupyImg"
                          :src="occupyImg"
                          class="avatar"
                          style="
                            border: 1px dashed #d9d9d9;
                            border-radius: 5px;
                            width: 100%;
                            height: 100%;
                          "
                        />
                        <div v-else>
                          <i
                            class="el-icon-plus"
                            style="
                              border: 1px dashed #d9d9d9;
                              border-radius: 5px;
                              width: 100%;
                              height: 100%;
                              line-height: 140px;
                              text-align: center;
                            "
                          ></i>
                          <p
                            style="
                              position: relative;
                              margin-top: -50px;
                              text-align: center;
                            "
                          >
                            支持拖拽上传
                          </p>
                        </div>
                      </div>
                      <div
                        class="imgcommentbox"
                        slot="reference"
                        v-show="piccomment"
                        @click="imgcomment"
                      >
                        <img
                          style="width: 17px; margin-left: 5px"
                          src="../assets/imgs/image.png"
                        />
                      </div>
                    </el-popover>
                    <input
                      ref="onkeyupdateBtn"
                      @click="
                        (e) => {
                          e.target.value = '';
                        }
                      "
                      @change="getFilef($event)"
                      type="file"
                      v-show="false"
                    />
                    <!-- 礼物 -->
                    <!-- <img
                    style="width:17px;margin-left: 5px;"
                    src="../assets/imgs/gift.png"
                  /> -->
                    <template
                      v-if="
                        businessConfigs &&
                        (businessConfigs.student_room_link_mic_show ||
                          businessConfigs.student_room_link_mic_show ==
                            undefined) &&
                        (((direct.play_style == 3 || direct.play_style == 2) &&
                          direct.direct_status == 'running' &&
                          playerStatus == 2) ||
                          playerStatus == 3) &&
                        isRTCSupport && liveType == 'open'
                      "
                    >
                      <img
                        v-if="linkType == 3"
                        @click="onLinkClicked"
                        style="width: 17px; margin-left: 5px; cursor: pointer"
                        src="../assets/imgs/lianmaiing.png"
                      />
                      <img
                        v-else
                        @click="onLinkClicked"
                        style="width: 17px; margin-left: 5px; cursor: pointer"
                        src="../assets/imgs/unlianmai.png"
                      />
                    </template>
                    <template
                      v-if="
                        businessConfigs &&
                        (businessConfigs.student_room_link_mic_show_class ||
                          businessConfigs.student_room_link_mic_show_class ==
                            undefined) &&
                        (((direct.play_style == 3 || direct.play_style == 2) &&
                          direct.direct_status == 'running' &&
                          playerStatus == 2) ||
                          playerStatus == 3) &&
                        isRTCSupport && liveType == 'class'
                      "
                    >
                      <img
                        v-if="linkType == 3"
                        @click="onLinkClicked"
                        style="width: 17px; margin-left: 5px; cursor: pointer"
                        src="../assets/imgs/lianmaiing.png"
                      />
                      <img
                        v-else
                        @click="onLinkClicked"
                        style="width: 17px; margin-left: 5px; cursor: pointer"
                        src="../assets/imgs/unlianmai.png"
                      />
                    </template>
                    <img
                      v-if="isShowFocusQrBtn"
                      @click="isShowFouceQrCode = true"
                      style="width: 17px; margin-left: 5px; cursor: pointer"
                      src="../assets/imgs/guangzhu.png"
                    />
                    <span
                      v-if="playerStatus == 3"
                      style="color: #4abbff; font-size: 14px; float: right"
                      >正在和主播连麦…</span
                    >

                    <ShoppingCart
                      :type="showShoppingCartType"
                      :goodsInfo="goodsInfo"
                      :fans_id="fans_id"
                      :channel_id="channel_id"
                      @hide="showShoppingCartType = ''"
                      @showGoodsQrCode="showGoodsQrCode"
                    />
                  </div>
                  <div></div>
                </div>
                <div
                  style="
                    height: 96px;
                    background-color: #363636;
                    position: relative;
                  "
                >
                  <template v-if="is_all_users_muted && commentTab !== 2">
                    <div class="inputText" style="height: 48px; width: 100%">
                      全员禁言中...
                    </div>
                    <button
                      style="
                        border: none;
                        bottom: 10px;
                        right: 10px;
                        position: absolute;
                        width: 79px;
                        height: 31px;
                        text-align: center;
                        background: #a6a9ad;
                        border-radius: 16px;
                        font-size: 14px;
                        color: white;
                      "
                    >
                      发送
                    </button>
                  </template>
                  <template v-else>
                    <textarea
                      placeholder="说点什么吧…"
                      class="inputText"
                      v-model="comment"
                      @keyup.13="sendMsg"
                      style="height: 48px; width: 100%"
                    ></textarea>
                    <button @click="sendMsg" class="send-btn">发送</button>
                  </template>
                  <!-- 快速评论 -->
                  <div v-if="isShowQuickPanel" class="quick">
                    <div class="quickArrow"></div>
                    <ul class="quickPanel">
                      <li
                        v-for="(word, index) in comment_list"
                        @click="sendquickMsgAction(index)"
                        :key="index"
                      >
                        <span style="padding-right: 10px">{{ index + 1 }}.</span
                        ><span>{{ word.comment }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- 登录 -->
              <div class="loginBox" v-show="!login">
                <p
                  style="
                    text-align: center;
                    cursor: pointer;
                    color: #ff6600;
                    font-size: 18px;
                  "
                  @click="showQrcode"
                >
                  请先登录
                </p>
              </div>
            </div>
            <!-- 购物导购 -->
            <template v-if="showBuyTipsState">
              <!-- 正在购买商品通知 -->
              <div v-for="(item, index) in ShoppingGuideas" :key="item.duosr">
                <div
                  v-if="item.Buying_now && index === ShoppingGuideas.length - 1"
                  class="bug-tipsyi user-buy-goods"
                  :class="[showBuyGoodsTips ? 'show' : 'hide']"
                >
                  <img
                    src="@/assets/imgs/gouwuche_tkt.png"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.Buying_now == 1" class="zhenzam">正在买</div>
                  <div class="tipsyi">
                    <span v-if="item.Buying_now == 1">
                      <span class="username" v-if="item.name.length <= 6">{{ item.name }}</span>
                      <span class="username" v-if="item.name.length >= 7">{{ item.name.slice(0, 6) }}...</span>
                        <span style="flex-shrink: 0;">
                          <span v-if="item.duosr - cggmsp > 1">等{{ item.duosr - cggmsp }}人</span>正在去购买
                        </span>
                        <span style="color: #ffffff;">【{{item.spname}}】</span>
                      </span>
                      <span v-if="item.Buying_now == 2">
                        <span class="username" v-if="item.name.length <= 6">{{ item.name }}</span>
                        <span class="username" v-if="item.name.length >= 7">{{ item.name.slice(0, 6) }}...</span>
                        <span style="flex-shrink: 0"><span v-if="item.duosr - zzgmsp > 1">等{{ item.duosr - zzgmsp }}人</span>成功购买</span>
                        <span style="color: #ffffff;">【{{item.spname}}】</span>
                      </span>
                  </div>
                </div>
              </div>
              <div v-for="(item, index) in ShoppingGuidebs" :key="item.duosr">
                <div
                  v-if="item.Buying_now && index === ShoppingGuidebs.length - 1"
                    class="bug-tipsyi user-buy-goodsyi"
                    :class="[showBuyGoodsTipsyi ? 'show' : 'hide']"
                  >
                    <img
                      src="@/assets/imgs/gouwuche_tkt.png"
                      alt=""
                      srcset=""
                    />
                    <div v-if="item.Buying_now == 1" class="zhenzam">正在买</div>
                    <div class="tipsyi">
                      <span v-if="item.Buying_now == 1">
                        <span class="username" v-if="item.name.length <= 6">{{ item.name }}</span>
                        <span class="username" v-if="item.name.length >= 7">{{ item.name.slice(0, 6) }}...</span>
                        <span style="flex-shrink: 0;"><span v-if="item.duosr - cggmsp > 1">等{{ item.duosr - cggmsp }}人</span>正在去购买</span>
                        <span style="color: #ffffff;">【{{item.spname}}】</span>
                      </span>
                      <span v-if="item.Buying_now == 2">
                        <span class="username" v-if="item.name.length <= 6">{{ item.name }}</span>
                        <span class="username" v-if="item.name.length >= 7">{{ item.name.slice(0, 6) }}...</span>
                        <span style="flex-shrink: 0"><span v-if="item.duosr - zzgmsp > 1">等{{ item.duosr - zzgmsp }}人</span>成功购买</span>
                        <span style="color: #ffffff;">【{{item.spname}}】</span>
                      </span>
                    </div>
                  </div>
              </div>
            </template>
          </div>
          <!-- 遮罩，用户点击触发video播放视频，iPad需要用户交互才能自动播放两个视频 -->
          <div v-if="showAutoPlayModal" class="auto-play-modal">
            <el-button class="user-click-paly-btn" @click="playVideo">
              <div class="play-content">
                <img
                  src="@/assets/imgs/living_icon.gif"
                  alt=""
                  srcset=""
                  width="20"
                  heiht="20"
                />
                <span>点击播放</span>
              </div>
            </el-button>
          </div>
          <!-- 显示预约按钮 -->
          <div
            v-if="isAppointment && isLive && appointmentEnabled"
            class="appointment"
          >
            <div
              v-if="isAppointmentCheck"
              class="appointment-confirm"
              @click="cancelfans()"
            >
              <img src="@/assets/imgs/cancel_appointment.png" alt="" />
              <span class="cancel">已预约</span>
            </div>
            <div v-else class="appointment-confirm">
              <img
                src="@/assets/imgs/appointment_check.png"
                alt=""
                @click="SMSpublic"
              />
              <span>预约</span>
            </div>
          </div>
        </div>
        <!--  <div class="footerbox">
          <div class="sharebox">
            <div class="phoneQrcode" @mouseenter="phoneQrcode = true" @mouseleave="phoneQrcode = false">
              <div id="qrcode01" ref="qrcode01" v-show="phoneQrcode"></div>
              <p>微信扫码观看</p>
            </div>
            <div class="bshare-custom icon-medium">
              <a title="分享到微信" class="bshare-weixin"></a>
              <a title="分享到新浪微博" class="bshare-sinaminiblog"></a>
              <a title="分享到腾讯微博" class="bshare-qqmb"></a>
              <a title="更多平台" class="bshare-more bshare-more-icon more-style-addthis"></a>
            </div>
          </div>
        </div>-->
        <div class="videoBox">
          <div style="display: flex">
            <div
              v-for="(item, index) in menus"
              :key="`nav_${index}`"
              class="baseTab"
              style="margin-right: 30px"
              :class="{ baseTabActive: tabActive == index }"
              @click="tabActive = index"
            >
              <template v-if="item.name">
                {{ item.name }}
              </template>
              <template v-if="item.module == 'nav'"> 往期视频 </template>
            </div>
          </div>
          <!-- <p v-if="videoshow">
            <el-button type="primary" size="mini" @click="watch" v-if="zhibo">观看直播</el-button>
          </p>-->
          <div v-for="(item, index) in menus" :key="`content_${index}`">
            <div v-show="tabActive == index">
              <div
                style="
                  font-size: 16px;
                  color: white;
                  padding: 20px;
                  line-height: 20px;
                  max-width: 774px;
                "
                v-if="item.cid == 3"
              >
                <template>
                  <div class="contentBox" v-dompurify-html="item.content"></div>
                  <div v-if="xianshilist == '2'" class="zizhipc">
                    <div class="xinxiyang">
                      <div class="xiaotan" @click="zizhiguankantan = true">
                        <p style="font-size: 18px">公司信息</p>
                      </div>
                      <!-- <div class="xiaotanyi" @click="gerenzhongx = true"><p>个人中心</p></div> -->
                    </div>
                    <p
                      style="
                        color: rgb(238, 240, 241);
                        margin-top: 20px;
                        font-size: 16px;
                      "
                    >
                      珊瑚云直播提供技术支持
                    </p>
                    <p style="margin-top: 10px">
                      <a
                        style="color: rgb(238, 240, 241); font-size: 16px"
                        href="https://www.shanhuketang.com/index.html"
                        >www.shanhuketang.com</a
                      >
                    </p>
                  </div>
                </template>
              </div>
              <ul v-else>
                <li
                  style="
                    width: 339px;
                    height: 318px;
                    padding: 0;
                    position: relative;
                    box-sizing: border-box;
                  "
                  v-for="(list, index) in videoList"
                  @click="changeVideo(list, index)"
                  :key="index"
                >
                  <img style="height: 210px; width: 100%" :src="list.pic_url" />
                  <div
                    style="position: relative; height: 72px; padding: 0 12px"
                  >
                    <el-tooltip
                      :content="list.title"
                      v-if="list.title.length > 16"
                      placement="top"
                    >
                      <div class="video-title" :title="list.title">
                        {{ list.title }}
                      </div>
                    </el-tooltip>
                    <div class="video-title" v-else :title="list.title">
                      {{ list.title }}
                    </div>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: 15px;
                      "
                    >
                      <!-- <div style="display: flex;">
                    <img style="width: 16px;vertical-align: middle;margin-right: 5px;" src="../assets/imgs/renqi.png" />
                    <span style="color: #999999;">热度：{{ view_num }}</span>
                  </div> -->

                      <div style="color: #999999; margin-top: 5px">
                        {{ list.create_time }}
                      </div>
                      <div v-if="index == 0 && isLiving" class="watch-living">
                        正在直播
                      </div>
                      <div v-else>
                        <div v-if="flag != index" class="watch-replay">
                          观看回放
                        </div>
                        <div v-else class="watch-replay">正在播放</div>
                      </div>
                    </div>
                  </div>
                  <!-- <p v-if="flag == index" style="
                      font-size: 18px;
                      color: #409eff;
                      position: absolute;
                      left: 0;
                      text-align: center;
                      top: 50%;
                      transform: translateY(-50%);
                      width: 100%;
                    ">
                    正在播放中..
                  </p> -->
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="qrcodebox" v-show="wxqrcode" @click="showWx">
      <div class="qrcode-box">
        <img
          src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/code/code.jpg"
          class="animated"
        />
      </div>
    </div>
    <!-- 打赏 -->
    <div class="dashanger">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="dialogVisibledas"
        width="354px"
        :show-close="false"
        :before-close="handleClose"
      >
        <div class="dashanghb">
          <img
            style="float: right; margin-right: 32px"
            @click="guanbidas"
            src="../assets/imgs/guanbidas.png"
            alt=""
          />
          <div class="hongbaose">
            <div style="display: flex; margin-left: 12px; margin-top: 20px">
              <div v-for="(item, index) in dashangclass" :key="index">
                <div
                  class="dashangyuan"
                  @click="leftChange(index, item.jinqian)"
                  :class="{ liBackground: changeLeftBackground == index }"
                >
                  <span class="qianys">{{ item.jinqian }}元</span>
                </div>
              </div>
            </div>
            <div style="margin-top: 10px; margin-left: 20px">
              <input
                class="dashang_input"
                v-model="inputjine"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, ''),inputjine = Number(inputjine) >= 999999.99 ? 999999.99 : inputjine"
                placeholder="输入其他金额"
              />
            </div>
            <div class="fuwusheng" @click="dialogVisiblefuwu = true">
              服务声明>>
            </div>
          </div>
          <img
            style="margin-left: 88px; margin-top: 10px"
            @click="lijidashang()"
            src="../assets/imgs/lijidashang.png"
            alt=""
          />
          <!-- <el-button style="margin-left: 110px;margin-top: 10px;" @click="lijidashang()" type="primary">立即打赏</el-button> -->
        </div>
      </el-dialog>
    </div>
    <el-dialog
      :close-on-press-escape="false"
      title="选择支付方式"
      :visible.sync="dialogzhifu"
      width="476px"
      :before-close="handleClose"
    >
      <div>
        <div>
          打赏金额<span style="color: #ff0b0b; margin-left: 20px"
            >¥ {{ inputjine }}</span
          >
        </div>
        <div style="display: flex; margin-top: 31px">
          <div style="margin-top: 14px">支付方式</div>
          <div
            class="weixinlist"
            style="margin-left: 20px"
            v-for="(item, index) in state"
            :key="index"
          >
            <div
              @click="leftChange1(index)"
              :class="{ liBackgroundyi: changeLeftBackgroundyi == index }"
            >
              <img
                v-if="item == '微信支付'"
                style="float: left; margin-left: 34px; margin-top: 7px"
                src="../assets/imgs/dsweixin.png"
                alt=""
              />
              <img
                v-if="item == '支付宝支付'"
                style="float: left; margin-left: 34px; margin-top: 7px"
                src="../assets/imgs/dszhifubao.png"
                alt=""
              />
              <span style="float: left; margin-left: 10px">{{ item }}</span>
            </div>
          </div>
          <!-- <div class="weixinlist" style="margin-left: 16px;">支付宝支付</div> -->
        </div>
        <div>
          <img
            v-if="changeLeftBackgroundyi == 0"
            style="
              position: absolute;
              margin-top: 73px;
              margin-left: 194px;
              z-index: 99;
            "
            src="../assets/imgs/weixinzhifuWX.png"
            alt=""
          />
          <img
            v-if="changeLeftBackgroundyi == 1"
            style="
              position: absolute;
              margin-top: 73px;
              margin-left: 194px;
              z-index: 99;
            "
            src="../assets/imgs/zhifubaoXZB.png"
            alt=""
          />
          <canvas
            ref="image"
            class="image"
            style="
              width: 120px;
              height: 120px;
              margin-left: auto;
              margin-right: auto;
              margin-top: 45px;
              position: relative;
            "
          />
          <!-- <div id="xiaotan1" style="
                  width: 120px;
                  height: 120px;
                  margin-left: auto;
                  margin-right: auto;
                  margin-top: 45px;
                  position: relative;
                "></div> -->
        </div>
        <div
          style="
            text-align: center;
            margin-top: 10px;
            font-size: 16px;
            color: #202020;
          "
        >
          扫描二维码支付
        </div>
      </div>
    </el-dialog>
    <div class="shengminglist">
      <el-dialog
        :close-on-press-escape="false"
        title="服务声明"
        :visible.sync="dialogVisiblefuwu"
        width="30%"
        :before-close="handleClose"
        center
      >
        <span class="smhuayu"
          >直播打赏须理性，打赏需用户自愿赠与主播的，当用户自愿支付打赏主播时，除因法定情形规定或者违反其他相关规定的情况外，支付金额不支持退款或者兑换。</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisiblefuwu = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 个人中心 -->
    <el-dialog
      :close-on-press-escape="false"
      title="我的"
      :visible.sync="gerenzhongx"
      width="600px"
      :before-close="handleClose"
      center
    >
      <div style="height: 240px">
        <div class="touyide">
          <div><img class="touxiang" :src="headeryi" alt="" /></div>
          <div>
            <p style="margin-left: 18px">{{ nickyi }}</p>
            <!-- <div class="tongbu">
                    <van-icon name="replay" style="margin-top: 8px;margin-left: 4px;" />
                    <span>同步微信信息</span>
                </div> -->
          </div>
        </div>
        <div class="xuexijilu">
          <div style="margin-left: 56px">
            <p style="margin-top: 24px">
              累计学习<span>{{ timesyi }}</span>
            </p>
            <p style="margin-top: 20px" @click="xuexijilu = true">听课记录</p>
          </div>
          <div style="margin-left: 235px; text-align: center">
            <p style="margin-top: 24px">{{ numsyi }}</p>
            <p style="margin-top: 20px" @click="yigoujilu = true">我的已购</p>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 听课记录 -->
    <el-dialog
      :close-on-press-escape="false"
      title="学习记录"
      :visible.sync="xuexijilu"
      width="700px"
      :before-close="handleClose"
      center
    >
      <div class="touyide">
        <div><img class="touxiang" :src="headeryi" alt="" /></div>
        <div>
          <p style="margin-left: 18px">{{ nickyi }}</p>
          <!-- <div class="tongbu">
                    <van-icon name="replay" style="margin-top: 8px;margin-left: 4px;" />
                    <span>同步微信信息</span>
                </div> -->
        </div>
      </div>
      <p style="margin-left: 20px; margin-top: 20px; font-size: 18px">
        已加入<span>{{ diff }}</span
        >天
      </p>
      <el-tabs
        v-model="activeNameer"
        @tab-click="handleClick"
        style="margin-top: 20px"
      >
        <el-tab-pane label="近十天数据" name="1">
          <el-table :data="tableData" style="width: 100%" height="300">
            <el-table-column prop="name" label="直播间名称" align="center">
            </el-table-column>
            <!-- <el-table-column prop="name" label="进入时间" align="center"> </el-table-column>
				<el-table-column prop="address" label="停留时间" align="center">
				<template slot-scope="scope">{{ zhuanhuan(scope.row.address) }}</template>
				</el-table-column> -->
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.row.channels)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="float: right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="10"
            :current-page="pageye"
            @current-change="shujufanye"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="十天以外数据" name="2">
          <el-table :data="tableData" style="width: 100%" height="300">
            <el-table-column prop="name" label="直播间名称" align="center">
            </el-table-column>
            <!-- <el-table-column prop="name" label="进入时间" align="center"> </el-table-column>
				<el-table-column prop="address" label="停留时间" align="center">
				<template slot-scope="scope">{{ zhuanhuan(scope.row.address) }}</template>
				</el-table-column> -->
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.row.channels)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="float: right"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="10"
            :current-page="pageye"
            @current-change="shujufanye"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog
      :close-on-press-escape="false"
      title="详情"
      :visible.sync="dialogTableVisible"
    >
      <el-table :data="gridData" height="300">
        <el-table-column
          property="create_time"
          label="进入时间"
          align="center"
        ></el-table-column>
        <el-table-column property="second_time" label="停留时间" align="center">
          <template slot-scope="scope">{{
            zhuanhuan(scope.row.second_time)
          }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 购买记录 -->
    <el-dialog
      :close-on-press-escape="false"
      title="我的已购"
      :visible.sync="yigoujilu"
      width="700px"
      :before-close="handleClose"
      center
    >
      <p style="margin-left: 20px; margin-top: 20px; font-size: 18px">
        购买记录
      </p>
      <el-table :data="tableDatalist" style="width: 100%" height="300">
        <el-table-column prop="goods_name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="price" label="商品售价" align="center">
        </el-table-column>
        <el-table-column prop="pay_time" label="下单时间" align="center">
        </el-table-column>
        <el-table-column prop="order_no" label="订单号" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 查看资质弹框 -->
    <el-dialog
      :close-on-press-escape="false"
      title="公司信息"
      :visible.sync="dialogVisiblelist"
      width="600px"
      :before-close="handleClose"
      center
    >
      <div style="height: 200px">
        <div>
          <p class="qiyemc">企业名称</p>
          <p class="gongming">{{ org_name }}</p>
        </div>
        <div style="clear: both"></div>
        <div style="margin-top: 40px">
          <p style="margin-top: 35px" class="qiyemc">营业执照</p>
          <p class="gongming" style="margin-top: 35px">点图放大</p>
          <div class="demo-image__preview gongming">
            <img
              @click="tupianchakan = true"
              style="width: 100px; height: 100px"
              :src="business_img"
              alt=""
            />
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 展示营业执照 -->
    <el-dialog
      :close-on-press-escape="false"
      :visible.sync="tupianchakan"
      width="800px"
    >
      <div style="text-align: center">
        <img width="700px" :src="business_img" alt="" />
      </div>
    </el-dialog>
    <!-- 资质验证弹框 -->
    <el-dialog
      :close-on-press-escape="false"
      title="安全验证"
      :visible.sync="zizhiguankantan"
      :before-close="handleClose"
      width="500px"
      center
    >
      <div class="yanzhengma">
        <div class="yanzhengmade">
          <input
            class="shuruyanz"
            type="text"
            v-model="inputCode"
            placeholder="请输入下图验证码，不区分大小写"
          />
          <div style="margin-top: 10px; display: flex">
            <!--验证码组件-->
            <div style="margin-left: 115px">
              <VerifyStyle :identifyCode="identifyCode"></VerifyStyle>
            </div>
            <div>
              <i
                class="el-icon-refresh-left"
                @click="refreshCode()"
                style="font-size: 24px; margin-left: 15px; margin-top: 17px"
              ></i>
            </div>
          </div>
          <button class="tijiaoanniu" type="primary" @click="getSubmitData()">
            提交
          </button>
        </div>
      </div>
    </el-dialog>
    <!-- 登录弹框 -->
    <el-dialog
      :close-on-press-escape="false"
      title
      :visible.sync="qrcodeShow"
      :show-close="false"
      :close-on-click-modal="false"
      width="300px"
      center
      style="text-align: center"
    >
      <div style="text-align: center">
        <span style="color: #008cf8; font-size: 19px">欢迎登录</span>
        <div style="display: flex; margin-top: 20px">
          <div
            style="flex: 1; padding: 10px; cursor: default"
            :class="{ loginAction: isWeixinLogin }"
            @click="isWeixinLogin = true"
          >
            微信扫描登录
          </div>
          <div
            style="flex: 1; padding: 10px; margin-left: 20px; cursor: default"
            :class="{ loginAction: !isWeixinLogin }"
            @click="isWeixinLogin = false"
          >
            QQ扫描登录
          </div>
        </div>
        <div
          style="margin-top: 26px; padding-bottom: 61px"
          v-show="isWeixinLogin"
        >
          <!-- <img
            style="width: 120px;"
            src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/code/code.jpg"
          />-->
          <div
            id="qrcode01"
            style="
              width: 120px;
              height: 120px;
              margin-left: auto;
              margin-right: auto;
              position: relative;
            "
          ></div>
          <div style="margin-top: 14px">打开微信扫一扫，立即登录</div>
        </div>

        <div
          style="margin-top: 26px; padding-bottom: 61px"
          v-show="!isWeixinLogin"
        >
          <!-- <img
            style="width: 120px;"
            src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/code/code.jpg"
          />-->
          <div
            id="qrcode02"
            style="
              width: 120px;
              height: 120px;
              margin-left: auto;
              margin-right: auto;
              position: relative;
            "
          ></div>
          <div style="margin-top: 14px">打开QQ扫一扫，立即登录</div>
        </div>

        <!-- <div style="margin-top: 26px; padding-bottom: 41px" v-else>
          <div style="display: flex; align-items: center">
            <div style="width: 50px">账号</div>
            <div
              style="flex: 1; padding: 10px 0; border-bottom: 1px solid #dadada"
            >
              <input
                placeholder="请输入微信账号"
                style="border: none; width: 100%"
              />
            </div>
          </div>

          <div style="display: flex; align-items: center; margin-top: 20px">
            <div style="width: 50px">密码</div>
            <div
              style="flex: 1; padding: 10px 0; border-bottom: 1px solid #dadada"
            >
              <input
                placeholder="请输入微信密码"
                style="border: none; width: 100%"
              />
            </div>
          </div>
          <div class="loginbtn">登录</div>
        </div> -->
      </div>
    </el-dialog>

    <!-- 密码观看 isWeixinLogin-->
    <el-dialog
      :close-on-press-escape="false"
      title
      :visible.sync="mimaDialogVisible"
      custom-class="customClassDialog"
      :close-on-click-modal="false"
      :show-close="false"
      width="441px"
      center
      style="text-align: center"
    >
      <div style="text-align: center">
        <span style="color: #333333; font-size: 30px">密码观看</span>
        <div style="margin-top: 15px; font-size: 15px">
          {{ view_auth_text }}
        </div>
        <div style="margin-top: 26px; padding-bottom: 41px">
          <div style="display: flex; align-items: center">
            <div class="watchbox">
              <input
                placeholder="请输入直播间密码"
                v-model="view_auth_pasword"
                style="border: none; width: 100%; font-size: 20px"
              />
            </div>
          </div>
          <div class="enterWatchBtn" @click="mimaWatchTap">进入观看</div>
        </div>
      </div>
    </el-dialog>

    <!-- 白名单观看 -->
    <el-dialog
      :close-on-press-escape="false"
      title
      :visible.sync="TelTestShow"
      custom-class="customClassDialog"
      :show-close="false"
      :close-on-click-modal="false"
      width="441px"
      center
      style="text-align: center"
    >
      <div style="text-align: center">
        <span style="color: #333333; font-size: 30px">白名单观看</span>

        <div style="margin-top: 26px; padding-bottom: 41px">
          <div style="display: flex; align-items: center">
            <div class="watchbox">
              <input
                v-model="phone"
                placeholder="请输入手机号"
                style="border: none; width: 100%; font-size: 20px"
              />
            </div>
          </div>
          <div
            v-if="need_check_bool"
            style="display: flex; align-items: center; margin-top: 20px"
          >
            <div class="watchbox">
              <input
                v-model="smscode"
                placeholder="请输入验证码"
                style="border: none; width: 100%; font-size: 20px"
              />
            </div>
            <el-button
              type="primary"
              v-if="phone_text == '获取验证码'"
              style="
                margin-left: 10px;
                height: 50px;
                line-height: 50px;
                padding: 0;
                width: 99px;
              "
              @click="sendSMS(phone, 2)"
            >
              {{ phone_text }}</el-button
            >
            <el-button
              type="primary"
              v-else
              style="
                margin-left: 10px;
                height: 50px;
                line-height: 50px;
                padding: 0;
                width: 99px;
              "
            >
              {{ phone_text }}</el-button
            >
          </div>

          <div class="enterWatchBtn" @click="watchWiteCommit">进入观看</div>
        </div>
      </div>
    </el-dialog>

    <!-- 账号密码观看 -->
    <el-dialog
      :close-on-press-escape="false"
      title
      custom-class="customClassDialog"
      :visible.sync="accountwhiteShow"
      :show-close="false"
      :close-on-click-modal="false"
      width="441px"
      center
      style="text-align: center"
    >
      <div style="text-align: center">
        <span style="color: #333333; font-size: 30px">账号密码观看</span>

        <div style="margin-top: 26px; padding-bottom: 41px">
          <div style="display: flex; align-items: center">
            <div class="watchbox">
              <input
                v-model="account_white_name"
                placeholder="请输入账号"
                style="border: none; width: 100%; font-size: 20px"
              />
            </div>
          </div>
          <div style="display: flex; align-items: center; margin-top: 20px">
            <div class="watchbox">
              <input
                v-model="account_white_password"
                placeholder="请输入密码"
                style="border: none; width: 100%; font-size: 20px"
              />
            </div>
          </div>

          <div class="enterWatchBtn" @click="watchAccountWiteCommit">
            进入观看
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 无权限观看提示 -->
    <el-dialog
      :close-on-press-escape="false"
      title="提示"
      :visible.sync="isBlack"
      :show-close="false"
      :close-on-click-modal="false"
      width="300px"
      center
      style="text-align: center"
    >
      <div style="text-align: center; padding-bottom: 50px; padding-top: 30px">
        你无权观看此直播间，请联系管理员!
        <template v-if="fans_id">学员ID:{{ fans_id }}</template>
      </div>
    </el-dialog>

    <!-- 无权限观看提示 -->
    <el-dialog
      :close-on-press-escape="false"
      title="提示"
      :visible.sync="isyxinImLoginOut"
      :show-close="false"
      :close-on-click-modal="false"
      width="300px"
      center
      style="text-align: center"
    >
      <div style="text-align: center; padding-bottom: 50px; padding-top: 30px">
        你在其他端登陆，刷新后可以重新登陆!
      </div>
    </el-dialog>
    <!-- 观看二维码 -->
    <div class="weixingz">
      <el-dialog
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="isShowFouceQrCode"
        :close-on-click-modal="false"
        width="432px"
        center
        style="text-align: center"
      >
        <img
          class="weixingb"
          @click="isShowFouceQrCode = false"
          src="https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/%E5%85%B3%E9%97%AD%402x.png"
          alt=""
        />
        <div style="text-align: center; padding-bottom: 46px">
          <p class="weixinhd">{{ weixintopText }}</p>
          <img style="width: 240px; height: 240px" :src="weixincodeUrl" />
          <p style="padding-top: 20px" class="weixinbott">
            -{{ weixinbottomText }}-
          </p>
        </div>
      </el-dialog>
    </div>

    <!-- 显示老师二维码 -->
    <div class="teacher_ewm">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="isShowTeacherQrCode"
        :close-on-click-modal="false"
        :show-close="false"
        class="erweima"
      >
        <div v-if="teacher_qrcode_url" class="parent_bgc">
          <div style="display: flex; justify-content: center">
            <img
              src="../assets/imgs/公告.png"
              alt=""
              style="width: 164px; height: 46px; margin-top: -4px"
            />
          </div>
          <div ref="add_text_contect" class="text_contect">
            {{ teacher_qrcode_title }}
          </div>
          <div style="text-align: center; margin-top: 20px">
            <img
              :src="teacher_qrcode_url"
              style="width: 200px; height: 200px; border-radius: 12px"
            />
          </div>
          <div class="notice_close" @click="isShowTeacherQrCode = false">
            <span style="color: #ffffff">我知道了</span>
          </div>
          <div style="width: 100%; height: 1px"></div>
        </div>
        <div v-else>
          <div class="parent_bgc1">
            <div style="display: flex; justify-content: center">
              <img
                src="../assets/imgs/公告.png"
                alt=""
                style="width: 164px; height: 46px; margin-top: -4px"
              />
            </div>
            <div ref="add_text_contect1" class="text_contect1">
              {{ teacher_qrcode_title }}
            </div>
            <div class="notice_close" @click="isShowTeacherQrCode = false">
              <span style="color: #ffffff">我知道了</span>
            </div>
            <div style="width: 100%; height: 1px"></div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 显示签到  isShowAttend -->
    <div v-if="Attend_status == 1" class="Attend_Box">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="isShowAttend"
        :show-close="false"
        :close-on-click-modal="false"
        style="text-align: center"
      >
        <div class="Attend_Box_conect">
          <svg width="140" height="140" viewbox="0 0 140 140">
            <circle
              cx="70"
              cy="70"
              r="50"
              stroke-width="10"
              stroke="#1872ED"
              fill="none"
            ></circle>
            <circle
              cx="70"
              cy="70"
              r="50"
              stroke-width="10"
              stroke="#CEE1FF"
              fill="none"
              transform="matrix(0,-1,1,0,0,140)"
              stroke-dasharray="0 1069"
            ></circle>
          </svg>
          <div
            class=""
            style="font-size: 16px; color: #202020; margin-bottom: 15px"
          >
            {{ Attend_title }}
          </div>
          <div class="show_time">{{ limitCountDownTimeStr }}</div>
          <div style="padding-bottom: 41px">
            <div
              style="
                margin-top: 10px;
                line-height: 40px;
                background: rgba(0, 140, 248, 1);
                border-radius: 30px;
                font-size: 14px;
                color: white;
                cursor: pointer;
                text-align: center;
              "
              @click="onAttend"
            >
              {{ Attend_Btn }}
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="Attend_Box_finsh">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="isShowAttend_finsh"
        :show-close="false"
        :close-on-click-modal="false"
        style="text-align: center"
      >
        <div class="Attend_Box_conect">
          <div class="Attend_Box_text">恭喜您，签到成功</div>
          <div class="Attend_Box_btn" @click="isShowAttend_finsh = false">
            我知道了
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 登记观看 -->
    <el-dialog
      :close-on-press-escape="false"
      title="登记信息"
      :visible.sync="registerViewShow"
      :show-close="false"
      :close-on-click-modal="false"
      width="500px"
      center
      style="text-align: center"
    >
      <div style="text-align: left">
        <span style="color: #008cf8; font-size: 19px; line-height: 22px"
          >为了保障课程知识产权，需登记学员信息核实后即可观看</span
        >
        <div style="margin-top: 26px; padding-bottom: 41px">
          <div v-for="(item, index) in registerList" :key="index">
            <template v-if="item.type == 1">
              <div
                style="
                  display: flex;
                  align-items: center;
                  flex: 1;
                  padding: 15px 0;
                  border-bottom: 1px solid #dadada;
                "
              >
                <span class="content-box_span">
                  <span
                    class="content-box_title"
                    v-if="item.is_field == 'yes'"
                    style="color: red"
                    >* </span
                  >{{ item.name_title }}</span
                >
                <input
                  :value="item.value"
                  type="number"
                  @input="item.value = $event.target.value"
                  placeholder="请输入手机号"
                  style="border: none; flex: 1; width: 100%; margin-left: 10px"
                />
              </div>
              <div
                v-if="item.is_phone_check == 'yes'"
                style="
                  display: flex;
                  align-items: center;
                  margin-top: 10px;
                  flex: 1;
                  padding: 15px 0;
                  border-bottom: 1px solid #dadada;
                "
              >
                <span class="content-box_span content-box_title">
                  <span v-if="item.is_field == 'yes'" style="color: red"
                    >*
                  </span>
                  验证码</span
                >
                <input
                  v-bind:value="item.code"
                  v-on:input="item.code = $event.target.value"
                  placeholder="请输入验证码"
                  type="number"
                  style="border: none; width: 100%; flex: 1; margin-left: 10px"
                />

                <el-button
                  v-if="phone_text == '获取验证码'"
                  style="margin-left: 10px"
                  @click="sendSMS(item.value, 1)"
                >
                  {{ phone_text }}</el-button
                >
                <el-button v-else style="margin-left: 10px">
                  {{ phone_text }}</el-button
                >
              </div>
            </template>
            <div
              v-if="item.type == 2"
              style="
                display: flex;
                align-items: center;
                flex: 1;
                padding: 15px 0;
                border-bottom: 1px solid #dadada;
              "
            >
              <span class="content-box_span">
                <span
                  class="content-box_title"
                  v-if="item.is_field == 'yes'"
                  style="color: red"
                  >* </span
                >{{ item.name_title }}</span
              >
              <input
                v-bind:value="item.value"
                v-on:input="item.value = $event.target.value"
                placeholder="请输入内容"
                style="border: none; width: 100%; flex: 1; margin-left: 10px"
              />
            </div>

            <div
              v-if="item.type == 3"
              style="
                display: flex;
                align-items: center;
                flex: 1;
                padding: 15px 0;
                border-bottom: 1px solid #dadada;
              "
            >
              <span class="content-box_span">
                <span
                  class="content-box_title"
                  v-if="item.is_field == 'yes'"
                  style="color: red"
                  >* </span
                >{{ item.name_title }}</span
              >
              <input
                v-bind:value="item.value"
                v-on:input="item.value = $event.target.value"
                placeholder="请输入内容"
                style="border: none; width: 100%; flex: 1; margin-left: 10px"
              />
            </div>
          </div>
          <div class="loginbtn" @click="registerCommit">进入观看</div>
        </div>
      </div>
    </el-dialog>

    <!-- 网校学员登录观看 -->
    <el-dialog
      :close-on-press-escape="false"
      title
      :visible.sync="showLineSchoolPopUp"
      :show-close="false"
      :close-on-click-modal="false"
      width="300px"
      center
      style="text-align: center"
    >
      <div style="text-align: center">
        <span style="color: #008cf8; font-size: 19px">网校账号登录</span>
        <div class="desc" style="margin-top: 10px">
          此课程为VIP课程，需要登录后观看
        </div>
        <div style="margin-top: 6px; padding-bottom: 41px">
          <div style="display: flex; margin-top: 20px; padding-bottom: 11px">
            <div
              style="flex: 1; padding: 10px; cursor: default"
              :class="{ loginAction: schoolLoginType == 1 }"
              @click="schoolLoginType = 1"
            >
              账号密码登录
            </div>
            <div
              style="flex: 1; padding: 10px; margin-left: 20px; cursor: default"
              :class="{ loginAction: schoolLoginType == 2 }"
              @click="schoolLoginType = 2"
            >
              验证码登录
            </div>
          </div>
          <div style="display: flex; align-items: center">
            <div
              style="flex: 1; padding: 10px 0; border-bottom: 1px solid #dadada"
            >
              <input
                v-model="onlineSchoolAccount"
                placeholder="请输入手机号"
                style="border: none; width: 100%"
              />
            </div>
          </div>

          <div
            v-if="schoolLoginType == 1"
            style="display: flex; align-items: center"
          >
            <div
              style="
                flex: 1;
                padding: 10px 0;
                border-bottom: 1px solid #dadada;
                margin-top: 10px;
              "
            >
              <input
                v-model="onlineSchoolPassword"
                placeholder="请输入密码"
                type="password"
                style="border: none; width: 100%"
              />
            </div>
          </div>

          <div
            v-if="schoolLoginType == 2"
            style="display: flex; align-items: center; margin-top: 10px"
          >
            <div
              style="flex: 1; padding: 10px 0; border-bottom: 1px solid #dadada"
            >
              <input
                v-model="onlineSchoolSMSCode"
                placeholder="请输入验证码"
                style="border: none; width: 100%"
              />
            </div>
            <el-button
              v-if="onlineSednMsgText == '获取验证码'"
              style="margin-left: 10px"
              @click="onlineLineSchoolSendMsg"
            >
              {{ onlineSednMsgText }}</el-button
            >
            <el-button v-else style="margin-left: 10px">
              {{ onlineSednMsgText }}</el-button
            >
          </div>

          <div
            class="loginbtn"
            v-if="schoolLoginType == 1"
            @click="onlineSchoolLoginClick"
          >
            进入观看
          </div>
          <div class="loginbtn" v-else @click="onlineSchoolSMSLoginClick">
            进入观看
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 连麦 -->
    <el-dialog
      :close-on-press-escape="false"
      :visible.sync="lianmaiDialogVisible"
      width="350px"
      center
      style="text-align: center"
    >
      <div style="text-align: center">
        <img
          src="../assets/imgs/topimage.png"
          style="width: 100%; position: absolute; top: 0; left: 0"
        />
        <img
          style="
            margin-top: 20px;
            width: 134px;
            height: 134px;
            position: relative;
            z-index: 0;
          "
          src="../assets/imgs/voyice.png"
          v-if="isApplaying"
        />
        <img
          style="
            margin-top: 20px;
            width: 134px;
            height: 134px;
            position: relative;
            z-index: 0;
          "
          src="../assets/imgs/zhengqu.png"
          v-else-if="isLianmaiSucee"
        />
        <img
          style="
            margin-top: 20px;
            width: 134px;
            height: 134px;
            position: relative;
            z-index: 0;
          "
          src="../assets/imgs/error.png"
          v-else
        />
        <div style="padding-bottom: 41px">
          <div
            style="text-align: center; padding-bottom: 20px"
            v-if="isApplaying"
          >
            <div
              class="dotDiv"
              style="
                background-color: #12c8ff;
                animation: myfirst1 0.5s infinite;
              "
            ></div>
            <div
              class="dotDiv"
              style="
                background-color: #68ddff;
                margin-left: 10px;
                animation: myfirst2 0.5s infinite;
              "
            ></div>
            <div
              class="dotDiv"
              style="
                background-color: #a0e9ff;
                margin-left: 10px;
                animation: myfirst3 0.5s infinite;
              "
            ></div>
          </div>
          <div v-if="linkType == 1" style="color: #333333; font-size: 18px">
            是否申请与老师连麦…
          </div>
          <div v-if="linkType == 2" style="color: #333333; font-size: 18px">
            连麦成功
          </div>
          <div v-if="linkType == 3" style="color: #333333; font-size: 18px">
            正在连麦中，是否下麦？
          </div>
          <div v-if="linkType == 1" style="display: flex">
            <div @click="refuseLink" class="loginbtn bgg1" style="flex: 1">
              取消申请
            </div>
            <div
              @click="applayLink"
              class="loginbtn bgg2"
              style="flex: 1; margin-left: 10px"
            >
              确认申请
            </div>
          </div>
          <div v-if="linkType == 3" style="display: flex">
            <div @click="refuseLink" class="loginbtn bgg1" style="flex: 1">
              取消
            </div>
            <div
              @click="applayLink"
              class="loginbtn bgg2"
              style="flex: 1; margin-left: 10px"
            >
              确认下麦
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-press-escape="false"
      title
      :visible.sync="lianmai2DialogVisible"
      width="330px"
      center
      :close-on-click-modal="false"
      :show-close="false"
      style="text-align: center"
    >
      <div style="text-align: center">
        <div style="padding-bottom: 41px">
          <div
            style="display: flex; align-items: center; justify-content: center"
          >
            <img
              src="../assets/imgs/laoshitu.png"
              style="width: 62px; height: 62px; border-radius: 31px"
            />
            <div style="text-align: center; padding: 0 20px">
              <div
                class="dotDiv"
                style="
                  background-color: #12c8ff;
                  animation: myfirst1 0.5s infinite;
                "
              ></div>
              <div
                class="dotDiv"
                style="
                  background-color: #68ddff;
                  margin-left: 10px;
                  animation: myfirst2 0.5s infinite;
                "
              ></div>
              <div
                class="dotDiv"
                style="
                  background-color: #a0e9ff;
                  margin-left: 10px;
                  animation: myfirst3 0.5s infinite;
                "
              ></div>
            </div>
            <img
              src="../assets/imgs/voyice.png"
              style="width: 72px; height: 72px; border-radius: 36px"
            />
          </div>
          <div style="color: #333333; font-size: 15px; margin-top: 40px">
            <span style="color: #07a1ff">老师</span>邀请你连麦…
          </div>
          <div style="display: flex; justify-content: center; margin-top: 40px">
            <img
              src="../assets/imgs/guaduan.png"
              @click="refuseLink()"
              style="height: 34px"
            />
            <img
              src="../assets/imgs/liantong.png"
              @click="applayLink()"
              style="margin-left: 40px; height: 34px"
            />
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-press-escape="false"
      title
      :visible.sync="weixinLoginVisible"
      width="300px"
      center
      :close-on-click-modal="false"
      :show-close="false"
      style="text-align: center"
    >
      <div style="text-align: center">
        <span style="color: #008cf8; font-size: 19px">微信登录授权</span>
        <div style="margin-top: 26px; padding-bottom: 41px">
          <div class="loginbtn" @click="wxLoginTap">登录</div>
          <el-button
            @click="wxLogoutTap"
            style="margin-top: 10px; color: #dee1e6"
            type="text"
            >退出</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-press-escape="false"
      :visible.sync="goodsQrCodeVisiable"
      class="payment"
      width="30%"
    >
      <el-tabs v-model="activeName" stretch>
        <el-tab-pane
          label="微信"
          name="first"
          v-if="platfrom == 'wx' || !platfrom"
        >
          <div style="display: flex; justify-content: center">
            <vue-qr
              :logoSrc="qrImgUrl"
              :text="previewLink"
              :size="200"
              :logoScale="0.2"
            ></vue-qr>
          </div>
          <div
            class="preview-link"
            style="text-align: center; margin-top: 14px"
          >
            预览链接：{{ previewLink }}
          </div>
          <div style="margin-top: 14px; text-align: center">
            请使用微信扫描上方二维码进行预览
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="支付宝"
          name="second"
          v-if="platfrom == 'ali' || !platfrom"
        >
          <div style="display: flex; justify-content: center">
            <vue-qr
              :logoSrc="qrAliImgUrl"
              :text="aliPreviewLink"
              :logoScale="0.2"
              :size="200"
            ></vue-qr>
          </div>
          <div style="margin-top: 14px; text-align: center">
            请使用支付宝扫描上方二维码进行预览
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 短信通知服务 -->
    <messageServerDialog
      ref="messageServerDialog"
      :dialog-visible="isAppointmentDialog"
      :uid="uid"
      :dsId="ds_id"
      :fansId="fans_id"
      :channelId="channel_id"
      :appointmentData="appointmentData"
      @close="messageClose"
    />
    <el-dialog
      :visible.sync="isCancelfans"
      width="360px"
      class="custom-confirm"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div class="custom-confirm-header">
          <img src="@/assets/imgs/message.png" alt="Your Image" />
          <span>提示</span>
        </div>
      </template>
      <div class="custom-confirm-content">
        确定取消预约吗，取消后将无法收到上课通知
      </div>
      <template slot="footer">
        <div class="submitBox">
          <p @click="cancelfansBtn('fail')" class="cancels">取&nbsp;消</p>
          <p class="submit" @click="cancelfansBtn('success')">确&nbsp;定</p>
        </div>
      </template>
    </el-dialog>
    <!-- 公众号服务 -->
    <div class="Public_tk">
      <el-dialog
        title="关注后可收到直播最新动态哦"
        :visible.sync="PublicHao"
        width="300px"
        center
        :show-close="false"
      >
        <div class="Public_hz">
          <div class="Public_ewm" id="qrCode_gzh"></div>
          <p class="Public_gz">-打开微信扫一扫关注公众号-</p>
          <div class="Public_gk"></div>
          <p class="Public_gb" @click="gzhClose">关闭</p>
        </div>
      </el-dialog>
    </div>
    <!-- 不允许PC端观看 -->
    <div class="pc_no_watch_dialog" v-if="isShowOpenClassNoWatchDialog">
      <div class="pc_no_watch_dialog_content">
        <!-- <img
            style="width: 120px;"
            src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/code/code.jpg"
          />-->
        <vue-qr :text="h5_watch_url" :size="300" :logoScale="0.2"></vue-qr>
        <div class="pc_no_watch_dialog_text">使用微信扫一扫</div>
      </div>
    </div>
    <footWrapper></footWrapper>
    <div
      v-if="
        !isRTCSupport &&
        initAllData &&
        initAllData.direct_seeding.play_style == 3 &&
        isShowBottomTips
      "
      class="bottomTips"
    >
      <p>
        微信内置浏览器<strong style="font-size: 16px; font-weight: bold"
          >不支持连麦</strong
        >，请复制链接到电脑浏览器播放连麦
        <span @click="isShowBottomTips = false">X</span>
      </p>
    </div>
    <liveanser
      v-if="isShowLiveAnser"
      :uid="uid"
      :LiveanserObj="LiveanserObj"
      :ds_id="ds_id"
      :channel_code="channel_id"
      :fans_id="fans_id"
      @hideliveAnser="hideliveAnser"
    ></liveanser>
    <!-- 个人中心 -->
    <div>
      <PersonalCenter
        ref="mychild"
        v-if="initAllData"
        :uid="uid"
        :ds_id="ds_id"
        :appid="initAllData.direct_seeding.appid"
        :fans_id="fans_id"
        :channel_id="channel_id"
        @xianShiewmt="xianShiewmt"
        @showGoodsQrCode="showGoodsQrCode"
      ></PersonalCenter>
    </div>
    <div class="tbtanzhuang">
      <el-dialog
        :visible.sync="xianshiersx"
        width="280px"
        class="custom-confirm"
        :close-on-click-modal="false"
        :lock-scroll="false"
      >
        <div class="Public_ewm" style="padding-top: 46px" id="dengluewm"></div>
        <div class="systbtx">扫一扫登录同步微信头像昵称</div>
        <p class="guanbitbewm" @click="xianshiersx = false">关闭</p>
      </el-dialog>
    </div>
    <!-- 单场观看弹框 -->
    <LimitWatchDialog ref="limitWatchDialogRef" />
    <!-- 在线人数达到上限弹框 -->
    <LimitOnlineUserDialog ref="limitOnlineUserDialogRef" />
    <!-- 锁客弹框 -->
    <UserLockChannelDialog ref="userLockChannelDialogRef" />
    <!-- 游客登录 -->
    <!-- 游客登录 -->
    <VisitorLogin
      v-if="visitorLoginShow"
      :dsInfo="initAllData"
      @login="visitloginTap"
    ></VisitorLogin>
  </div>
</template>

<script>
/* eslint-disable */
import md5 from "blueimp-md5";
import vxxData from "@/kits/data.js";
import FakeIm from "@/kits/im/FakeIm.js";
import tool, { payOpenClassHost } from "@/kits/Tools.js";
import headWrapper from "./head.vue";
import footWrapper from "./foot.vue";
import ConsultTeacher from "./ConsultTeacher/index.vue";
import Emotion from "./Emotion/biaoqingindex.vue";
import bigImg from "./BigImg.vue";
import TFPlayer from "tfplayer";
import qs from "qs";
import goodsList from "./goodsList";
import VueQr from "vue-qr";
import VerifyStyle from "./VerifyStyle.vue";
import ShoppingCart from "./ShoppingCart";
import liveanser from "./liveanser.vue";
import COS from "cos-js-sdk-v5";
import handleim from "@/kits/im/handleim.js";
import QRCode1 from "qrcode";
import hlsvideo from "./hlsvideo.vue";
import messageServerDialog from "./messageServerDialog.vue";
import PersonalCenter from "./PersonalCenter.vue";
import couponsList from "./couponsComponents/couponsList.vue";
import recommend from "./couponsComponents/recommend.vue";
import NotAchieveCoupon from "./couponsComponents/notAchieveCoupon.vue";
import couponsProduct from "./couponsComponents/couponsProduct.vue";
import LimitWatchDialog from "./limitWatchDialog.vue";
import LimitOnlineUserDialog from "./limitOnlineUserDialog.vue";
import UserLockChannelDialog from './userLockChannelDialog.vue'
import { useOrgConfig } from '../utils/useOrgConfig.js'
import VisitorLogin from "./VisitorLogin.vue";

export default {
  directives: {
    focus: {
      update: function (el, { value }) {
        if (value) {
          el.focus();
        }
      },
    },
  },
  data() {
    return {
      lookingTime: 0, // 误差
      setLookTime: null,
      noCouponVisible: false,
      isClassEnter: false,
      hideNickFlag: false,
      classid: "",
      isThird: true,
      total_like: 0,
      isplay: true,
      visible: false,
      flag: -1,
      status: "",
      comment: "",
      focusState: false,
      ds_id: "",
      hostId: -1,
      comment_id: 0,
      videoUrl: "",
      initData: null,
      initAllData: null,
      comlist: [],
      direct: {
        direct_seeding: {},
      },
      coverpic: "http://pres.shikee.tv/uploads/2018/02/07/1517993219335762.jpg",
      start: true,
      allow: true,
      playback: "",
      view_num: "",
      login: false,
      before_ad: null,
      qrcodeShow: false,
      wxqrcode: false,
      isShowQuickPanel: false,
      isReply: false,
      occupyImg: "",
      videoList: [],
      placeholder: "请输入您要评论的内容",
      phoneQrcode: false,
      fans_id: "",
      data_id: null,
      timer: "",
      userLogin: {},
      zhibo: false,
      starttime: "2018-09-13 20:00:00",
      time: "",
      videoshow: true,
      advanceInfo: {
        nick: "ACC",
        fans_id: 30991,
        header: "",
        tsl_sig: "",
      },
      uid: "",
      videoplay: false,
      page: 100,
      moreshow: true,
      uploader: "",
      accessid: "",
      accesskey: "",
      host: "",
      policyBase64: "",
      signature: "",
      callbackbody: "",
      key: "uploads/comment/",
      expire: 0,
      g_object_name: "live",
      suffix: "",
      g_object_name_type: "local_name",
      now: Date.parse(new Date()) / 1000,
      timestamp: Date.parse(new Date()) / 1000,
      imgcommentshow: true,
      piccomment: false,
      player: "",
      showvideo: true,
      fileID: "5285890782777475609",
      watch_time: "",
      tcplayer: "",
      currentTime: "",
      tctimer: 0,
      watch_key: true,
      isNotShowWebRTC: true,
      rtcClient: null,
      rtcRemoteStream: null,
      tabActive: 0,
      centerDialogVisible: false,
      isWeixinLogin: true,
      mimaDialogVisible: false,
      lianmaiDialogVisible: false,
      isApplaying: true,
      isLianmaiSucee: false,
      lianmai2DialogVisible: false,
      qrcodeObj: null,
      qrcodema: null,
      qqqrcodema: null,
      loginTimer: null,
      linkType: 1,
      playerStatus: 1,
      imgText: "",
      returnCitySN: null,
      isRTCSupport: true,
      isShowBottomTips: true,
      imIsLogin: false,
      sendMsgTimer: null,
      scrolltimer: null,
      scrollTop: 0,
      showNewMsgTip: false,
      showPersonNum: false,
      tid: 0,
      fromuser: 0,
      commentTab: 1,
      unReadNum: 0,
      unReadMsgData: null,
      showUnReadView: false,
      verify_comment: false,
      channel_id: "",
      TelTestShow: false,
      phone_text: "获取验证码",
      phone: "",
      smscode: "",
      isOpenWatchWhite: false,
      isBlack: false,
      userConfigData: null,
      showTeacherTab: false,
      isShowFouceQrCode: false,
      isShowFocusQrBtn: false,
      weixincodeUrl:
        "https://tengfaceliveuser.tengface.net/web/wx-user/img/tengface.jpg",
      weixintopText: "关注后可收到直播最新动态哦",
      weixinbottomText: "长按关注公众号接收最新动态",
      registerViewShow: false, //登记观看
      registerList: [],
      is_show_gift: false,
      is_show_nav: false,
      img_text_title: "",
      menus: [],
      playerType: "live",
      currentPlayerData: null,
      isOpenAccountwhite: false,
      account_white_name: "",
      account_white_password: "",
      accountwhiteShow: false,
      is_all_users_muted: false,
      is_first_mousewheel: false,
      first_mousewheel_scrollTop: 0,
      last_mousewheel_scrollTop: 0,
      needShowNewMsgTip: false,
      heart_time: 30,
      heartTimer: null,
      need_check_bool: true,
      isShowTeacherQrCode: false,
      showVideoQrCode: false,
      teacher_qrcode_title: "",
      teacher_qrcode_url: "",
      say_self: {
        enabled: false,
        type: "2",
        all: "2",
      },
      iSOpenRegisterViewShow: false,
      noticeObj: {
        open: false,
        content: "",
        time: 0,
      },
      runObj: {
        open: false,
        fontSize: "",
        fontColor: "",
        fontTrans: 1,
        remark: false,
      },
      copyrightObj: {
        open: false,
        inputValue: "",
        copyrightTrans: 1,
      },
      isNoitceTopShow: true,
      runHourseShow: true,
      copyrightShow: true,
      businessConfigs: {},
      liveType: "open",
      showLineSchoolPopUp: false,
      onlineSchoolAccount: "",
      onlineSchoolPassword: "",
      onlineSchoolSMSCode: "",
      onlineSednMsgText: "获取验证码",
      onlineSendMsgNum: 59,
      onlineSchoolTimer: null,
      schoolLoginType: 1, //1账号 2验证码
      weixinLoginVisible: false,
      isLocalCode: true,
      sendFllowerText: "",
      channelGroupID: "",
      channel_REL_ID: "",
      goodsList: [],
      showGoodsList: false,
      goodsQrCodeVisiable: false,
      activeName: "first",
      goodsDomain: '',
      previewLink: "",
      aliPreviewLink: "",
      is_show_cart: false,
      qrImgUrl: require("../assets/imgs/wechat.png"),
      qrAliImgUrl: require("../assets/imgs/alipay.png"),
      zizhiguankantan: false,
      dialogVisiblelist: false,
      identifyCodeType: "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ", //定义验证类型 1.数字 2.字母
      identifyCode: "",
      inputCode: "", //text框输入的验证码
      tupianchakan: false,
      headeryi: "",
      nickyi: "",
      numsyi: "",
      timesyi: "",
      business_img: "",
      org_name: "",
      gerenzhongx: false,
      xuexijilu: false,
      yigoujilu: false,
      xianshilist: "",
      tableData: [],
      dialogTableVisible: false,
      activeNameer: "1",
      gridData: [],
      tableDatalist: [],
      total: 0,
      pageye: 1,
      diff: "",
      flowers: "true",
      isShowOpenClassNoWatchDialog: false,
      h5_watch_url: "",
      view_auth_http_url: "",
      view_auth_text: "",
      view_auth_pasword: "",
      isyxinImLoginOut: false,
      HeartMode: "",
      videoheartTimer: null,
      isThreeScreen: false,
      pageUUID: tool.guid(),
      // 购物车
      showShoppingCartType: "",
      goodsInfo: {},
      goodsIdsList: [],
      isShowLiveAnser: false,
      LiveanserObj: {
        qpid: "",
        lqid: "",
      },
      cos: null,
      to_fans_idlist: [],
      to_fans_idlistc: true,
      dialogVisibledas: false,
      dashangclass: [],
      inputjine: "",
      dialogVisiblefuwu: false,
      changeLeftBackground: 0,
      daShangje: "",
      dialogzhifu: false,
      changeLeftBackgroundyi: 0, //默认选中第一个
      state: ["微信支付", "支付宝支付"],
      business_Id: "",
      cameraUrl: "",
      whiteboardUrl: "",
      enabledDs: "",
      remainingTime: 0,
      myYunXinCustom: [],
      isSwitchPosition: false,
      //签到
      isShowAttend: false,
      isShowAttend_finsh: false,
      Attend_id: "",
      Attend_title: "进行签到",
      Attend_Btn: "点击签到",
      Attend_status: 2,
      limitCountDownTimeStr: "00:00",
      limitCountDownTime: null,
      threeScreenVideofile_id: "",
      currentPlayTime: 0,
      platfrom: "",
      // 用户进入
      openWelcomeUser: false,
      saveEnterTimer: null,
      saveEnterUserList: [],
      bobbleUserList: [],
      welcomeUser: {},
      showBubbleWelcome: false,
      showBubbleWelcomeTimer: null,
      clearBobbleUserTimer: null,
      showAutoPlayModal: false,
      asyncthreeScreenTimer: null,
      miniConfigData: {},
      interaction: true,
      // 是否需要展示预约信息
      appointmentEnabled: false, // 是否打开预约功能
      isAppointment: false,
      isAppointmentCheck: false,
      isAppointmentDialog: false,
      PublicHao: false,
      isCancelfans: false,
      appointmentData: {},
      // 判断是否显示预约时间
      exTime: true, // 默认显示
      interval: null,
      timeData: {},
      xianshiersx: false,
      imgsrc: "",
      nicknc: "",
      isLiving: false,
      livingObj: {},
      isShowCoupon: false,
      showCouponList: false,
      couponsList: [],
      isRecommendVisible: false,
      couponTuijianData: {},
      showcouponsGoodList: false,
      couponsGoodList: [],
      remark: "",
      orgStatus: true,
      isOpenSingleWatch: false,
      limitOnlineUser: {},
      isRequesting: false,
      messageSendStatus: false,
      // 正在购买
      showBuyGoodsTips: false,
      showBuyGoodsTipsyi: false,
      tipsBuyTimer: null,
      tipsBuyTimeryi: null,
      tipsBuyTimsan: null,
      tipsBuyText: '',
      tipsBuyUsername: '',
      saveUserBuyList: [],
      // 购买成功
      showBuySuccessGoodsTips: false,
      showBuySuccessGoodsTipsyi: false,
      showBuySuccessGoodsTipser: false,
      tipsBuySuccessTimer: null,
      tipsBuySuccessTimeryi: null,
      tipsBuySuccessText: '',
      tipsBuySuccessUsername: '',
      saveUserBuySuccessList: [],
      ShoppingGuide: [],
      ShoppingGuideyi: {},
      ShoppingGuideas: [],
      ShoppingGuidebs: [],
      showBuyTipsState: false,
      zzgmsp: 0,
      cggmsp: 0,
      timerer: null,
      yunxinnetworkStatus: false,
      myOrgConfig: {},
      orderform: false,
      visitorLoginShow: false
    };
  },
  components: {
    headWrapper,
    footWrapper,
    Emotion,
    TFPlayer,
    ConsultTeacher,
    bigImg,
    goodsList,
    VueQr,
    VerifyStyle,
    ShoppingCart,
    liveanser,
    hlsvideo,
    messageServerDialog,
    PersonalCenter,
    couponsList,
    recommend,
    NotAchieveCoupon,
    couponsProduct,
    LimitWatchDialog,
    LimitOnlineUserDialog,
    UserLockChannelDialog,
    VisitorLogin
  },
  computed: {
    c_view_num() {
      if (this.initAllData && this.initAllData.direct_seeding.direct_status == "running") {
        return this.view_num;
      }
      return 0;
    },
    isLookingLive() {
      // 正在看直播
      if (this.initAllData) {
        return this.initAllData.direct_seeding.direct_status == "running";
      }
      return false;
    },
    zhioboTime() {
      if (this.direct.startTime > this.direct.real_start_time) {
        return this.direct.startTime;
      }
      return this.direct.real_start_time;
    },
    isShowLivePage() {
      return (
        !this.accountwhiteShow &&
        !this.TelTestShow &&
        !this.mimaDialogVisible &&
        !this.isBlack &&
        !this.showLineSchoolPopUp &&
        !this.isyxinImLoginOut &&
        !this.isShowOpenClassNoWatchDialog &&
        !this.qrcodeShow
      );
    },
    // 只有三分屏并且不是直播状态才显示video回放
    showThreeLivePlayer() {
      if (this.initAllData) {
        return (
          this.isThreeScreen &&
          this.initAllData.direct_seeding.direct_status !== "running" &&
          this.is_show_nav &&
          this.whiteboardUrl &&
          this.cameraUrl
        );
      }
      return false;
    },
    isLive() {
      var boolean = false;
      var data = this.initAllData;
      if (data && data.direct_seeding.direct_status !== "running") {
        boolean = true;
      }
      return boolean;
    },
    startTime() {
      var times = this.initAllData.direct_seeding.start_time;
      const dateParts = times.split(" ");
      const time = dateParts[1];
      // 提取月和日
      const month = dateParts[0].substring(5, 7);
      const day = dateParts[0].substring(8, 10);
      var params = {
        month,
        day,
        time,
      };
      return params;
    },
    isShowCount() {
      var timeData = this.timeData;
      if (
        timeData.seconds ||
        timeData.minutes ||
        timeData.hours ||
        timeData.days
      )
        return true;
      return false;
    },
  },
  watch: {
    showThreeLivePlayer(val) {
      if (val && tool.isTablet()) {
        this.showAutoPlayModal = true;
      }`````````````````````````
` `` ``  },
    "initAllData.direct_seeding.start_time"() {
      this.interval = setInterval(() => {
        this.timeData = this.calculateTimeRemaining(
          this.initAllData.direct_seeding.start_time
        );
      }, 1000);
    },
  },
  async created() {
    this.remark = localStorage.getItem("tengface_remark") || "";
    console.log("[<-- this.remark88888 -->]", this.remark);
  },
  async mounted() {
    var u = navigator.userAgent;
    if (u.indexOf("WindowsWechat") != -1) {
      this.isRTCSupport = false;
    }
    var that = this;
    var urlToken = getQueryString("token");
    var otherLogin = getQueryString("other");
    this.isClassEnter = Number(otherLogin) == 1;
    this.fromuser = tool.getQueryString("fromuser");
    this.ds_id = tool.getQueryString("ds_id");
    this.tid = tool.getQueryString("tid");
    this.channel_id = tool.getQueryString("channel_id");
    try {
      if (!this.ds_id && this.channel_id) {
        const data = await this.axios.post(
          tool.baseUrl2() + "/customer/channel/getDsIdByChannelId",
          "channel_code=" + this.channel_id,
          { timeout: 6000 }
        );
        if (data.data.code == 200) {
          this.ds_id = data.data.data.ds_id;
        } else {
          this.$alert(data.data.message, "", {
            showConfirmButton: false,
            showClose: false,
            type: "warning",
            center: true,
          });
          return false;
        }
      }
    } catch (error) {
      try {
        const data = await this.axios.get(
          tool.tencentOssUrl() +
            "/ds/channel_cache/channel_" +
            this.channel_id +
            ".json?" +
            new Date().getTime() +
            parseInt(Math.random() * 10e4),
          { timeout: 2000 }
        );
        if (data) {
          this.ds_id = data.data.ds_id;
        }
      } catch (e) {
        this.$alert("网络存在问题,请刷新重试", "", {
          showConfirmButton: false,
          showClose: false,
          type: "warning",
          center: true,
        });
        return false;
      }
    }

    if (!this.ds_id && !this.channel_id) {
      this.$message("获取房间号失败");
      return false;
    }
    tool.setDsId(this.ds_id);
    this.$TFWebLog.setCommonKeyValue("ds_id", this.ds_id);
    this.$TFWebLog.setCommonKeyValue("channel_id", this.channel_id);
    this.$TFWebLog.setCommonKeyValue("token", tool.getCookie("token"));

    this.h5_watch_url = `${location.origin}/${location.search}`;
    console.log("h5_watch_url====", this.h5_watch_url);

    if (urlToken && otherLogin) {
      // 如果页面中包含token 优先处理
      tool.getUserInfoByToken();
    } else {
      // 普通直播
      this.getData(async () => {
        // 校验该机构是否被禁用或者被删除，被禁用或者被删除的机构无法使用直播间任何功能
        const { orgStatus } = await this.checkOrgIsForbidden();
        this.orgStatus = orgStatus;
        if (!orgStatus) {
          return;
        }


        // this.getInfo();
        this.getUserConfig();
        !this.channel_id && this.getComment();
        this.getMiniConfig(() => {
          this.initCos();
        });
        //是否有权限
        this.getUserConfig2(async () => {
          if (
            this.liveType == "open" &&
            this.businessConfigs &&
            this.businessConfigs.open_class_pc_no_watch
          ) {
            //公开课不允许PC观看
            this.isShowOpenClassNoWatchDialog = true;
            setTimeout(() => {
              this.$message({
                message: "该课程pc端不可观看，请手机扫码观看",
                customClass: "customClass",
              });
            }, 100);

            //禁止 F12
            document.onkeydown = function () {
              if (window.event.keyCode == 123) {
                return false;
              }
            };
            //网站禁止右键
            document.body.oncontextmenu = function () {
              return false;
            };
            return;
          }
          console.log("[<-- this.businessConfigs -->]", this.businessConfigs);

          // const { data: { code, data: levelRes } } = await this.axios.post(`${tool.baseUrl2()}/customer/index/getBindOrgLevel`, qs.stringify({
          //   org_id: that.uid
          // }))
          // if (code == 200) {
          //   const myConfig = await useOrgConfig(levelRes, this.uid)
          //   this.myOrgConfig = myConfig
          //   tool.setOrgConfig(this.myOrgConfig)
          //   // that.$store.commit('setting/setDefaultConfig', myConfig)
          // }
          // this.myOrgConfig = await useOrgConfig('', this.uid)
          // tool.setOrgConfig(this.myOrgConfig)
          const myConfig = await useOrgConfig(this.uid)
          this.myOrgConfig = myConfig
          tool.setOrgConfig(this.myOrgConfig)
          if (
            this.liveType == "class" &&
            this.businessConfigs &&
            this.businessConfigs.classroom_check_access
          ) {
            //需要登录
            var userInfo = tool.getCookie("userInfo");
            console.log("获取用户信息==2", JSON.parse(userInfo));
            if (userInfo && userInfo != "undefined") {
              this.userLogin = JSON.parse(userInfo);
              if (!this.remark) {
                this.remark = this.userLogin.stu_note;
              }
              console.log("[<-- this.userLogin -->]", this.userLogin);
              this.fans_id = this.userLogin.fans_id;
              this.$TFWebLog.fans_id = this.fans_id;
              const paramsString = window.location.search.substr(1);
              const searchParams = new URLSearchParams(paramsString);
              if (searchParams.get("smsCode")) {
                const paramValue = searchParams.get("smsCode");
                this.smsLog(paramValue);
              }
            }
            this.checkClassLiveUserInfo(() => {
              //判断用户是否有权限观看
              this.channel_id && this.getGroupIdByChannelID();
              this.xianshiyingc();
              this.signIncomplete(); //刷新签到
              this.invite();
              this.getStatus();
              this.studentList();
              this.getISBack((isBlack) => {
                this.channel_id && this.channelInfoUpload();
                if (!isBlack) {
                  this.playeVideo();
                  this.loginIM();
                  this.showEnterUser(true, this.userLogin.nick);
                  this.watchWhiteCheck();
                  this.registerCheck();
                }
              });
              this.$nextTick(() => {
                // 获取预约信息
                this.getAppointmentData();
                var couponData = this.getModuleData("coupon");
                if (couponData) {
                  this.isShowCoupon =
                    couponData.enabled == "yes" ? true : false;
                  this.getMyFansLiveCouponInfo(couponData);
                }
              });
              this.setRuningLinght();
            });
          } else {
            //公开课
            if(this.direct.mode === 2) {
              const { isExpried } = await this.checkCampLiveIsExpired()
              if(isExpried) {
                return
              }
            }
            // 用户是否登录
            console.log(tool.getCookie("token"));
            var userInfo = tool.getCookie("userInfo");
            

            if (tool.getCookie("token")) {
              //有token
              // 已经登录了
              console.log("获取用户信息==1", userInfo);
              if (userInfo && userInfo != "undefined") {
                this.userLogin = JSON.parse(userInfo);
                this.fans_id = this.userLogin.fans_id;
                // 判断该直播间人数是否已满
                const { status } = await this.getLiveRoomOnlineUser();
                if (!status) {
                  this.$refs.limitOnlineUserDialogRef.show();
                  return;
                }
                // 判断当前用户是否可以观看直播
                const { canWatch } = await this.checkIsSingleWatch();
                if (!canWatch) {
                  this.$refs.limitWatchDialogRef.show();
                  return;
                }
                this.$TFWebLog.fans_id = this.fans_id;
                const paramsString = window.location.search.substr(1);
                const searchParams = new URLSearchParams(paramsString);
                if (searchParams.get("smsCode")) {
                  const paramValue = searchParams.get("smsCode");
                  this.smsLog(paramValue);
                }
                this.xianshiyingc();
                this.storedata();
                this.getStatus();
                this.signIncomplete();
                //   this.infogeren()
                //   this.orderdata()
                //   this.studydata(1)
                this.channel_id && this.getGroupIdByChannelID();
                this.getLastques();
                this.invite();
                this.studentList();
                this.$nextTick(() => {
                  // 获取预约信息
                  this.getAppointmentData();
                  // 获取优惠券弹框
                  var couponData = this.getModuleData("coupon");
                  if (couponData) {
                    this.isShowCoupon =
                      couponData.enabled == "yes" ? true : false;
                    this.getMyFansLiveCouponInfo(couponData);
                  }
                });
                if (this.userLogin.unReal != 1) {
                  //不是虚拟用户，这个接口唯一校验token的是否是同一个机构
                  this.getISBack(async (isBlack) => {
                    this.channel_id && this.channelInfoUpload();
                    if (!isBlack) {
                      this.playeVideo();
                      this.loginIM();
                      const { isLock , is_limit_we_com} = await this.setUserEnterRoomTag()

                      let lockType = 0
                      if(isLock) {
                        lockType = 1
                      } else if(is_limit_we_com) {
                        lockType = 2
                      }
                      if(lockType != 0) {
                        this.$refs.userLockChannelDialogRef.show(lockType)
                        return
                      }
                      this.updateUserTag(2)
                      this.showEnterUser(true, this.userLogin.nick);
                      this.handleShowBubbleWelcome({
                        nick: this.userLogin.nick,
                        header: this.userLogin.header,
                      });
                      this.clearBobbleUserList();
                      this.watchWhiteCheck();
                      this.registerCheck();
                    }
                  });
                } else {
                  this.playeVideo();
                }
                this.setRuningLinght();
              } else {
                // 没有获取到用户数据
                tool.delCookie("token");
                tool.delCookie("userInfo")
                setTimeout(() => {
                  window.location.reload()
                }, 500)
              }
              this.login = true;
              // 判断是否登录并付费
              this.getDetailPageFn(this.fans_id);
            } else {
              if (tool.isWeixin()) {
                //微信授权弹框
                let loginCodeTMp = tool.getQueryString("code");
                if (loginCodeTMp) {
                  this.wxLoginTap();
                } else {
                  // this.weixinLoginVisible = true;
                  this.wxLoginTap();
                }
              } else {
                // 游客登录
                if (this.initAllData && this.initAllData.ds_func.find((item) => item.module == 'visitor_log_on' && item.enabled == "yes")) {
                   this.visitorLoginShow = true;
                }else {
                    this.getLoginCode();
                }
              }
            }
          }
        });
      });
    }

    // document.getElementById("commentList").onscroll = function() {
    // that.scrollTop = document.getElementById("commentList").scrollTop;
    // let content_height = document.getElementById("commentList").scrollHeight;
    // let offsetHeight = document.getElementById("commentList").offsetHeight;
    // if (content_height - that.scrollTop <= offsetHeight) {
    //   that.showNewMsgTip = false;
    //   that.needShowNewMsgTip = false;
    //   that.is_first_mousewheel = false;
    //   that.first_mousewheel_scrollTop = 0
    //   that.last_mousewheel_scrollTop = 0
    // }
    // };

    // 判断鼠标是否滚动
    document.getElementById("commentList").onmousewheel = function (e) {
      if (that.businessConfigs.student_message_auto_scroll) {
        return;
      }

      if (!that.is_first_mousewheel) {
        that.is_first_mousewheel = true;
        that.last_mousewheel_scrollTop = 0;
        that.first_mousewheel_scrollTop =
          document.getElementById("commentList").scrollTop;
        return;
      }
      that.last_mousewheel_scrollTop =
        document.getElementById("commentList").scrollTop;
      if (e.wheelDelta > 0) {
        if (
          that.first_mousewheel_scrollTop - that.last_mousewheel_scrollTop >
          100
        ) {
          that.needShowNewMsgTip = true;
        }
      } else {
        // 向下处理
        that.first_mousewheel_scrollTop =
          document.getElementById("commentList").scrollTop;
        let content_height =
          document.getElementById("commentList").scrollHeight;
        let clientHeight = document.getElementById("commentList").clientHeight;
        if (
          content_height <=
          that.last_mousewheel_scrollTop + clientHeight + 100
        ) {
          that.showNewMsgTip = false;
          that.needShowNewMsgTip = false;
          that.is_first_mousewheel = false;
          that.first_mousewheel_scrollTop = 0;
          that.last_mousewheel_scrollTop = 0;
        }
      }
    };
    this.refreshCode();
    this.Initialization();
  },
  beforeDestroy() {
    if (this.clearBobbleUserTimer) {
      clearInterval(this.clearBobbleUserTimer);
      this.clearBobbleUserTimer = null;
    }
    if (this.setLookTime) {
      clearInterval(this.setLookTime);
      this.setLookTime = null;
    }
    clearTimeout(this.timerer);
  },
  destroyed() {
    if (this.limitCountDownTime) {
      clearInterval(this.limitCountDownTime);
      this.limitCountDownTime = null;
    }
    console.log("销毁");
  },
  methods: {
    visitloginTap() {
      this.visitorLoginShow = false;
      window.location.reload();
    },
    /**
     * 描述：展示“正在购买”提示
     **/
     startTimer() {
      // 清除之前的定时器
      clearTimeout(this.timerer);
      // 设置新的定时器，这里设定为5秒
      this.timerer = setTimeout(() => {
        console.log('购物车提示定时器结束');
        this.ShoppingGuide = []
        this.zzgmsp = 0
        this.cggmsp = 0
        // 可以在这里执行你的逻辑，例如关闭定时器
        this.timerer = null; // 可选，明确表示定时器已关闭
      }, 5000);
     },
     Xansders() {
      const arr = []
      const brr = []
      this.ShoppingGuide.forEach((item,index)=>{
        if (index % 2 === 0) {
          item.duosr = index + 1
          arr.push(item)
        } else {
          item.duosr = index + 1
          brr.push(item)
        }
      })
      this.ShoppingGuideas = arr
      this.ShoppingGuidebs = brr
      this.showTipsByUserBuy();
      this.startTimer()
    },
     showTipsByUserBuy() {
      if (this.ShoppingGuide.length > 0) {
        if (this.ShoppingGuide.length % 2 !== 0) {
          this.showBuyGoodsTips = true;
          const text =
            this.ShoppingGuide.length > 1
              ? `等${this.ShoppingGuide.length}人`
              : '';
            this.tipsBuyText = `${text}正在去购买`;
          // this.tipsBuyUsername = this.saveUserBuyList[0];
          // this.saveUserBuyList = [];
          this.tipsBuyTimer = setTimeout(() => {
            this.showBuyGoodsTips = false;
            if (this.tipsBuyTimer) {
              clearTimeout(this.tipsBuyTimer);
              return
            }
            this.tipsBuyTimer = setTimeout(() => {
              this.showTipsByUserBuy();
            }, 300);
          }, 5000);
        } else {
          this.showBuyGoodsTipsyi = true;
          const text =
            this.saveUserBuyList.length > 1
              ? `等${this.saveUserBuyList.length}人`
              : '';
          // if (!this.ShoppingGuide.Buying_now) {
          //   this.tipsBuyText = `${text} 正在去购买`;
          // } else {
            this.tipsBuyText = `${text}正在去购买`;
          // }
          this.tipsBuyUsername = this.saveUserBuyList[0];
          // this.saveUserBuyList = [];
          this.tipsBuyTimeryi = setTimeout(() => {
            this.showBuyGoodsTipsyi = false;
            if (this.tipsBuyTimeryi) {
              clearTimeout(this.tipsBuyTimeryi);
              return
            }
            this.tipsBuyTimeryi = setTimeout(() => {
              this.showTipsByUserBuy();
            }, 300);
          }, 5000);
        }
      } else {
        if (this.saveUserBuyList.length % 2 === 0) {
          clearTimeout(this.tipsBuyTimer);
          this.tipsBuyTimer = null;
        } else {
          clearTimeout(this.tipsBuyTimeryi);
          this.tipsBuyTimeryi = null;
        }
      }
    },
    /**
     * 描述：展示“购买成功”提示
     **/
    showTipsByUserBuySuccess() {
      if (this.saveUserBuySuccessList.length > 0) {
        if (this.ShoppingGuideyi.nick) {
          this.showBuySuccessGoodsTipser = true;
          // const text =
          //   this.saveUserBuySuccessList.length > 1
          //     ? `等${this.saveUserBuySuccessList.length}人`
          //     : '';
          // ${text}
            this.tipsBuySuccessText = `成功购买`;
          this.tipsBuySuccessUsername = this.ShoppingGuideyi.nick;
          this.saveUserBuySuccessList = [];
          this.tipsBuySuccessTimer = setTimeout(() => {
            this.showBuySuccessGoodsTipser = false;
            if (this.tipsBuySuccessTimer) {
              clearTimeout(this.tipsBuySuccessTimer);
              return
            }
            this.tipsBuySuccessTimer = setTimeout(() => {
              this.showTipsByUserBuySuccess();
            }, 300);
          }, 5000);
          return
        }
      } else {
        clearTimeout(this.tipsBuySuccessTimer);
        this.tipsBuySuccessTimer = null;
      }
    },
    timeAchievedFn() {
      this.isRecommendVisible = true;
      this.noCouponVisible = false;
    },
    getModuleData(mode) {
      return this.initAllData.ds_func.find((item) => item.module === mode);
    },
    getMyFansLiveCouponInfo(row) {
      if (row.params.length > 0) {
        const { coupontuijianData } = row.params[0];
        if (this.isObject(coupontuijianData)) {
          // live_type 1 公开课直播
          this.axios
            .post(
              tool.getTestSchoolApi() + "/fansCoupon/getMyFansLiveCouponInfo",
              qs.stringify({
                coupon_id: coupontuijianData.coupon_id,
                live_id: this.ds_id,
                live_type: 1,
              })
            )
            .then((res) => {
              if (res.data.code == 200) {
                this.couponTuijianData = res.data.data;
                // 优惠劵弹窗
                if (res.data.data.get_condition == 1) {
                  // 无限制
                  this.noCouponVisible = false;
                  this.isRecommendVisible = true;
                } else {
                  // 有限制
                  if (res.data.data.is_satisfy) {
                    // 限制已达成
                    this.noCouponVisible = false;
                    this.isRecommendVisible = true;
                  } else {
                    // 限制未达成
                    this.isRecommendVisible = false;
                    this.noCouponVisible = true;
                    if (res.data.data.get_condition == 2) {
                      this.lookingTime = res.data.data.second_time;
                      this.setLookTime && clearInterval(this.setLookTime);
                      this.setLookTime = null;
                      // 开始计时了
                      this.setLookTime = setInterval(() => {
                        this.lookingTime += 1;
                      }, 1000);
                    }
                  }
                }
                this.showCouponList = false;
                this.showcouponsGoodList = false;
                if (res.data.data.state == "0") {
                  this.$set(this.couponTuijianData, "statusType", 1);
                } else if (res.data.data.state == "1") {
                  this.$set(this.couponTuijianData, "statusType", 2);
                }
              }
            });
        } else {
          this.isRecommendVisible = false;
        }
      }
    },
    gotoUseCouponGood(list) {
      this.showcouponsGoodList = true;
      this.couponsGoodList = list;
    },
    recommendClose() {
      this.isRecommendVisible = false;
      this.noCouponVisible = false;
    },
    getCouponsList() {
      this.showCouponList = true;
      this.$nextTick(() => {
        this.$refs.couponList.fetch();
      });
    },
    // 东旭添加 判断是否已付费
    getDetailPageFn(fans_id) {
      const params = {
        ds_id: this.ds_id,
        fans_id,
      };
      this.axios
        .post(
          `${payOpenClassHost()}/liveapi/api/ds/payOpenInfo`,
          qs.stringify(params)
        )
        .then((res) => {
          console.log(res.data, "数据啊1111");
          if (res.data.code === 200) {
            if (res.data.data && !res.data.data.is_pay) {
              // 跳转支付详情页
              localStorage.setItem("ds_id", this.ds_id);
              localStorage.setItem("fans_id", fans_id);
              localStorage.setItem("channel_id", this.channel_id);
              this.$router.push({ name: "DetailPage" });
            }
          }
        });
    },
    smsLog(item) {
      // 开课提醒获取数据
      const data = {
        sms_code: item,
      };
      this.axios
        .post(tool.baseUrlSchool() + "/appeal/smsLog", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
          }
        });
    },
    studentList() {
      // 获取头像昵称
      const data = {};
      this.axios
        .post(tool.baseUrlSchool() + "/core/studentList", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            this.imgsrc = res.data.data.header;
            this.nicknc = res.data.data.nick;
          }
        });
    },
    getStatus() {
      this.axios
        .post(tool.baseUrlSchool() + "/stu/courseDirect", "ds_id=" + this.ds_id)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data == 0) {
              this.classid = "";
            } else {
              this.classid = res.data.data;
              let course_id = "course_id=" + this.classid;
              this.axios
                .post(
                  tool.baseUrlSchool() + "/stu/courseFunctionList",
                  course_id
                )
                .then((res) => {
                  if (res.data.code === 200) {
                    if (res.data.data.length > 0) {
                      res.data.data.forEach((item) => {
                        if (item.module == "running_horse") {
                          if (item.enabled == "yes") {
                            let j = JSON.parse(item.params);
                            this.runObj = {
                              open: true,
                              fontSize: j.fontSize,
                              fontColor: j.fontColor,
                              fontTrans: j.fontTrans / 100,
                              remark: j.remark,
                            };
                          } else {
                            let data = "ds_id=" + this.ds_id;
                            this.axios
                              .post(
                                tool.baseUrlSchool() +
                                  "/stu/courseDsFunctionList",
                                data
                              )
                              .then((reslut) => {
                                if (reslut.data.code === 200) {
                                  if (reslut.data.data.length > 0) {
                                    reslut.data.data.forEach((item) => {
                                      if (item.module == "running_horse") {
                                        if (item.enabled == "yes") {
                                          let j = JSON.parse(item.params);
                                          this.runObj = {
                                            open: true,
                                            fontSize: j.fontSize,
                                            fontColor: j.fontColor,
                                            fontTrans: j.fontTrans / 100,
                                            remark: j.remark,
                                          };
                                        } else {
                                          this.runObj.open = false;
                                        }
                                      }
                                    });
                                  }
                                }
                              });
                          }
                        }
                        if (item.module == "copyright_statement") {
                          if (item.enabled == "yes") {
                            let j = JSON.parse(item.params);
                            this.copyrightObj = {
                              open: true,
                              inputValue: j.inputValue,
                              copyrightTrans: j.copyrightTrans / 100,
                            };
                          } else {
                            let data = "ds_id=" + this.ds_id;
                            this.axios
                              .post(
                                tool.baseUrlSchool() +
                                  "/stu/courseDsFunctionList",
                                data
                              )
                              .then((reslut) => {
                                if (reslut.data.code === 200) {
                                  if (reslut.data.data.length > 0) {
                                    reslut.data.data.forEach((item) => {
                                      if (
                                        item.module == "copyright_statement"
                                      ) {
                                        if (item.enabled == "yes") {
                                          let j = JSON.parse(item.params);
                                          this.copyrightObj = {
                                            open: true,
                                            inputValue: j.inputValue,
                                            copyrightTrans:
                                              j.copyrightTrans / 100,
                                          };
                                        } else {
                                          this.copyrightObj.open = false;
                                        }
                                      }
                                    });
                                  }
                                }
                              });
                          }
                        }
                      });
                    }
                  }
                });
            }
          }
        });
    },
    xianShiewmt() {
      this.xianshiersx = true;
      this.$nextTick(() => {
        if (this.qrcode1) {
          // 如果二维码对象已存在，则更新链接
          this.qrcode1.clear(); // 清除之前的二维码
          // this.qrcode1.makeCode(
          //   `https://autha.coralclass.cn/login/#/wx-pc-update?ds_id=${
          //     this.ds_id
          //   }&appId=${this.initAllData.direct_seeding.appid}&uId=${
          //     this.uid
          //   }&token=${localStorage.getItem("tongbu_token")}&origin=shanhu`
          // ); // 生成新的二维码 
          this.qrcode1.makeCode(
            `${this.myOrgConfig.wechat_auth_domain}/login/#/wx-pc-update?ds_id=${this.ds_id}&appId=${this.myOrgConfig.official_account_appid}&uId=${this.uid}&token=${localStorage.getItem("tongbu_token")}&origin=shanhu`
          );
        } else {
          this.qrcode1 = new QRCode("dengluewm", {
            //这个qrCode是承载二维码元素的id
            // text: `https://autha.coralclass.cn/login/#/wx-pc-update?ds_id=${this.ds_id}&appId=${this.initAllData.direct_seeding.appid}&uId=${this.uid}&token=${localStorage.getItem("tongbu_token")}&origin=shanhu`, //二维码的内容也可以是段文本
            text: `${this.myOrgConfig.wechat_auth_domain}/login/#/wx-pc-update?ds_id=${this.ds_id}&appId=${this.myOrgConfig.official_account_appid}&uId=${this.uid}&token=${localStorage.getItem("tongbu_token")}&origin=shanhu`,
            width: 116, //宽
            height: 116, //高
            colorDark: "#000000", //前景色
            colorLight: "#ffffff", //背景色
            correctLevel: QRCode.CorrectLevel.H, //容错
          });
        }
      });
    },
    tanChuanghr() {
      this.$refs.mychild.testNum();
    },
    SMSpublic() {
      if (this.appointmentData.cate == 0) {
        if (this.appointmentData.type == 1) {
          this.PublicHao = true;
          this.getQrcode();
        } else {
          this.isAppointmentDialog = true;
        }
      } else {
        this.getSubscribe();
      }
    },
    // 预约操作
    getSubscribe() {
      var data = this.appointmentData;
      var option = `ds_id=${this.ds_id}&fans_id=${
        this.fans_id
      }&url=${encodeURIComponent(location.href)}&class_time=${
        data.class_time || ""
      }&flag=${data.flag}&dates=${data.dates || ""}&type=${data.type}&dsb_id=${
        data.id
      }&org_id=${this.uid}`;
      this.axios
        .post(tool.baseUrl4() + "/user/fansBook", option)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("预约成功");
            this.getAppointmentData();
            this.close("success");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    getQrcode() {
      this.axios
        .post(
          "https://publicmessage.tenghuiwangxiao.cn/getQrcode",
          `flag=1&org_id=${this.uid}`
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (this.qrcode) {
              // 如果二维码对象已存在，则更新链接
              this.qrcode.clear(); // 清除之前的二维码
              this.qrcode.makeCode(res.data.data.url); // 生成新的二维码
            } else {
              this.qrcode = new QRCode("qrCode_gzh", {
                //这个qrCode是承载二维码元素的id
                text: res.data.data.url, //二维码的内容也可以是段文本
                width: 116, //宽
                height: 116, //高
                colorDark: "#000000", //前景色
                colorLight: "#ffffff", //背景色
                correctLevel: QRCode.CorrectLevel.H, //容错
              });
            }
          }
        });
    },
    cancelfans() {
      this.isCancelfans = true;
    },
    cancelfansBtn(mode) {
      if (mode == "fail") {
        this.isCancelfans = false;
        this.$message({
          type: "info",
          message: "已取消操作",
        });
      } else {
        var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
        this.axios
          .post(tool.baseUrl4() + "/user/cancelfans", option)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: "success",
                message: "取消预约成功!",
              });
              this.isCancelfans = false;
            }
            this.getAppointmentData();
          });
      }
    },
    /**
     * 描述：展示“用户欢迎”提示
     **/
    showEnterUser(isSelf, nick) {
      if (!this.openWelcomeUser) return;
      if (this.saveEnterUserList.length > 0) {
        const json = this.saveEnterUserList[this.saveEnterUserList.length - 1];
        console.log(this.saveEnterUserList);
        const text =
          this.saveEnterUserList.length > 1
            ? `等${this.saveEnterUserList.length}人`
            : "";
        json.content =
          '欢迎<span style="color:#FFBF02;">' +
          `${this.hideNickFlag ? `${json.nick[0]}****` : json.nick}` +
          "</span>" +
          text +
          "进入直播间";
        json.nick = "系统消息";
        json.header =
          "https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/wx-user/flower/%E9%80%9A%E7%9F%A5%402x.png";
        json.module = "text_comment";
        console.log("json", json);
        this.onReceivedMsgCallBack(json);
        this.saveEnterUserList = [];
        this.saveEnterTimer = setTimeout(() => {
          if (this.saveEnterTimer) {
            clearTimeout(this.saveEnterTimer);
            this.saveEnterTimer = null;
          }
        }, 5000);
      } else if (isSelf) {
        const json = {};
        json.content =
          '欢迎<span style="color:#FFBF02;">' +
          `${this.hideNickFlag ? `${nick[0]}****` : nick}` +
          "</span>" +
          "进入直播间";
        json.nick = "系统消息";
        json.create_time = this.getTimes();
        json.header =
          "https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/wx-user/flower/%E9%80%9A%E7%9F%A5%402x.png";
        json.module = "text_comment";
        this.onReceivedMsgCallBack(json);
      }
    },
    handleShowBubbleWelcome(user) {
      if (!this.openWelcomeUser) return;
      if (this.bobbleUserList.length > 4) {
        this.bobbleUserList.pop();
      }
      this.bobbleUserList.unshift(user);
      this.showBubbleWelcomeTimer = setTimeout(() => {
        if (this.showBubbleWelcomeTimer) {
          clearTimeout(this.showBubbleWelcomeTimer);
          this.showBubbleWelcomeTimer = null;
        }
      }, 2000);
    },
    clearBobbleUserList() {
      if (this.clearBobbleUserTimer) {
        clearInterval(this.clearBobbleUserTimer);
        this.clearBobbleUserTimer = null;
      }
      this.clearBobbleUserTimer = setInterval(() => {
        if (this.bobbleUserList.length > 0) {
          this.bobbleUserList = [];
        }
      }, 10000);
    },
    async signIncomplete() {
      // 刷新签到
      const data = { ds_id: this.ds_id };
      const res = await this.axios.post(
        tool.baseUrl2() + "/api/sign/signIncomplete",
        qs.stringify(data)
      );

      if (res.data.code == 200) {
        if (res.data.data && res.data.data.status != 2) {
          this.Attend_id = res.data.data.id;
          this.Attend_title = res.data.data.title;
          this.Attend_Btn = res.data.data.sign_reminder;
          this.Attend_status = res.data.data.status;
          this.AttendCountdown(res.data.data.effective);
          this.isShowAttend = true;
        }
      }
    },
    async onAttend() {
      // 点击签到
      const data = {
        ds_id: this.ds_id,
        sign_id: this.Attend_id,
        channel_code: this.channel_id,
      };
      const res = await this.axios.post(
        tool.baseUrl2() + "/api/sign/fansSign",
        qs.stringify(data)
      );
      if (res.data.code == 200) {
        this.isShowAttend = false;
        this.isShowAttend_finsh = true;
      } else {
        this.$message.error("签到失败");
        this.isShowAttend = false;
      }
    },
    AttendCountdown(time) {
      //倒计时
      let time2 = +time;

      this.limitCountDownTime = setInterval(() => {
        time2--;
        if (time2 > 0) {
          this.limitCountDownTimeStr = this.calcTime(time2);
        } else {
          this.isShowAttend = false;
          clearInterval(this.limitCountDownTime);
          this.limitCountDownTime = null;
        }
      }, 1000);
    },

    calcTime(time) {
      if (time) {
        let min = Math.floor(time % 3600);
        let minute = Math.floor(min / 60);
        let second = min - minute * 60;
        return `${this.formatBit(minute)}:${this.formatBit(second)}`;
      } else {
        return "00:00";
      }
    },
    formatBit(val) {
      // 补0
      return val < 10 ? "0" + val : val;
    },

    cutSwitch() {
      console.log("=======cutSwitch======");
      this.isThird = !this.isThird;
      this.isSwitchPosition = !this.isSwitchPosition;
      let CameraVideoTopDiv = document.getElementById("CameraVideoTopDiv");
      let CameraVideoDiv = document.getElementById("CameraVideoDiv");
      let whiteBoardTopDiv = document.getElementById("whiteBoardTopDiv");
      let whiteBoardDiv = document.getElementById("whiteBoardDiv");
      if (this.isSwitchPosition) {
        console.log("切过去");
        CameraVideoTopDiv.after(whiteBoardDiv);
        whiteBoardTopDiv.after(CameraVideoDiv);
      } else {
        console.log("切回去");
        CameraVideoTopDiv.after(CameraVideoDiv);
        whiteBoardTopDiv.after(whiteBoardDiv);
      }
    },
    xueyuandslist(item) {
      this.dashangim =
        '<span style="color:#FFBF02;">' +
        item.nick +
        "</span>" +
        "打赏了" +
        '<span style="color:#FF0B0B;">' +
        item.money +
        "</span>" +
        "元";
      this.sendDaShuangMessage(this.dashangim);
    },
    guanbidas() {
      this.dialogVisibledas = false;
    },
    leftChange1(index) {
      //当前的背景颜色赋给当前点击的索引
      this.changeLeftBackgroundyi = index;
    },
    lijidashang() {
      if (this.inputjine == "") {
        this.$message({
          type: "error",
          message: "请选择或输入金额",
        });
        return;
      }
      const data = {
        money: Number(this.inputjine),
        opid: Number(this.business_Id),
        org_id: this.uid,
        ds_id: this.ds_id,
        channel_id: this.channel_id,
        fans_id: this.fans_id,
      };
      this.getPayLink(data);
      this.getflag({ opid: this.business_Id }, (flag) => {
        if (flag == 1) {
          //0全都有 1 微信 2 支付宝 3小程序
          this.state = ["微信"];
        } else if (flag == 2) {
          this.state = ["支付宝"];
        }
      });
      this.dialogzhifu = true;
      // that.qrcodeObj = new QRCode("xiaotan1", {
      //         width: 120,
      //         height: 120, // 高度https://u.yixueyoudao.com/pay/?money=1&opid=29
      //         text: `${process.env.BUILD_ENV === "production" ? location.origin : "https://u.yixueyoudao.com/pay/?money=1&opid=29"}`, // 二维码内容
      //         // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      //         background: "white"
      //       });
    },
    async getflag(data, callback) {
      const res = await this.axios.post(
        tool.onlineBaseURL() + "/payapi/getflag",
        qs.stringify(data)
      );
      // console.log('res----------', res.data)
      // this.createCode(res.data)
      if (res.data.code === 200) {
        callback && callback(res.data.data.flag);
      }
    },
    async getPayLink(data) {
      const res = await this.axios.post(
        tool.onlineBaseURL() + "/payapi/rewardUrl",
        qs.stringify(data)
      );
      // console.log('res----------', res.data)
      // this.createCode(res.data)
      if (res.data.code === 200) {
        console.log("res----------", res);
        // this.payLink = `${res.data.url}`
        this.createCode(res.data.data);
      }
    },
    // 生成二维码
    createCode(item) {
      console.log("success");
      const codeImg = this.$refs.image;
      QRCode1.toCanvas(codeImg, item, (err) => {
        if (err) {
          console.log(err);
        } else {
          console.log("success");
        }
      });
    },
    leftChange(index, jine) {
      //当前的背景颜色赋给当前点击的索引
      this.changeLeftBackground = index;
      this.inputjine = jine;
    },
    Initialization() {
      let that = this;
      let postdata = "ds_id=" + this.ds_id;
      this.axios
        .post(tool.baseUrl2() + "/customer/function/index", postdata, {
          credentials: false,
          emulateJSON: true,
        })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data) {
              res.data.data.forEach((e) => {
                if (e.module == "reward") {
                  this.business_Id = e.business_id;
                  this.dashangclass = e.params;
                  this.enabledDs = e.enabled;
                  if (e.params[0]) {
                    this.inputjine = e.params[0].jinqian;
                  }
                }
                if (e.module == "ds_book") {
                  this.appointmentEnabled = e.enabled == "yes" ? true : false;
                }
                if (e.module == "purchase_prompt") {
                  this.showBuyTipsState = e.enabled == "yes" ? true : false;
                }
                if (e.module == 'order_form') {
                  this.orderform = e.enabled == 'yes'? true:false
                }
              });
            }
          }
        });
    },

    initCos() {
      let that = this;
      this.cos = new COS({
        getAuthorization: function (options, callback) {
          // const url = process.env.VUE_APP_API_ONLINE_SCHOOL + '/common/index/getCosSign'
          const url = tool.baseUrlSchool() + "/common/index/getCosSign";
          console.log(url, "url");
          // return
          const xhr = new XMLHttpRequest();
          xhr.open("GET", url, true);
          xhr.onload = function () {
            try {
              var data = JSON.parse(xhr.responseText);
              var credentials = data.data.credentials;
            } catch (e) {
              console.log(e);
            }
            if (!data || !credentials) {
              return console.error(
                "credentials invalid:\n" + JSON.stringify(data, null, 2)
              );
            }
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
        UseAccelerate: that.miniConfigData.upload_use_accelerate,
      });
    },
    randomString(len) {
      len = len || 32;
      const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      const maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    getSuffix(filename) {
      console.log("get_suffix");
      let pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos !== -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    two(num) {
      if (num < 10) {
        return "0" + num;
      }
      return num;
    },
    cosUpload(uid, file) {
      return new Promise((resolve, reject) => {
        const time = new Date();
        const y = time.getFullYear();
        const m = this.two(time.getMonth() + 1);
        const d = this.two(time.getDate());
        const fileName = this.randomString() + this.getSuffix(file.name);
        const uploadPath = "/uploads/" + uid + "/" + y + "/" + m + "/" + d;
        const storeAs = uploadPath + "/" + fileName;
        this.cos.uploadFile(
          {
            Bucket: "tengface-live-user-1308721187",
            /* 填入您自己的存储桶，必须字段 */
            Region: "ap-guangzhou",
            /* 存储桶所在地域，例如ap-beijing，必须字段 */
            Key: storeAs,
            /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
            StorageClass: "STANDARD",
            Body: file, // 上传文件对象
            onTaskReady: (taskId) => {
              /* 非必须 */
              // this.form.file[0].taskId = taskId
            },
          },
          (err, data) => {
            if (data.statusCode === 200) {
              resolve(`https://${data.Location}`);
            }
            if (err) {
              // this.$set(this.enclosureForm.file[0], 'err', true)
            }
          }
        );
      });
    },
    hideliveAnser(value) {
      this.isShowLiveAnser = value;
    },
    async getLastques() {
      try {
        const postData = {
          org_id: this.uid,
          fans_id: this.fans_id,
          dsid: this.ds_id,
        };
        const data = await this.axios.post(
          tool.baseUrlSchool() + "/ds/user/lastques",
          qs.stringify(postData)
        );
        if (data.data && data.data.code == 200) {
          console.error("直播答题信息", data.data);
          let liveanserTmp = data.data.data;
          liveanserTmp.qpid = data.data.data.id;
          this.LiveanserObj = liveanserTmp;
        }
      } catch (error) {}
    },
    mimaWatchTap() {
      if (!this.view_auth_pasword) {
        this.$message({
          type: "error",
          message: "请输入密码",
        });
        return;
      }
      var passwd = md5(this.view_auth_pasword + "auth");
      if (this.view_auth_http_url == passwd) {
        var today = new Date().valueOf();
        localStorage.setItem("tengface_password_" + this.ds_id, today);
        this.mimaDialogVisible = false;
        this.$message({
          type: "success",
          message: "验证通过",
        });
      } else {
        this.$message({
          type: "error",
          message: "密码不正确",
        });
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    },
    shujufanye(val) {
      console.log(`当前页: ${val}`);
      this.pageye = val;
      this.studydata();
    },
    handleClick(tab, event) {
      console.log(tab._props.name, event);
      this.studydata(tab._props.name);
    },
    handleEdit(item) {
      this.dialogTableVisible = true;
      this.gridData = item;
      console.log(item);
    },
    // async studydata(item) {
    // 	try {
    // 		const param = {
    // 			fans_id: this.fans_id,
    // 			type: item,
    // 			num: 10,
    // 			page: this.pageye
    // 		}
    // 		const data = await this.axios.post('http://liveapi2.tenghuiwangxiao.com/api/ds/user/study_data', qs.stringify(param))
    // 		if(data.data.code == 200){
    // 			this.tableData = data.data.data.list
    // 			this.diff = data.data.data.info.diff
    // 			this.total = data.data.data.count
    // 		}
    // 	} catch (error) {
    //     console.error("checkClassLiveUserInfo", error);
    //   }
    // },
    // orderdata() {
    //   // 获取我的已购
    //   const param = "fansId=" + this.fans_id;
    //   this.axios
    //           .post("http://liveapi2.tenghuiwangxiao.com/api/ds/user/order_data",param)
    //           .then((res)=> {
    //             if (res.data.code == 200) {
    //               this.tableDatalist = res.data.data
    //             }
    //           });
    // },
    // infogeren() {
    //   // 获取我的信息
    //   const param = "fansId=" + this.fans_id;
    //   this.axios
    //           .post("http://liveapi2.tenghuiwangxiao.com/api/ds/user/info",param)
    //           .then((res)=> {
    //             if (res.data.code == 200) {
    //               this.headeryi = res.data.data.header
    //               this.nickyi = res.data.data.nick
    //               this.timesyi = res.data.data.times
    //               this.numsyi = res.data.data.nums
    //             }
    //           });
    // },
    storedata() {
      // 获取公司信息
      const param = "uid=" + this.uid;
      this.axios
        .post(tool.baseUrl2() + "/api/store_data", param)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data) {
              this.business_img = res.data.data.business_img;
              this.org_name = res.data.data.org_name;
            }
          }
        });
    },
    xianshiyingc() {
      // console.log('hhhhhhhhhhhkkkkkkkkkkkkkkkkkkkkkkkk=========================================', this.fans_id)
      const param = "uid=" + this.uid;
      this.axios.post(tool.baseUrl2() + "/api/store_msg", param).then((res) => {
        if (res.data.code == 200) {
          this.xianshilist = res.data.data.is_show;
        }
      });
    },
    zhuanhuan(value) {
      let result = parseInt(value);
      let y =
        Math.floor(result / 86400) < 10
          ? "0" + Math.floor(result / 86400)
          : Math.floor(result / 86400);
      let h =
        Math.floor((result / 3600) % 24) < 10
          ? "0" + Math.floor((result / 3600) % 24)
          : Math.floor((result / 3600) % 24);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      let res = "";
      // if (y !== "00") res += `${y}天`;

      res += `${h}:`;

      res += `${m}:`;

      res += `${s}`;

      return res;
    },
    //验证码规则
    getSubmitData() {
      if (this.inputCode == "") {
        this.$message({
          message: "请输入验证码",
          type: "error",
        });
        return;
      }
      let num = this.inputCode.toUpperCase();
      if (this.identifyCode !== num) {
        this.inputCode = "";
        this.refreshCode();
        this.$message({
          message: "请输入正确验证码",
          type: "error",
        });
        return;
      } else {
        this.inputCode = "";
        this.refreshCode();
        this.$message({
          message: "验证成功",
          type: "success",
        });
        this.zizhiguankantan = false;
        this.dialogVisiblelist = true;
        // this.$router.push({'path':'/Informationpage'});
      }
    },
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //初始化验证码
    refreshCode() {
      this.identifyCode = ""; //输入框置空
      this.makeCode(this.identifyCodeType, 4); //验证码长度为4
    },
    //随机切换验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodeType[
            this.randomNum(0, this.identifyCodeType.length)
          ];
      }
      //   console.log(this.identifyCode);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async errorReport(data) {
      if (data) {
        data.sessiontID = this.pageUUID;
      }
      const postData = {
        fans_id: parseInt(this.fans_id || 0),
        error_code: "70000",
        ds_id: parseInt(this.ds_id),
        uid: parseInt(this.uid || 0),
        terminal_type: 2,
        data,
      };
      try {
        // let param = `data=${JSON.stringify(postData)}`
        await this.axios.post(
          "https://report.tenghuiwangxiao.cn/app/report/errorReport",
          postData,
          { timeout: 10000 }
        );
      } catch (error) {}
    },
    wxLoginCallBack(fans) {
      if (fans) {
        tool.setCookie("userInfo", JSON.stringify(fans), 30);
        tool.setCookie("token", fans.token, 30);
        setTimeout(() => {
          location.reload();
        }, 500);
      } else {
        this.getLoginCode();
      }
    },
    getLoginCode() {
      this.axios
        .get(tool.baseUrl2() + "/wap/login/getLoginCode", { timeout: 5000 })
        .then((res2) => {
          if (res2.data.code == 200) {
            this.qqqrcodema = res2.data.data.code;
            this.qrcodema = res2.data.data.code;
            this.isLocalCode = true;
            this.showQrcode();
          }
        })
        .catch((error) => {
          this.axios
            .post(
              "https://service-jmibg8h4-1317978474.gz.apigw.tencentcs.com/release/api/login/getLoginCode",
              { ds_id: this.ds_id }
            )
            .then((res) => {
              if (res.data.code == 200) {
                this.qrcodema = res.data.data.code;
                this.isLocalCode = false;
                this.showQrcode();
              }
            });
        });
    },
    wxLoginTap() {
      tool.pcWXLogin(
        this.initAllData.direct_seeding.appid,
        this.initAllData.direct_seeding.ds_id,
        (fans) => {
          this.wxLoginCallBack(fans);
        },
        this.initAllData.direct_seeding.name
      );
    },
    wxLogoutTap() {
      wx.closeWindow();
    },
    async onlineLineSchoolSendMsg() {
      try {
        const postData = {
          area: 86,
          phone: this.onlineSchoolAccount,
          org_id: this.uid,
        };
        console.log("qs.stringify(postData)", qs.stringify(postData));
        const data = await this.axios.post(
          "https://twin-live.shktclass.com/sms/studentLoginSendSms",
          qs.stringify(postData)
        );
        console.log("data", data);
        if (data.data.code == 200) {
          this.sendMsgStartTimer();
        } else {
          this.$message.error(data.data.message);
        }
      } catch (error) {
        console.error("checkClassLiveUserInfo", error);
      }
    },
    sendMsgStartTimer() {
      this.onlineSednMsgText = "59S";
      this.onlineSendMsgNum = 59;
      this.onlineSchoolTimer = setInterval(() => {
        this.onlineSendMsgNum = this.onlineSendMsgNum - 1;
        if (this.onlineSendMsgNum <= 0) {
          this.onlineSendMsgNum = 0;
          this.onlineSednMsgText = "获取验证码";
          clearInterval(this.onlineSchoolTimer);
          this.onlineSchoolTimer = null;
          return;
        }
        this.onlineSednMsgText = `${this.onlineSendMsgNum}S`;
      }, 1000);
    },
    async onlineSchoolSMSLoginClick() {
      if (this.onlineSchoolAccount == "") {
        this.$message.error("账号不能为空");
        return;
      }
      if (this.onlineSchoolSMSCode == "") {
        this.$message.error("验证码不能为空");
        return;
      }
      try {
        const postData = {
          area: 86,
          phone: this.onlineSchoolAccount,
          code: this.onlineSchoolSMSCode,
          org_id: this.uid,
        };
        this.showLineSchoolPopUp = false;
        const data = await this.axios.post(
          tool.baseUrlSchool() + "/user/index/phoneLogin",
          qs.stringify(postData)
        );
        console.log("data", data);
        if (data.data.code == 200) {
          this.remark = data.data.stu_note;
          localStorage.setItem("tengface_remark", this.remark);
          tool.setCookie("netschool_token", data.data.data.token, 30);
          const postData2 = {
            fans_id: data.data.data.fansId,
            ds_id: this.ds_id,
          };
          console.log("qs.stringify(postData)", qs.stringify(postData2));
          const data2 = await this.axios.post(
            tool.baseUrlSchool() + "/stu/course/dsAuth",
            qs.stringify(postData2)
          );
          if (data2.data.code == 200) {
            if (data2.data.data.result) {
              tool.getUserInfoReloadByToken(data2.data.data.liveToken);
            } else {
              this.$message.error("此账号无权限观看此课程请联系管理员开通");
              this.showLineSchoolPopUp = true;
            }
          } else {
            this.$message.error(data2.data.message);
            this.showLineSchoolPopUp = true;
          }
        } else {
          this.showLineSchoolPopUp = true;
          this.$message.error(data.data.message);
        }
      } catch (error) {
        console.error("onlineSchoolLoginClick", error);
      }
    },
    async onlineSchoolLoginClick() {
      if (this.onlineSchoolAccount == "") {
        this.$message.error("账号不能为空");
        return;
      }
      if (this.onlineSchoolPassword == "") {
        this.$message.error("密码不能为空");
        return;
      }
      try {
        const postData = {
          account: this.onlineSchoolAccount,
          password: this.onlineSchoolPassword,
          org_id: this.uid,
        };
        this.showLineSchoolPopUp = false;
        const data = await this.axios.post(
          tool.baseUrlSchool() + "/user/index/login",
          qs.stringify(postData)
        );
        console.log("data", data);
        if (data.data.code == 200) {
          this.remark = data.data.data.stu_note;
          localStorage.setItem("tengface_remark", this.remark);
          console.log("[<-- this.remark -->]", this.remark);
          tool.setCookie("netschool_token", data.data.data.token, 30);
          const postData2 = {
            fans_id: data.data.data.fansId,
            ds_id: this.ds_id,
          };
          console.log("qs.stringify(postData)", qs.stringify(postData2));
          const data2 = await this.axios.post(
            tool.baseUrlSchool() + "/stu/course/dsAuth",
            qs.stringify(postData2)
          );
          if (data2.data.code == 200) {
            if (data2.data.data.result) {
              // console.log("班课token",data2.data.data.liveToken)
              tool.getUserInfoReloadByToken(data2.data.data.liveToken);
            } else {
              this.$message.error("此账号无权限观看此课程请联系管理员开通");
              this.showLineSchoolPopUp = true;
            }
          } else {
            this.$message.error(data2.data.message);
            this.showLineSchoolPopUp = true;
          }
        } else {
          this.showLineSchoolPopUp = true;
          this.$message.error(data.data.message);
        }
      } catch (error) {
        console.error("onlineSchoolLoginClick", error);
      }
    },
    sendDaShuangMessage(text) {
      let userInfo = tool.getCookie("userInfo");
      if (userInfo && userInfo != "undefined") {
        let userInfo2 = JSON.parse(userInfo);
        let message = {
          content: text,
          create_time: this.getTimes(),
          fans_id: userInfo2.fans_id,
          header:
            "https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/wx-user/flower/%E9%80%9A%E7%9F%A5%402x.png",
          key: `${this.ds_id}_comment_${new Date().getTime()}`,
          like_num: 0,
          module: "text_comment",
          nick: "系统消息",
          pic_url: "",
          user_type: "real",
          ds_id: this.ds_id,
          _id: `${this.ds_id}_comment_${new Date().getTime()}`,
        };
        this.onReceivedMsgCallBack(message);
      }
    },
    sendMessageMySelf(text, pic_url) {
      let userInfo = tool.getCookie("userInfo");
      if (userInfo && userInfo != "undefined") {
        let userInfo2 = JSON.parse(userInfo);
        let message = {
          content: text,
          create_time: this.getTimes(),
          fans_id: userInfo2.fans_id,
          header: userInfo2.header,
          key: `${this.ds_id}_comment_${new Date().getTime()}`,
          like_num: 0,
          module: "text_comment",
          nick: userInfo2.nick,
          pic_url: pic_url,
          user_type: "real",
          ds_id: this.ds_id,
          _id: `${this.ds_id}_comment_${new Date().getTime()}`,
        };
        this.onReceivedMsgCallBack(message);
        if (this.say_self.type == 1) {
          //是否发送给助教
          this.getServeTime().then((time) => {
            console.log("送给助教==time", time);
            handleim.sendTextMsg(
              Object.assign({}, message, {
                module: "my_self_hi",
                create_time: time || message.create_time,
              })
            );
          });
        }
      }
    },
    async getServeTime() {
      try {
        const data = await this.axios.get(
          `${tool.baseUrl2()}/wap/live/getServerTime`
        );
        if (data.data.code == 200) {
          return data.data.data.time;
        }
        return "";
      } catch (error) {
        return "";
      }
    },
    sendMessageBy505Error(text, pic_url, type) {
      let userInfo = tool.getCookie("userInfo");
      if (userInfo && userInfo != "undefined") {
        let userInfo2 = JSON.parse(userInfo);
        let message = {
          content: text,
          create_time: this.getTimes(),
          fans_id: userInfo2.fans_id,
          header: userInfo2.header,
          key: `${this.ds_id}_comment_${new Date().getTime()}`,
          like_num: 0,
          module: "text_comment",
          nick: userInfo2.nick,
          pic_url: pic_url,
          user_type: "real",
          _id: `${this.ds_id}_comment_${new Date().getTime()}`,
          ds_id: this.ds_id,
        };

        this.onReceivedMsgCallBack(message);

        this.getServeTime().then((time) => {
          console.log("送给助教==time", time);
          let message2 = Object.assign({}, message);
          message2.create_time = time || message.create_time;
          if (this.verify_comment && type != 1) {
            //审核评论
            message2.module = "check_comment";
            handleim.sendTextMsg(message2);
          } else {
            handleim.sendTextMsg(message2);
          }
        });
      }
    },
    copyTextTap(text) {
      //复制过滤
      let reg = /\<a(.*?)\>(\S*)\<\/a>/;
      let resultArr = text.match(reg);
      if (resultArr && resultArr[2]) {
        text = resultArr[2];
      }

      var oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value = text; //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$message.success("复制成功");
    },
    playFailed(playType, data) {
      if (playType != 2) {
        this.$message.error("加载视频失败,正在切换备选线路");
        this.$refs.tfPlayer.changePlayType(2);
      } else {
        this.$message.error("加载视频失败,请检查网络");
      }
    },
    registerCommit() {
      let that = this;
      let obj = {};
      for (let index in this.registerList) {
        const o = this.registerList[index];
        obj[o.name_title] = o;
        if (o.type == 1) {
          if (!/^1\d{10}$/.test(o.value)) {
            this.$message.error("请输入正确的手机号码");
            return;
          }
        }
      }
      const str = JSON.stringify([obj]);
      const option =
        "ds_id=" + this.ds_id + "&content=" + str + "&fans_id=" + this.fans_id;
      this.axios
        .post(tool.baseUrl2() + "/wap/index/playerRegist", option)
        .then(function (res) {
          console.log(res);
          if (res.data.code == 200) {
            that.registerViewShow = false;
            that.$message.success(res.data.data);
          } else {
            that.$message.error(res.data.message);
            console.log(res.data.message);
          }
        })
        .catch(function (data) {
          that.$message.error("网络错误！");
          console.log("错误" + data);
        });
    },
    registerCheck() {
      //开启了登记观看
      let that = this;
      if (this.iSOpenRegisterViewShow) {
        var options = "ds_id=" + that.ds_id + "&fans_id=" + that.fans_id;
        that.axios
          .post(tool.baseUrl2() + "/wap/index/isRegist", options)
          .then(function (res) {
            if (res.data.code == 200) {
              if (res.data.data.isRegist == "yes") {
                that.registerViewShow = false;
                console.log("用户已登记");
              } else {
                that.registerViewShow = true;
                // that.getCheckPlayParams();
                console.log("用户未登记");
              }
            } else {
              that.$message.error(res.data.message);
            }
          })
          .catch(function (res) {});
        console.log("用户开启了登记观看");
      }
    },
    getCheckPlayParams() {
      var that = this;
      let option2 = "ds_id=" + that.ds_id;
      that.axios
        .post(tool.baseUrl2() + "/wap/index/getCheckPlayParams", option2)
        .then(function (res) {
          if (res.data.code == 200) {
            that.registerList = JSON.parse(data.data.data.params);
            for (let index in that.registerList) {
              const obj = that.registerList[index];
              obj.value = "";
              obj.phone = "";
            }
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    sendFllowerTap(type) {
      if (type == 1) {
        this.sendFllowerText =
          "<span>送给老师的鲜花</span><img style='width:20px;vertical-align: bottom;' src='https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/flower/ico_songhua_new.png'/>";
      } else if (type == 2) {
        this.sendFllowerText =
          "<span>给老师点个赞</span><img style='width:20px;vertical-align: bottom;' src='https://tengface-live.oss-cn-beijing.aliyuncs.com/web/wx-user/flower/ico_dianzan_new.png'/>";
      }
      this.sendMsg(1);
    },
    watchWhiteCheck() {
      //白名单账号或者手机号观看
      let that = this;
      if (this.isOpenWatchWhite || this.isOpenAccountwhite) {
        // 白名单观看
        let option2 = "fans_id=" + that.fans_id + "&ds_id=" + that.ds_id;
        that.axios
          .post(tool.baseUrl2() + "/wap/index/whiteLoginCheck", option2)
          .then(function (res) {
            if (res.data.code == 200) {
              if (that.isOpenWatchWhite) {
                if (
                  !res.data.data.is_white_checked ||
                  res.data.data.is_white_checked == "true"
                ) {
                  that.TelTestShow = false;
                  //开启心跳
                  that.getHeartMode();
                  console.log("用户已验证");
                } else {
                  that.TelTestShow = true;
                  console.log("用户未验证");
                }
              } else if (that.isOpenAccountwhite) {
                if (
                  !res.data.data.is_white_checked ||
                  res.data.data.is_white_checked == "true"
                ) {
                  that.accountwhiteShow = false;
                  //开启心跳
                  that.getHeartMode();
                  console.log("用户已验证");
                } else {
                  that.accountwhiteShow = true;
                  console.log("用户未验证");
                }
              }
            } else {
              that.$message.error(res.data.message);
            }
          });
      } else {
        //没有白名单 开启心跳
        this.getHeartMode();
      }
    },
    changeNick(nick, isTeacher) {
      if (nick) {
        let nickName = nick.replace(/(\d{3})\d{4}(\d{4})/g, "$1****$2");
        if (this.hideNickFlag && nick !== "系统消息" && !isTeacher) {
          nickName = `${nick[0]}****`;
        }
        return nickName;
      }
      return "";
    },
    playeVideo() {
      console.log("playeVideo-----");
      setTimeout(() => {
        if (!this.showAutoPlayModal) {
          console.log("playeVideo-----", this.showAutoPlayModal);
          if (
            typeof WeixinJSBridge == "object" &&
            typeof WeixinJSBridge.invoke == "function" &&
            !/android/i.test(navigator.userAgent)
          ) {
            window.WeixinJSBridge.invoke("getNetworkType", {}, (res) => {
              console.log("autoplayer1");
              this.$refs.tfPlayer && this.$refs.tfPlayer.playVideoClicked();
              if (this.isThreeScreen) {
                this.$refs.tfPlayer1 && this.$refs.tfPlayer1.playVideoClicked();
              }
            });
          } else {
            console.log("autoplayer2");
            this.$refs.tfPlayer && this.$refs.tfPlayer.playVideoClicked();
            if (this.isThreeScreen) {
              this.$refs.tfPlayer1 && this.$refs.tfPlayer1.playVideoClicked();
            }
          }
        }
      }, 200);
    },
    checkIsAuth() {
      var option = "fans_id=" + this.fans_id + "&ds_id=" + this.ds_id;
      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }
      this.axios
        .post(
          "http://edu-api-1.tenghuiwangxiao.cn/user/index/checkIsAuth",
          option
        )
        .then(function (data) {
          if (data.data.data.auth == 0) {
            alert("没有权限观看此直播，请从网校入口进入直播间");
            var url = data.data.data.url;
            window.location.href = url;
          }
        })
        .catch(function (data) {
          console.log("错误" + data);
        });
    },

    unAutoPlay(message) {
      this.$message({ type: message.type, message: message.message });
    },
    changeCommentTab(item) {
      this.commentTab = item;
      if (item == 2) {
        this.unReadNum = 0;
        this.showUnReadView = false;
        this.$refs.consultTeacher.switchTimeList();
      } else {
        this.$refs.consultTeacher.stopTimeList();
      }
    },
    getISBack(callback) {
      let that = this;
      let option2 = {
        ds_id: this.ds_id,
        fans_id: this.fans_id,
        nick: this.userLogin.nick,
        header: this.userLogin.header,
      };
      that.axios
        .post(tool.baseUrl2() + "/api/ds/getIsBlack", qs.stringify(option2))
        .then(function (res) {
          if (res.data.code == 200) {
            if (res.data.data.in_black == "yes") {
              that.isBlack = true;
              callback && callback(true);
            } else {
              that.isBlack = false;
              callback && callback(false);
            }
          } else if (res.data.code != 100068 && res.data.code != 100067) {
            //token过期
            callback && callback(false);
          }
        })
        .catch((e) => {
          callback && callback(false);
        });
    },
    invite() {
      // this.checkIsAuth();
    },
    isSupportRTCCallBack(value) {
      console.log("isSupportRTCCallBack", value);
      var u = navigator.userAgent;
      if (u.indexOf("WindowsWechat") == -1) {
        this.isRTCSupport = value;
      }
    },
    dragoverAction(e) {
      e.preventDefault();
      console.log("dragoverAction");
    },
    async dragAction(e) {
      console.log("dragAction");
      var fileList = e.dataTransfer.files; // 获取文件对象
      // 检测是否是拖拽文件到页面的操作
      if (fileList.length == 0) {
        return false;
      }
      this.occupyImg = await this.cosUpload(this.uid, fileList[0]);
      e.preventDefault();
    },
    channelInfoUpload() {
      var param = {
        ds_id: this.ds_id,
        fans_id: this.fans_id,
        uid: this.uid,
        channel_code: this.channel_id,
      };

      if (this.tid) {
        param.tid = this.tid;
      }

      let option3 = qs.stringify(param);
      this.axios
        .post(tool.baseUrl2() + "/customer/channel/channelInfoUpload", option3)
        .then(function (data) {})
        .catch(function (data) {});
    },
    comme_inRequest() {
      let that = this;
      this.returnCitySN = returnCitySN || {};
      var param = {
        ds_id: this.ds_id,
        fans_id: this.fans_id,
        cip: this.returnCitySN.cip,
        cid: this.returnCitySN.cid,
        province_name: this.returnCitySN.cname,
        interval: 30,
        uid: this.uid,
        channel_ds_code: this.channel_id,
        terminal_type: 2,
      };
      if (this.tid) {
        param.tid = this.tid;
      }
      let option3 = qs.stringify(param);
      this.axios
        .post(tool.baseUrlUser() + "/app/index/come_in", option3)
        .then(function (data) {
          var data = data.data;
          if (data.code != 200) {
            that.errorReport({
              msg: "come_in调用异常",
              userinfo: that.userLogin,
              error: data,
            });
          }
        })
        .catch(function (error) {
          that.errorReport({
            msg: "come_in网络异常",
            userinfo: that.userLogin,
            error: error,
          });
          this.axios
            .post(tool.baseUrlUserBak() + "/app/index/come_in", option3)
            .then(function (data) {
              var data = data.data;
              if (data.code != 200) {
                that.errorReport({
                  msg: "come_in2调用异常",
                  userinfo: that.userLogin,
                  error: data,
                });
              }
            })
            .catch(function (error2) {
              that.errorReport({
                msg: "come_in2网络异常",
                userinfo: that.userLogin,
                error: error2,
              });
            });
        });
      //获取心跳
      this.heartRequest();
    },
    getHeartMode() {
      if (this.direct.im_type == 2) {
        //1 腾讯IM 2 网易
        return;
      }
      let param = {
        ds_id: this.ds_id,
      };
      this.axios
        .post(tool.baseUrl4() + "/init/getHeartMode", qs.stringify(param))
        .then((res) => {
          let data = res.data;
          this.errorReport({ msg: "心跳模式", HeartMode: res });
          if (data.code == 200) {
            //2 接口 3 接口+长连接 4 长连接
            this.HeartMode = data.data.mode;
            if (data.data.mode == "2") {
              //接口
              this.comme_inRequest();
            } else if (data.data.mode == "3") {
              //接口+长连接
              // this.comme_inRequest();
              this.loginYunXinIM(2);
            } else if (data.data.mode == "4") {
              //长连接
              this.loginYunXinIM(2);
            } else if (data.data.mode == "5") {
              // 接口+长连接
              this.comme_inRequest();
              this.loginYunXinIM(2);
            } else {
              this.comme_inRequest();
            }
          } else {
            this.comme_inRequest();
          }
          console.log("getHearModel", data);
        })
        .catch((err) => {
          this.comme_inRequest();
        });
    },
    msgScrollBottom() {
      // var h = document.getElementById("commentList").scrollHeight;
      // var self = this;

      if (
        this.needShowNewMsgTip &&
        !this.businessConfigs.student_message_auto_scroll
      ) {
        this.showNewMsgTip = true;
      } else {
        this.is_first_mousewheel = false;
        setTimeout(() => {
          document.getElementById("commentList").scrollTop =
            document.getElementById("commentList").scrollHeight;
        }, 0);
      }
      // if (this.scrolltimer == null) {
      //   this.scrolltimer = setTimeout(function() {
      //     if (h - self.scrollTop < 700) {
      //       document.getElementById(
      //         "commentList"
      //       ).scrollTop = document.getElementById("commentList").scrollHeight;
      //     } else {
      //       // 有新消息没有展示出来
      //       self.showNewMsgTip = true;
      //     }
      //     self.scrolltimer = null;
      //   }, 500);
      // }
    },
    scrollToBottom() {
      this.showNewMsgTip = false;
      this.needShowNewMsgTip = false;
      this.is_first_mousewheel = false;
      this.first_mousewheel_scrollTop = 0;
      this.last_mousewheel_scrollTop = 0;
      document.getElementById("commentList").scrollTop =
        document.getElementById("commentList").scrollHeight;
    },
    heartRequest() {
      clearInterval(this.heartTimer);
      this.heartTimer = null;
      this.heartTimer = setInterval(() => {
        // eslint-disable-next-line no-undef
        this.returnCitySN = returnCitySN || {};
        var param = {
          ds_id: this.ds_id,
          fans_id: this.fans_id,
          cip: this.returnCitySN.cip,
          cid: this.returnCitySN.cid,
          province_name: this.returnCitySN.cname,
          interval: this.heart_time,
          uid: this.uid,
          channel_ds_code: this.channel_id,
          terminal_type: 2,
        };
        if (this.tid) {
          param.tid = this.tid;
        }
        let option3 = qs.stringify(param);
        this.axios
          .post(tool.baseUrlUser() + "/app/index/heart", option3)
          .then((data) => {
            var data = data.data;
            if (data.code == 200) {
              if (!data.data.heartSwitch) { //心跳开关
                 clearInterval(this.heartTimer);
                 this.heartTimer = null;
                 this.yunxinnetworkStatus = false
                return
              }
              if (this.heart_time != data.data.interval) {
                this.heart_time = data.data.interval || 30;

                this.heartRequest();
              }
            } else {
              this.errorReport({
                msg: "heart调用异常",
                userinfo: this.userLogin,
                error: data,
              });
            }
          })
          .catch((error) => {
            this.errorReport({
              msg: "heart网络异常",
              userinfo: this.userLogin,
              error: error,
            });
            this.axios
              .post(tool.baseUrlUserBak() + "/app/index/heart", option3)
              .then((data) => {
                var data = data.data;
                if (data.code == 200) {
                  if (this.heart_time != data.data.interval) {
                    this.heart_time = data.data.interval || 30;
                  }
                } else {
                  this.errorReport({
                    msg: "heart2调用异常",
                    userinfo: this.userLogin,
                    error: data,
                  });
                }
              })
              .catch((error1) => {
                this.errorReport({
                  msg: "heart2网络异常",
                  userinfo: this.userLogin,
                  error: error1,
                });
              });
          });
      }, this.heart_time * 1000);
    },
    videoheartRequest() {
      if (!this.videoheartTimer) {
        this.videoheartTimer = setInterval(() => {
          const videoData = {
            file_id: this.threeScreenVideofile_id,
            fans_id: this.fans_id,
            uid: this.uid,
            ds_id: this.ds_id,
            progress: parseInt(this.currentPlayTime),
          };
          this.axios
            .post(
              tool.baseUrlUser() + "/app/index/videoHeart",
              qs.stringify(videoData)
            )
            .then(function (data) {})
            .catch(function (data) {});
        }, 5000);
      }
    },
    playerStatusChange(to) {
      this.playerStatus = to;
      console.log("播放状态变化了");
    },
    linkTypeChange(to) {
      this.linkType = to;
      console.log("连麦状态变化了");
    },
    studentOneKeyLinkMicCB(data) {
      // 开始走连麦流程了
      if (this.initAllData.direct_seeding.play_style != 3) {
        return;
      }
      if (data.content == this.fans_id) {
        const canLink = this.$refs.tfPlayer.getIsSupportRTCLink();
        if (!canLink) {
          //设备不支持
          this.$TFWebLog.putLogs(10007, 1, {
            responseData: "学员一键连麦老师消息PC-设备不支持",
          });
          return;
        }

        if (this.playerStatus != 2) {
          //没有播放视频
          this.$TFWebLog.putLogs(10007, 1, {
            responseData: "学员一键连麦老师消息PC-没有播放视频",
          });
          return;
        }
        this.linkType = 2;
        //开始走连麦流程了
        this.$refs.tfPlayer.rtcLink();
        this.$TFWebLog.putLogs(10007, 1, {
          responseData: "学员一键连麦老师消息PC-走连麦流程了",
        });
      }
    },
    onkeyLinkMic(data) {
      // 开始走连麦流程了
      if (this.initAllData.direct_seeding.play_style != 3) {
        return;
      }

      if (data.content == this.fans_id) {
        if (!this.isRTCSupport) {
          console.log("不能连麦");
          handleim.sendCannotLink("1");
          this.$TFWebLog.putLogs(10007, 1, {
            responseData: "老师一键连麦学员消息PC-设备不支持",
          });
          return;
        }

        if (this.playerStatus != 2) {
          handleim.sendCannotLink("2");
          this.$TFWebLog.putLogs(10007, 1, {
            responseData: "老师一键连麦学员消息PC-没有播放视频",
          });
          return;
        }
        this.linkType = 2;
        this.$refs.tfPlayer.rtcLink();
        this.$TFWebLog.putLogs(10007, 1, {
          responseData: "老师一键连麦学员消息PC-走连麦流程",
        });
      }
    },
    applayLink() {
      if (this.linkType === 1) {
        console.log("发送连麦消息");
        if (
          this.userConfigData &&
          this.userConfigData.student_onekey_linkMic == 1
        ) {
          handleim.studentOneKeyLinkMic(); //一键连麦
          this.$TFWebLog.putLogs(10007, 1, {
            responseData: "学员发送一键连麦消息PC",
          });
        } else {
          handleim.sendApplyLink();
          this.$TFWebLog.putLogs(10007, 1, {
            responseData: "学员发送连麦消息PC",
          });
        }
      } else if (this.linkType == 2) {
        handleim.sendSureLink();
        // 开始走连麦流程了
        this.$refs.tfPlayer.rtcLink();
        this.$TFWebLog.putLogs(10007, 1, {
          responseData: "学员发送同意连麦消息PC",
        });
      } else if (this.linkType == 3) {
        // 走结束连麦流程
        this.$refs.tfPlayer.rtcLinkDown();
        this.linkType = 1;
        this.$TFWebLog.putLogs(10007, 1, {
          responseData: "学员发送结束连麦消息PC",
        });
      }
      this.lianmai2DialogVisible = false;
      this.lianmaiDialogVisible = false;
    },
    refuseLink() {
      if (this.linkType == 2) {
        handleim.sendRefuseLink();
        this.$TFWebLog.putLogs(10007, 1, {
          responseData: "学员发送拒绝连麦消息PC",
        });
      }
      this.lianmaiDialogVisible = false;
      this.lianmai2DialogVisible = false;
    },
    onLinkClicked() {
      this.lianmaiDialogVisible = true;
    },
    getRadmonFansId() {
      // 没有登录用户获取随机的用户id
      return Math.round(Math.random() * 9999999 + 100000);
    },
    handleEmotion(i) {
      this.comment += i;
    },
    // 将匹配结果替换表情图片
    emotion(res) {
      return tool.emotion(res);
    },
    update() {
      this.starttime = this.starttime.replace(new RegExp("-", "gm"), "/");
      var starttimeHaoMiao = new Date(this.starttime).getTime();
      var nowtime = new Date().getTime();
      var surplustime = parseInt((starttimeHaoMiao - nowtime) / 1000);
      this.time = tool.changeTime(surplustime);
      //        console.log(this.time);
    },
    isWeixin() {
      var agent = navigator.userAgent.toLowerCase();
      if (agent.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    getdatas: function (input) {
      this.qrcodeShow = input;
    },
    handleSizeChange(val) {
      console.log("每页 ${val} 条");
    },
    handleCurrentChange(val) {
      console.log("当前页: ${val}");
    },
    inputFocus() {
      this.isShowQuickPanel = false;
    },
    reply(item) {
      // 回复
      if (!tool.getCookie("token")) {
        this.showQrcode();
        return;
      }
      this.isReply = true;
      this.focusState = true;
      this.occupyImg = "";
      this.comment_id = item._id;
      this.comment = "";
      this.placeholder = "请输入回复" + item.nick + "的内容";
      this.visible = false;
    },
    sendquickMsgAction(index) {
      this.isShowQuickPanel = false;
      this.comment = this.comment_list[index].comment;
      this.sendMsg();
    },
    showQuickMsgPanelAction() {
      this.isShowQuickPanel = !this.isShowQuickPanel;
      this.focusState = false;
    },
    loop() {
      var that = this;
      this.timer = setInterval(function () {
        that.getComment();
      }, 5000);
    },
    sendMsg(type) {
      let contentText = "";
      if (type == 1) {
        contentText = this.sendFllowerText;
      } else {
        contentText = this.comment.replace(/(<|>|&lt;|&gt;)/gi, "#");
      }
      if (type == 4) {
        contentText = this.dashangim;
      }
      //直播结束禁止发言
      if (
        this.direct.direct_status == "end" &&
        this.userConfigData &&
        this.userConfigData.all_no_speak
      ) {
        this.$message({
          message: "当前未直播禁止发言",
          type: "warning",
        });
        return;
      }

      if (contentText.length < 1 && this.occupyImg === "") {
        this.$message({
          message: "发送消息不能为空",
          type: "warning",
        });
        return false;
      }

      if (this.sendMsgTimer || this.messageSendStatus) {
        this.$message({
          message: "评论发送太快了",
          type: "warning",
        });
        return;
      }

      this.sendMsgTimer = setTimeout(() => {
          clearTimeout(this.sendMsgTimer)
          this.sendMsgTimer = null;
        },
        type == 1 ? 5000 : 3000
      )

      //评论不可以大于500字
      // if(this.comment.length > 500){
      //   this.$message({
      //     message: "评论不可以大于500字",
      //     type: "warning"
      //   });
      //   return false;
      // }
      contentText = contentText.replace(
        /\#[\u4E00-\u9FA5]{1,3}\;/gi,
        this.emotion
      );

      this.messageSendStatus = true

      if (this.commentTab === 2) {
        this.messageSendStatus = false
        this.$refs.consultTeacher.sendC2CMsg(
          contentText,
          this.occupyImg,
          (isOK, errorMsg) => {
            this.visible = false;
            this.occupyImg = "";
            if (type != 1) {
              this.comment = "";
            }
          }
        );
        return;
      }

      var that = this;
      var url2 = tool.baseUrl2() + "/liveapi3/comment/index/sendComment";
      var option2 = {
        terminal_type: 2,
        fans_id: this.fans_id,
        ds_id: this.ds_id,
        content: contentText,
        nick_name: this.userLogin.nick,
        header_url: this.userLogin.header,
        pic_url: this.occupyImg || "",
        debug: 1,
        channel_id: this.channel_REL_ID,
      };
      option2 = qs.stringify(option2);
      if (that.say_self.enabled && that.say_self.all == 1) {
        that.messageSendStatus = false
        //开启全员自嗨
        that.sendMessageMySelf(contentText, that.occupyImg);
        that.visible = false;
        that.occupyImg = "";
        if (type != 1) {
          that.comment = "";
        }
        return;
      }
      // if (this.isRequesting) { // 正在请求中
      //   this.$message({
      //     message: "评论发送太快了！",
      //     type: "warning",
      //   });
      //   return;
      // }
      // this.isRequesting = true;
      this.axios
        .post(url2, option2, { timeout: 10000 })
        .then(function (data) {
          that.messageSendStatus = false
          var data = data.data;
          // that.isRequesting = false;
          if (data.code == 200) {
            data.data.content.header = that.userLogin.header;
            data.data.content.nick = that.userLogin.nick;
            if (data.data.isCheck) {
              let newObj = Object.assign({}, data.data.content);
              newObj.module = "check_comment";
              handleim.sendTextMsg(newObj);
            } else {
              handleim.sendTextMsg(data.data.content);
            }
            that.onReceivedMsgCallBack(data.data.content);
          } else {
            if (that.say_self.enabled) {
              //开启自嗨
              that.sendMessageMySelf(contentText, that.occupyImg);
            } else {
              that.$message({
                message: data.message,
                type: "warning",
              });
            }
          }

          that.visible = false;
          that.occupyImg = "";
          if (type != 1) {
            that.comment = "";
          }
        })
        .catch(function (data) {
          that.messageSendStatus = false
          // that.isRequesting = false;
          // that.$message("评论失败");
          that.sendMessageBy505Error(contentText, that.occupyImg, type);
          that.visible = false;
          that.occupyImg = "";
          if (type != 1) {
            that.comment = "";
          }
          console.log("错误" + data);
        });
    },
    encrypt(option) {
      var Base64 = require("js-base64").Base64;
      var verifyCode = "1111110111"; // vxxData.verifyCode;
      var tmp;
      var tmp1;

      var data1 = JSON.stringify(option);
      var params1 = Base64.encode(data1).replace(/\+/g, "%2B");
      var newstr1 = "";
      var tmp2 = params1.substring(0, 3);
      var tmp3 = params1.substring(3, params1.length);
      newstr1 += tmp2 + md5(data1 + verifyCode) + tmp3;
      newstr1 = "data=" + newstr1;
      return newstr1;
    },
    changeVideo(list, index) {
      this.flag = index;
    },
    addLikeNum(item) {
      if (!tool.getCookie("token")) {
        this.showQrcode();
        return;
      }
      var url, option;
      var that = this;
      if (item) {
        url = tool.baseUrl2() + "/comment/index/addLikeNum";
        option = "&ds_id=" + this.ds_id + "&id=" + item._id;
      } else {
        url = tool.baseUrl2() + "/init/addAgree";
        option = "ds_id=" + this.ds_id + "&num=1";
      }
      this.axios
        .post(url, option)
        .then(function (res) {
          var data = res.data;
          if (data.code == 200) {
            console.log(data);
            if (url == tool.baseUrl2() + "/init/addAgree") {
              that.total_like++;
            }
          }
        })
        .catch(function (res) {
          console.log("错误" + res.data);
        });
    },
    getMiniConfig(callBack) {
      var that = this;
      this.axios
        .get(
          `${tool.tencnetConfigOssUrl()}/web/config/userConfig/${
            this.uid
          }.json?ran=${new Date().valueOf()}`
        )
        .then(function (res) {
          if (res.status == 200) {
            that.miniConfigData = res.data || {};
          }
          callBack && callBack();
        })
        .catch(function (error) {
          callBack && callBack();
        });
    },
    getUserConfig() {
      var that = this;
      this.axios
        .get(
          `${tool.userOSSConfigUrl()}/web/config/userConfig/${
            this.uid
          }.json?ran=${new Date().valueOf()}`
        )
        .then(function (res) {
          if (res.status == 200) {
            that.userConfigData = res.data;
            console.log("[<-- that.userConfigData -->]", that.userConfigData);
            if (that.userConfigData.show_teacher == 0) {
              that.showTeacherTab = false;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getUserConfig2(callback) {
      const param = "uid=" + this.uid;
      this.axios
        .post(tool.baseUrl2() + "/customer/index/qryUserConfigs", param, {
          timeout: 5000,
        })
        .then((res) => {
          var data = res.data.data;
          if (res.data.code == "200") {
            if (data) {
              console.log(
                "所有自定义=========================================",
                data
              );
              data.forEach((item) => {
                this.businessConfigs[item.key] = item.value == "true";
                if (item.key == "show_likes_and_flowers") {
                  this.flowers = item.value;
                } else if (item.key == "openClassHideNick") {
                  this.hideNickFlag =
                    item.value === "true" &&
                    !this.isClassEnter &&
                    !(this.initAllData.direct_seeding.type == "class");
                } else if (item.key == 'set_goods_domain') {
                  // 获取商品自定义域名
                  this.goodsDomain = item.value == 'false' ? '' : item.value
                }
              });
            }
          }
          if (callback) {
            callback();
          }
        })
        .catch(function (error) {
          console.log(error);
          callback && callback();
        });
    },
    checkClassLiveUserInfo(callBack) {
      if (this.fans_id) {
        const param = "fans_id=" + this.fans_id + "&ds_id=" + this.ds_id;
        this.axios
          .post(tool.baseUrlSchool() + "/stu/course/dsAuth", param)
          .then((res) => {
            if (res.data.code == 222222) {
              this.login = false;
              this.showLineSchoolPopUp = true;
            } else if (res.data.code == 200) {
              callBack && callBack();
              // this.checkNetSchoolTokenValid();
              // setInterval(() => {
              //   this.checkNetSchoolTokenValid();
              // }, 10000);
              this.login = true;
            } else {
              this.$message(res.data.message);
              this.login = false;
              this.showLineSchoolPopUp = true;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.showLineSchoolPopUp = true;
      }
    },
    checkNetSchoolTokenValid() {
      var that = this;
      this.axios
        .post(tool.baseUrlSchool() + "/user/index/checkToken", "")
        .then(function (res) {
          if (res.data.code == "200") {
            // that.view_num = data.view_num;
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getInfo() {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=1";
      this.axios
        .post(this.beseUrl + "/init/getDynamicData", option)
        .then(function (res) {
          var data = res.data.data;
          if (res.data.code == "200") {
            that.total_like = data.like_num;
            // that.view_num = data.view_num;
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getGroupIdByChannelID() {
      var that = this;
      var option = "channel_code=" + this.channel_id;
      this.axios
        .post(tool.baseUrl2() + "/customer/channel/query", option)
        .then(function (res) {
          if (res.data.code == "200" && res.data.data) {
            that.channelGroupID = res.data.data.grouping || "";
            that.channel_REL_ID = res.data.data.id || "";
            that.getComment();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    at_to() {
      let arr = [];
      let element = this.$refs[this.to_fans_idlist[0].to_fans_id];
      element.forEach((x) => {
        if (!x.getAttribute("isnow")) {
          arr.push(x.offsetTop);
        }
        x.setAttribute("isnow", true);
      });
      document.getElementById("commentList").scrollTop = arr[0];
      this.to_fans_idlist = [];
    },
    getData(callBack, fakeInfo) {
      const tencentOssUrl = `${tool.tencentOssUrl()}/ds/larave_cache/dsCache_${
        this.ds_id
      }.json?${new Date().getTime()}${parseInt(Math.random() * 10e4)}`;
      const use_time_b = new Date();
      this.axios
        .get(tencentOssUrl, { timeout: 2000 })
        .then((res) => {
          let use_time = new Date() - use_time_b;
          this.$TFWebLog.putLogs(10000, 1, {
            responseData: res,
            use_time: use_time,
          });
          console.log("[<-- res.data6666666666 -->]", res.data);
          this.afterGetData(callBack, fakeInfo, res.data);
        })
        .catch((err) => {
          let use_time = new Date() - use_time_b;
          this.$TFWebLog.putLogs(10000, 1, {
            responseData: err,
            use_time: use_time,
          });
          this.axios
            .post(this.beseUrl + "/init/index/index", "ds_id=" + this.ds_id, {
              timeout: 5000,
            })
            // this.axios.post("http://liveapi2.tenghuiwangxiao.com/api/init/index/index", "ds_id=" + this.ds_id)
            .then((res) => {
              if (res.data.code == 200) {
                this.afterGetData(callBack, fakeInfo, res.data.data);
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
              callBack();
            });
        });
    },
    async afterGetData(callBack, fakeInfo, data) {
      const that = this;
      const Obj = {};
      if (fakeInfo) {
        data = tool.mergeDsData(fakeInfo, data);
      }

      if (data.direct_seeding.play_style == 5) {
        //三分屏
        data.direct_seeding.play_style = 3;
        that.isThreeScreen = true;
      }
      that.initAllData = data;
      that.direct = data.direct_seeding;
      document.title = data.direct_seeding.name;
      that.comment_list = data.comment_list;
      that.videoList = data.direct_seeding.break_point || [];
      this.livingObj.pic_url = data.direct_seeding.pic_url;
      this.livingObj.title = data.direct_seeding.name;
      this.livingObj.create_time = data.direct_seeding.start_time;
      if (data.direct_seeding.direct_status == "running") {
        this.isLiving = true;
        this.videoList.unshift(this.livingObj);
      }
      that.uid = data.direct_seeding.uid;
      tool.setBuinessId(that.uid);
      this.$TFWebLog.org_id = that.uid;
      that.liveType = data.direct_seeding.type;
      that.is_all_users_muted = data.direct_seeding.comment_on_off == "0";
      // 自动播放进度条
      if (this.videoList && this.videoList.length > 0) {
        const len = this.videoList.length;
        const { playback, wb_playback, file_id } = this.videoList[len - 1];
        this.threeScreenVideofile_id = file_id;
        this.cameraUrl = playback;
        this.whiteboardUrl = wb_playback;
      }

      setTimeout(() => {
        if (
          data.direct_seeding.direct_status != "running" &&
          that.videoList.length > 0 &&
          !this.showAutoPlayModal
        ) {
          this.flag = 0;
        }
      }, 1000);
      const Interactive_chat = [];
      data.ds_menu.forEach((item) => {
        if (item.cid == 3) {
          // 图文互动
          that.menus.push(item);
        }
        if (item.cid == 1) {
          Interactive_chat.push(item);
        }
      });
      if (Interactive_chat.length === 0) {
        that.interaction = false;
      } else {
        that.interaction = true;
      }
      for (let j of data.ds_func) {
        Obj[j.module] = j.params || true;
        if (j.module == "before_ad") {
          if (j.params.user_type == 1) {
            that.before_ad = j.params.ad_url;
          } else {
            that.before_ad = JSON.parse(j.params.video_list);
            that.before_ad = that.before_ad[0].url;
          }
        }
        if (j.module == "master") {
          // 主持人功能
          that.hostId = j.params.fans_id;
        }
        if (j.module == "pic_comment") {
          // 图片评论功能
          that.piccomment = true;
        }
        if (j.module == "verify_comment") {
          // 图片评论功能
          that.verify_comment = true;
        }
        if (j.module == "gift") {
          //显示礼物
          that.is_show_gift = true;
        }

        if (j.module == "welcome_user") {
          this.openWelcomeUser = true;
        }

        if (j.module == "shopping_cart") {
          //显示礼物
          that.is_show_cart = true;
          if (j.params.length > 0) {
            const { type, shangpingID } = j.params[0];
            // 如果已经显示过了，再次返回到首页则不再显示购物车弹框
            // const isFirstShow = localStorage.getItem('IS_SHOW_ShOPPING_CART')
            // if(isFirstShow !== '1') {
            this.showShoppingCartType = type;
            // if(type === '3') {
            //   this.showShoppingDialog = true
            // } else if(type === '2') {
            //   this.showShoppingType = true
            // }
            // 标记已显示
            // localStorage.setItem('IS_SHOW_ShOPPING_CART', '1')
            // }
            if (type !== "1") {
              // 二、三购物车样式只会有一个商品信息
              this.goodsInfo = shangpingID[0];
              this.goodsIdsList = [this.goodsInfo.id];
            } else {
              // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
              this.goodsInfo = {};
              this.goodsIdsList = shangpingID;
            }
          }
        }
        // 优惠券
        if (j.module == "coupon") {
          // this.getMyFansLiveCouponInfo(j)
        }
        if (j.module == "consulting_teacher") {
          //显示礼物
          that.showTeacherTab = true;
        }
        //显示图片
        if (j.module == "nav") {
          // if(j.params.length > 0) {
          that.is_show_nav = true;
          // }
          that.menus.push(j);
        }

        if (j.module == "screen_image") {
          that.isShowTeacherQrCode = that.showVideoQrCode = j.enabled == "yes";
          that.teacher_qrcode_title = j.params.title || "";
          that.teacher_qrcode_url = j.params.image || "";

          if (this.teacher_qrcode_url) {
            this.$nextTick(() => {
              let height = this.$refs.add_text_contect.clientHeight;
              if (height == 198) {
                this.$refs.add_text_contect.style.overflowY = "auto";
              } else {
                this.$refs.add_text_contect.style.overflowY = "visible";
              }
            });
          } else {
            this.$nextTick(() => {
              let height = this.$refs.add_text_contect1.clientHeight;
              if (height == 400) {
                this.$refs.add_text_contect1.style.overflowY = "auto";
              } else {
                this.$refs.add_text_contect1.style.overflowY = "visible";
              }
            });
          }
        }
        //自嗨
        if (j.module == "say_self") {
          //自嗨
          that.say_self = {
            enabled: true,
            type: j.params.type,
            all: j.params.all,
          };
        }
        //公告
        if (j.module == "notice") {
          //公告

          that.noticeObj = {
            open: true,
            content: j.params.content,
            time: j.params.time,
          };
          if (that.noticeObj.time != -1) {
            setTimeout(() => {
              that.isNoitceTopShow = false;
            }, parseInt(that.noticeObj.time || 0) * 1000);
          }
        }

        // 是否开启单场观看
        if (j.module === "single_view") {
          that.isOpenSingleWatch = j.enabled === "yes";
        }
        // 是否设置同时在线人数
        if (j.module === "limit_online_user") {
          that.limitOnlineUser = {
            ...j.params,
            isOpen: j.enabled === "yes",
          };
        }

        //     this.axios.post(tool.baseUrlSchool() + "/stu/courseDirect","ds_id=" + this.ds_id).then(res=>{
        //     if (res.data.code == 200) {
        //       if(res.data.data==0){
        //               if (j.module == "running_horse") {
        //               //跑马灯

        //               that.runObj = {
        //                 open: true,
        //                 fontSize: j.params.fontSize,
        //                 fontColor: j.params.fontColor,
        //                 fontTrans: j.params.fontTrans/100
        //               };
        //             }
        //             // 版权声明
        //             if (j.module == "copyright_statement") {
        //               //版权声明

        //               that.copyrightObj = {
        //                 open: true,
        //                 inputValue: j.params.inputValue,
        //                 copyrightTrans: j.params.copyrightTrans/100
        //               };
        //             }
        //       }else{
        //        this.getStatus()
        //       }
        //     }
        // })

        //     if(!this.classid){
        //            // 跑马灯
        //     // if (j.module == "running_horse") {
        //     //   //跑马灯

        //     //   that.runObj = {
        //     //     open: true,
        //     //     fontSize: j.params.fontSize,
        //     //     fontColor: j.params.fontColor,
        //     //     fontTrans: j.params.fontTrans/100
        //     //   };
        //     // }
        //     // // 版权声明
        //     // if (j.module == "copyright_statement") {
        //     //   //版权声明

        //     //   that.copyrightObj = {
        //     //     open: true,
        //     //     inputValue: j.params.inputValue,
        //     //     copyrightTrans: j.params.copyrightTrans/100
        //     //   };
        //     // }
        //  }
      }
      console.log("菜单数据", that.menus);
      console.log("Obj.hot", Obj.hot);
      if (Obj.hot) {
        // 热度显示
        that.showPersonNum = true;
      }

      console.log("Obj.wx_follow==", Obj.wx_follow);
      if (Obj.wx_follow) {
        // 开启观看权限
        if (Obj.wx_follow.wx_isFollow == "yes") {
          that.$alert("此直播间开启了限制观看，请返回手机获取权限", {
            type: "error",
            showClose: false,
            showConfirmButton: false,
          });
          that.allow = false;
          return false;
        }
        that.isShowFocusQrBtn = true;
        that.weixincodeUrl = Obj.wx_follow.pic_url;
        that.weixintopText = Obj.wx_follow.remark;
        that.weixinbottomText = Obj.wx_follow.wx_under_des;
        that.isShowFouceQrCode = Obj.wx_follow.wx_show_now == "yes";
      }
      if (Obj.view_auth) {
        if (
          Obj.view_auth.is_try_see == 0 ||
          Obj.view_auth.view_type == "password_view"
        ) {
          const nTime = new Date().valueOf() - 60 * 60 * 24 * 1000;
          const stime = localStorage.getItem("tengface_password_" + that.ds_id);

          if (!stime || stime < nTime) {
            that.view_auth_http_url = Obj.view_auth.http_url;
            that.view_auth_text = Obj.view_auth.text;
            that.mimaDialogVisible = true;
          }
        }
      }
      //开启白名单观看
      if ((Obj.view_auth && Obj.view_auth.view_type) === "white_num_view") {
        that.isOpenWatchWhite = true;
        that.need_check_bool = Obj.view_auth.need_check == 1;
      }

      if ((Obj.view_auth && Obj.view_auth.view_type) === "account_white_list") {
        that.isOpenAccountwhite = true;
      }

      //门票观看
      if (
        (Obj.view_auth && Obj.view_auth.is_try_see == 0) ||
        (Obj.view_auth && Obj.view_auth.view_type === "ticket_view")
      ) {
        that.$alert("此直播间开启了限制观看，请返回手机获取权限", {
          type: "error",
          showClose: false,
          showConfirmButton: false,
        });
        that.allow = false;
        return false;
      } else {
        that.watch_time = Number(Obj.view_auth && Obj.view_auth.watch_time);
      }

      console.log("check_play", Obj.check_play);
      //开启了登记观看
      if (Obj.check_play) {
        that.iSOpenRegisterViewShow = true;
        that.registerList = Obj.check_play || [];
        for (let index in that.registerList) {
          const obj = that.registerList[index];
          obj.value = "";
          obj.phone = "";
        }
      }

      let option = "uid=" + that.uid + "&ds_id=" + that.ds_id;
      that.axios
        .post(that.beseUrl + "/playback/index", option)
        .then(function (res) {
          var data = res.data;
          if (data.code == 200) {
            localStorage.setItem("tongbu_token", data.token);
            that.videoplay = true;
          } else {
            console.log(data.message);
          }
        });

      that.coverpic = that.direct.pic_url;
      callBack();
    },
    getComment() {
      var that = this;
      var data = {
        ds_id: this.ds_id,
        page_nums: 50,
        order: 0,
        _id: 0,
      };
      if (this.tid) {
        data.tid = this.tid;
      }
      var option = qs.stringify(data);
      that.axios
        .post(that.beseUrl2 + "/comment/index/listsForStudent", option)
        .then(function (res) {
          if (res.data.code == 200) {
            let commlist_tmp = res.data.data.filter((item) => {
              if (item.channel_code) {
                let channel_code_arr = JSON.parse(item.channel_code);
                if (channel_code_arr.indexOf(that.channel_REL_ID) > -1) {
                  return true;
                }
                return false;
              }
              return true;
            });
            that.comlist = commlist_tmp.reverse();
            // that.comlist.forEach(x=>{
            //   if (x.to_fans_id&&!(that.to_fans_idlist.includes(x.to_fans_id))) {
            //     that.to_fans_idlist.unshift(x)
            //   }
            // })
            // console.log(that.to_fans_idlist,'that.to_fans_idlist');
            that.scrollToBottom();
          } else {
            console.log(res.message);
          }
        });
    },
    loginIM() {
      if (this.direct.im_type == 2) {
        //网易IM
        this.loginYunXinIM(1);
      } else {
        //腾讯IM
        const self = this;
        const param = "fans_id=" + this.fans_id;
        self.axios
          .post(tool.baseUrl4() + "/im/getUserSign", param, { timeout: 5000 })
          .then(function (res) {
            console.log("登录", res);
            const data = res.data;
            if (data.code == "200") {
              self.loginIMUserSign(data.data.tl_sign, data.data.app_id);
            } else {
              console.log("网络请求成功");
              self.$message({
                message: data.message || data.msg,
                type: "warning",
              });
            }
          })
          .catch((e) => {
            self.axios
              .post(
                "https://service-jmibg8h4-1317978474.gz.apigw.tencentcs.com/release/api/login/getImUserSign",
                param
              )
              .then(function (res) {
                self.loginIMUserSign(
                  res.data.data.tl_sign,
                  res.data.data.appid
                );
              });
          });
      }
    },
    async loginYunXinIM(type) {
      const self = this;
      const param =
        "fans_id=" +
        this.fans_id +
        "&chatroomId=" +
        this.direct.chatroom_id +
        "&header=" +
        this.userLogin.header +
        "&nick=" +
        this.userLogin.nick;
      this.errorReport({
        search: `云信日志${this.fans_id}`,
        msg: "获取云信token2",
        error: param,
      });
      let yxInfo = null;
      try {
        const imDataNet = await self.axios.post(
          tool.baseUrl4() + "/init/getYxToken",
          param
        );
        yxInfo = imDataNet.data.data;
      } catch (error) {
        this.$TFWebLog.putLogs(10100, 1, { responseData: '云信登录接口失败', error: error });
        const imDataNet = await self.axios.post(
          "https://service-jmibg8h4-1317978474.gz.apigw.tencentcs.com/release/api/login/getYxToken",
          param
        );
        console.error("imDataNet", imDataNet);
        yxInfo = imDataNet.data.data;
      }

      let UserType = "old";
      let channelInfoStr = "";
      try {
        const userparam =
          "ds_id=" +
          this.ds_id +
          "&terminal_type=2" +
          "&channel_ds_code=" +
          this.channel_id;
        const userDataInfo = await self.axios.post(
          tool.baseUrlUser() + "/app/index/getUserDataInfo",
          userparam,
          { timeout: 3000 }
        );
        let firstUser = userDataInfo.data.data.first;
        let newUser = userDataInfo.data.data.new;
        if (firstUser == 1) {
          UserType = "first";
        } else if (newUser == 1) {
          UserType = "new";
        }
        if (userDataInfo.data.data.channel_id) {
          let channelInfo = {
            channel_name: userDataInfo.data.data.channelName,
            channel_id: userDataInfo.data.data.channel_id,
            grouping: userDataInfo.data.data.groupId,
          };
          channelInfoStr = JSON.stringify(channelInfo);
        }
      } catch (error) {}

      //标签
      let marktags = "";
      try {
        const param1 = "fansId=" + this.fans_id;
        const imDataNet = await this.axios.post(
          tool.baseUrl2() + "/tags/getFromFansId",
          param1,
          { timeout: 3000 }
        );
        let marktagsTmp = imDataNet.data.data[this.fans_id];
        if (marktagsTmp && marktagsTmp.length > 0) {
          marktags = JSON.stringify(marktagsTmp);
        }
        console.log("标签===", marktags);
      } catch (error) {
        console.log("标签=error==", error);
      }
      this.myYunXinCustom = [
        this.fans_id || "",
        this.ds_id || "0",
        "0",
        this.channel_id || "0",
        "2",
        "0",
        UserType,
        channelInfoStr,
        marktags,
      ];
      if (yxInfo) {
        let loginParams = {
          appKey: yxInfo.appKey,
          yxToken: yxInfo.yxToken,
          fans_id: this.fans_id,
          nick:
            this.userLogin && this.userLogin.nick
              ? this.userLogin.nick
              : "游客" + this.fans_id,
          header:
            this.userLogin && this.userLogin.header
              ? this.userLogin.header
              : "https://tengface-live.oss-cn-beijing.aliyuncs.com/admin/img/youke_header.png",
          token: yxInfo.token,
          chatroomId: this.direct.chatroom_id,
          ds_id: this.ds_id,
          address: yxInfo.addr,
          tags: [
            this.fans_id || "",
            this.ds_id || "0",
            "0",
            this.channel_id || "0",
            "2",
            "0",
            UserType,
          ],
          custom: this.myYunXinCustom,
        };

        if (type == 1) {
          //im登录
          handleim.loginIM(loginParams, 2, {
            setMsgListener: self.onReceivedMsgCallBack,
            setMemberMsgListener: (json) => {
              console.log("setMemberMsgListener===>", json);
              if (self.commentTab == 1) {
                self.unReadNum = 1;
                self.showUnReadViewFunc(json);
              }
              this.$refs.consultTeacher.setRedPointToTeacher(json.fans_id);
              self.$refs.consultTeacher.onReceivedMsg(json);
            },
            setImStatusListener: (data) => {
              if (data.error == "kicked") {
                this.yxImChatRoomStatusListener("kicked");
              } else if (data.error == 'noconnect') { //断开连接
                setTimeout(() => {
                  if (this.yunxinnetworkStatus) {
                    return;
                  }
                  this.yunxinnetworkStatus = true;
                  this.yxImNoConnectListener();
                }, 1000);
              } else if (data.status == 'connect') { //链接成功
                  // this.yunxinnetworkStatus = false;
                  // clearInterval(this.heardTimer);
                  // this.heardTimer = null;
              } else if (data.error == 'imerror'){
                setTimeout(() => {
                  if (this.yunxinnetworkStatus) {
                    return;
                  }
                  this.yunxinnetworkStatus = true;
                  this.yxImNoConnectListener();
                }, 1000);
                this.$TFWebLog.putLogs(10101, 1, { responseData: '云信IM失败!', error: data.msg });
              }
            },
          });
        } else {
          handleim.loginYunXinChatRoom(loginParams, {
            setImStatusListener: (data) => {
              if (data.error == "kicked") {
                this.yxImChatRoomStatusListener("kicked");
              } else if (data.error == "noconnect") {
                this.yxImNoConnectListener();
              }
            },
          });
        }
      }
    },
    yxImLogListenerCB(message, error) {
      this.errorReport({
        search: `云信日志${this.fans_id}`,
        msg: message,
        error: error,
      });
    },
    yxImNoConnectListener() {
      this.comme_inRequest();
    },
    yxImChatRoomStatusListener(status) {
      if (status == "kicked") {
        this.isyxinImLoginOut = true;
        if (this.heartTimer) {
          clearInterval(this.heartTimer);
          this.heartTimer = null;
        }
        handleim.logout(() => {});
        if (this.linkType == 3 && this.$refs.tfPlayer) {
          this.$refs.tfPlayer.rtcLinkDown();
          this.linkType = 1;
        }
      }
    },
    loginIMUserSign(tl_sign, app_id) {
      const self = this;
      const userInfo = JSON.parse(tool.getCookie("userInfo"));
      const imData = {
        room_id: self.initAllData.direct_seeding.room_id,
        // room_id: '@TGS#aOYDEPXMX',
        fans_id: self.fans_id,
        nick: userInfo && userInfo.nick ? userInfo.nick : "游客" + self.fans_id,
        header:
          userInfo && userInfo.header
            ? userInfo.header
            : "https://tengface-live.oss-cn-beijing.aliyuncs.com/admin/img/youke_header.png",
        tsl_sig: tl_sign,
        app_id: app_id,
      };
      if (tl_sign) {
        localStorage.setItem("tl_sign", tl_sign);
      }
      console.log("IM登录信息", imData);
      handleim.loginIM(imData, 1, {
        setMsgListener: self.onReceivedMsgCallBack,
        setMemberMsgListener: (json) => {
          console.log("IM登录信息", imData);
          if (self.commentTab == 1) {
            self.unReadNum = 1;
            self.showUnReadViewFunc(json);
          }
          self.$refs.consultTeacher.onReceivedMsg(json);
        },
        setImStatusListener: self.imStatusListener,
      });
    },
    playerListener(data) {
      // console.log("data==", data);
      if (data.playType == "vod") {
        this.playerType = "vod";
        if (data.type == "timeupdate") {
          this.currentPlayerData = data;
          if (this.playerType == "vod" && this.currentPlayerData) {
            this.threeScreenVideofile_id =
              this.currentPlayerData.playData.file_id;
            this.currentPlayTime = this.currentPlayerData.currentPlayTime;
            this.videoheartRequest();
          }
          //同步数据  心跳
          if (this.isThreeScreen) {
            if (this.currentPlayerData.playData.file_id) {
              this.currentPlayTime = this.currentPlayerData.currentPlayTime;
            }
            if (!this.asyncthreeScreenTimer) {
              this.asyncthreeScreenTimer = setTimeout(() => {
                this.asyncthreeScreenTimer = null;
                if (this.remainingTime === 0) {
                  this.compareVideoTime();
                }
                console.log(
                  "this.currentPlayTime==",
                  this.currentPlayTime,
                  "getCurrentTime",
                  this.$refs.tfPlayer1.getCurrentTime()
                );
                let asyncTime = this.remainingTime + this.currentPlayTime;
                if (
                  Math.abs(this.$refs.tfPlayer1.getCurrentTime() - asyncTime) >
                  2
                ) {
                  this.$refs.tfPlayer1.setCurrentTime(asyncTime);
                }
              }, 1000);
            }
          }
        } else if (data.type == "play") {
          if (this.isThreeScreen) {
            //三分屏
            this.showAutoPlayModal = false;
            this.$refs.tfPlayer1.play();
          }
        } else if (data.type == "pause") {
          if (this.isThreeScreen) {
            //三分屏
            this.$refs.tfPlayer1.pause();
          }
        } else if (data.type == "speed") {
          if (this.isThreeScreen) {
            //三分屏
            console.log("speed====", data.value);
            this.$refs.tfPlayer1.changePlaySpeed(data.value);
          }
        } else if (data.type == "report") {
          //
          this.$TFWebLog.setCommonKeyValue("player_type", data.data.playType);
          this.$TFWebLog.putLogs(10009, 1, { responseData: data.data.info });
        }
      }
    },
    showUnReadViewFunc(json) {
      this.unReadMsgData = json;
      this.showUnReadView = true;
      setTimeout(() => {
        this.showUnReadView = false;
      }, 4500);
    },
    loadFakeComment() {
      const self = this;
      // 获取服务器时间校准
      var url = tool.baseUrl2() + "/wap/live/getServerTime";
      var option = "";
      this.axios
        .post(url, option)
        .then(function (data) {
          if (data.data.code == 200) {
            const time = data.data.data.time;
            const tempTime =
              new Date(
                self.initAllData.direct_seeding.real_start_time
              ).valueOf() +
              new Date().valueOf() -
              new Date(time).valueOf();
            const startTime = self.getTimes(tempTime);
            console.log(
              "时间校准",
              data.data.data.time,
              self.getTimes(new Date().valueOf())
            );
            const tid = self.initAllData.fakeTemplateId;
            FakeIm.setCommentCallback(self.onReceivedMsgCallBack);
            console.log("校准后时间:", startTime);
            FakeIm.startLoad(startTime, tid, (isOK) => {
              if (isOK) {
                FakeIm.startCommentRun();
              } else {
                self.$message({
                  message: "获取评论失败，请刷新重试",
                  type: "error",
                });
              }
            });
          } else {
            self.$message({
              message: "网络错误" + data.data.message,
              type: "error",
            });
          }
        })
        .catch(function (data) {
          console.log("时间校准错误", data);
          self.$message({
            message: "网络错误" + data.data.message,
            type: "error",
          });
        });
    },
    livestart(json, element) {
      if (!this.checkShowLiveStartDialog(json, element)) {
        return;
      }
      var liveinfo;
      if (json.module == "ds_start") {
        liveinfo = "直播已经开始,点击观看";
      } else {
        liveinfo = "直播已经结束，点击重播";
        this.isShowAttend = false;
      }
      setTimeout(() => {
        window.location.reload();
      }, 8000);
      this.$confirm(liveinfo, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          window.location.reload();
        });
    },
    showQrcode() {
      if (!this.orgStatus) {
        this.$message.warning("该机构已被禁用，直播相关功能限制使用");
        return;
      }
      var that = this;
      process.env == "";
      if (!that.qrcodeShow) {
        that.qrcodeShow = true;
        if (!that.qrcodeObj) {
          setTimeout(function () {
            let appid = that.initAllData.direct_seeding.appid;
            let uid = that.initAllData.direct_seeding.uid;
            console.log(process.env);
            const loginType = that.isLocalCode ? "" : "cloudapi";
            // const host = process.env.BUILD_ENV === 'production' ? 'https://autha.coralclass.cn' : 'https://autha.coralclass.cn'
            // let codeUrl = `https://autha.coralclass.cn/login/#/wx-pc-login?qrcode=${that.qrcodema}&ds_id=${that.ds_id}&appId=${appid}&loginType=${loginType}&uId=${uid}&origin=shanhu`;
            let codeUrl = `${that.myOrgConfig.wechat_auth_domain}/login/#/wx-pc-login?qrcode=${that.qrcodema}&ds_id=${that.ds_id}&appId=${that.myOrgConfig.official_account_appid}&loginType=${loginType}&uId=${uid}&origin=shanhu`;
            if (process.env.BUILD_ENV !== "production") {
              codeUrl = `${codeUrl}&debug=1`;
            }
            console.log('codeUrl: ', codeUrl)
            that.qrcodeObj = new QRCode("qrcode01", {
              width: 120,
              height: 120, // 高度
              // text: `${process.env.BUILD_ENV === "production" ? location.origin : 'https://u.shkt.online'}/pcsaomao/pclogin.html?qrcode=${that.qrcodema}&ds_id=${that.ds_id}&appid=${appid}&uid=${uid}&loginType=${that.isLocalCode ? '' : 'cloudapi'}`, // 二维码内容
              // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
              text: codeUrl,
              background: "white",
            });

            // const qqCodeUrl = `https://autha.coralclass.cn/login/#/qq-pc-login?qrcode=${that.qqqrcodema}&ds_id=${that.ds_id}&appId=${appid}&origin=shanhu`;
            const qqCodeUrl = `${that.myOrgConfig.qq_auth_domain}/login/#/qq-pc-login?qrcode=${that.qqqrcodema}&ds_id=${that.ds_id}&appId=${that.myOrgConfig.official_account_appid}&uId=${uid}&origin=shanhu`;
            new QRCode("qrcode02", {
              width: 120,
              height: 120, // 高度
              text: qqCodeUrl,
              // text:
              //   (process.env.BUILD_ENV === "production" ? location.origin : "https://u.tengface.net") +
              //   "/pcsaomao/?qrcode=" +
              //   that.qqqrcodema +
              //   "&ds_id=" +
              //   that.ds_id +
              //   "&state=qq" +
              //   "&debug=" +
              //   (process.env.BUILD_ENV === "production" ? "" : ""), // 二维码内容
              // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
              background: "white",
            });
          }, 600);

          that.loginTimer = setInterval(function () {
            if (that.isLocalCode) {
              var option = "code=" + that.qrcodema;
              that.axios
                .post(tool.baseUrl2() + "/wap/login/checkCodeStatus", option)
                .then(function (res) {
                  if (res.data.code == 200) {
                    if (res.data.data.status == 3) {
                      clearInterval(that.loginTimer);
                      that.loginTimer = null;
                      const token = res.data.data.token;
                      const userInfo = res.data.data.fans_data;
                      tool.setCookie("userInfo", JSON.stringify(userInfo), 30);
                      tool.setCookie("token", token, 30);
                      window.location.reload();
                    }
                  }
                });
            } else {
              that.axios
                .post(
                  "https://service-jmibg8h4-1317978474.gz.apigw.tencentcs.com/release/api/login/checkCodeStatus",
                  { code: that.qrcodema }
                )
                .then(function (res) {
                  if (res.data.code == 200) {
                    if (res.data.data.status == 3) {
                      clearInterval(that.loginTimer);
                      that.loginTimer = null;
                      const token = res.data.data.token;
                      const userInfo = res.data.data;
                      tool.setCookie("userInfo", JSON.stringify(userInfo), 30);
                      tool.setCookie("token", token, 30);
                      window.location.reload();
                    }
                  }
                });
            }

            var option = "code=" + that.qqqrcodema;
            that.axios
              .post(tool.baseUrl2() + "/wap/login/checkCodeStatus", option)
              .then(function (res) {
                if (res.data.code == 200) {
                  if (res.data.data.status == 3) {
                    clearInterval(that.loginTimer);
                    that.loginTimer = null;
                    const token = res.data.data.token;
                    const userInfo = res.data.data.fans_data;
                    tool.setCookie("userInfo", JSON.stringify(userInfo), 30);
                    tool.setCookie("token", token, 30);
                    window.location.reload();
                  }
                }
              });
          }, 3000);
        }
      }
    },
    showWx() {
      var that = this;
      if (that.wxqrcode == false) {
        that.wxqrcode = true;
        $(".qrcode-box img").addClass("bounceIn");
      } else {
        $(".qrcode-box img").removeClass("bounceIn");
        $(".qrcode-box img").addClass("bounceOut");
        setTimeout(function () {
          that.wxqrcode = false;
          $(".qrcode-box img").removeClass("bounceOut");
        }, 600);
      }
    },
    addPerson(data) {
      // if (data == 1) {
      //   this.view_num++;
      // } else {
      //   this.view_num = data;
      // }
    },
    getTimes(timeStr) {
      var time = new Date();
      if (timeStr) {
        time = new Date(timeStr);
      }
      var year = time.getFullYear();
      var month = tool.two(time.getMonth() + 1);
      var date = tool.two(time.getDate());
      var hours = tool.two(time.getHours());
      var minutes = tool.two(time.getMinutes());
      var seconds = tool.two(time.getSeconds());

      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    onReceivedMsgCallBack(json, element) {
      console.log("收到的消息: ", json, element);
      var that = this;
      if (!json.create_time) {
        json.create_time = this.getTimes();
      }
      switch (json["module"]) {
        case "updateLiveCoupon":
          /* if (this.couponTuijianData.id == json.coupon_id) {
            this.isRecommendVisible = false
          } */
          if (that.showCouponList) {
            that.$refs.couponList.fetch();
          }
          break;
        case "reward_success": // 直播打赏
          this.dialogVisibledas = false;
          this.dialogzhifu = false;
          that.xueyuandslist(Object.assign({}, json));

          break;
        case "enterPerson": // 用户进入
          that.addPerson(1);
          break;
        case "channel_text_comment": //渠道文字评论
          {
            if (
              json.channel_code &&
              (json.channel_code.indexOf(this.channel_REL_ID) > -1 ||
                json.channel_code.indexOf(this.channelGroupID) > -1)
            ) {
              json.content = json.content || "";
              let hasKey = this.comlist.find((item) => {
                return item.key == json.key && item.key;
              });

              if (hasKey) {
                return;
              }

              json.content = json.content
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">");
              json.module = "text_comment";
              this.comlist.push(json);
              if (this.comlist.length > 500) {
                this.comlist.splice(this.comlist.length - 100);
              }
              this.msgScrollBottom();
            }
          }
          break;
        case "teacher_reply_comment": {
          if (json.to_fans_id == this.fans_id) {
            let hasKey = this.comlist.find((item) => {
              return item.key == json.key && item.key;
            });
            if (json.to_fans_id) {
              this.to_fans_idlist.unshift(json);
            }

            if (hasKey) {
              return;
            }
            json.content = json.content
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">");
            json.module = "text_comment";
            this.comlist.push(json);
            // this.comlist.forEach(x=>{
            // if (x.to_fans_id&&!(this.to_fans_idlist.includes(x.to_fans_id))) {
            //   this.to_fans_idlist.unshift(x)
            // }
            // })
            if (this.comlist.length > 500) {
              this.comlist.splice(this.comlist.length - 100);
            }
            this.msgScrollBottom();
          }
          break;
        }
        // 正在购买
        case 'shopping_purchase':
          // this.isHideNickFlag ? `${json.nick[0]}****` :
          // this.ShoppingGuideyi = json
          const nickName = `${json.nick}`;
          this.saveUserBuyList.push(nickName);
          // if (!this.tipsBuyTimer) {
          //   this.showTipsByUserBuyyi();
          // }
          json.name = json.nick
          json.spname = json.goods_name
          json.Buying_now = 1
          this.ShoppingGuide.push(json)
          if (json.Buying_now == 1) {
            this.zzgmsp = this.zzgmsp + 1
          } else {
            this.cggmsp = this.cggmsp + 1
          }
          this.Xansders()
          break;
        // 购买成功
        case 'shopping_success':
          // this.ShoppingGuideyi = json
          this.saveUserBuySuccessList.push(json.nick_name);
          // // this.inventoryNum = json.num;
          // if (!this.tipsBuySuccessTimer) {
          //   this.showTipsByUserBuySuccess();
          // }
          json.name = json.nick_name
          json.spname = json.goods_name
          json.Buying_now = 2
          this.ShoppingGuide.push(json)
          if (json.Buying_now == 1) {
            this.zzgmsp = this.zzgmsp + 1
          } else {
            this.cggmsp = this.cggmsp + 1
            // 评论成单喜报
            if (this.orderform) {
              json.content = json.nick_name
              json.module = 'Buying_now'
              json.header =
                'https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/1%402x.png';
                this.comlist.push(json);
              this.msgScrollBottom();
            }
          }
          this.Xansders()
          break;
        // 购买提示
        case 'purchase_prompt':
          this.showBuyTipsState = json.status === 'yes';
          break;
        case 'Buying_now': //购物车导购
          const nickName1 = json.name
          this.saveUserBuyList.push(nickName1);
          this.ShoppingGuide.push(json)
          if (json.Buying_now == 1) {
            this.zzgmsp = this.zzgmsp + 1
          } else {
            this.cggmsp = this.cggmsp + 1
            // 评论成单喜报
            if (this.orderform) {
              json.content = json.name
              json.header =
                'https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/1%402x.png';
                this.comlist.push(json);
              this.msgScrollBottom();
            }
          }
          this.Xansders()
          // if (json.Buying_now == 1) {
            // const nickName1 = json.name
            // this.saveUserBuyList.push(nickName1);
            // this.showTipsByUserBuy();
          // } else {
            // this.saveUserBuySuccessList.push(json.name);
            // this.inventoryNum = json.num;
          //   this.showTipsByUserBuySuccess();
          // }
          break;
        case "text_comment": // 评论进入
        
        //  关联直播间讲师可看全部发言
        if (this.businessConfigs.teaching_Assistant_speak_segregation) {
          if (!json.hasOwnProperty('showLecturer') && json.ds_id != this.ds_id) { // 是否是讲师发言 && 是否是不同直播间的发言 && 是否是自嗨状态
            return
          }
        } else {
          if (
            this.direct.bind &&
            this.businessConfigs.ds_bind_in_one_room &&
            this.businessConfigs.ds_bind_in_one_room_alone_message &&
            json.terminal_type != 3 &&
            json.ds_id != this.ds_id &&
            !(json.bind == 1 && json.terminal_type == 4)
          ) {
            //主从直播间消息隔离
            return;
          }
        }
          if (json.to_fans_id) {
            this.to_fans_idlist.unshift(json);
          }
          json.content = json.content || "";
          if (json.business_id) {
            for (var i = 0, len = this.comlist.length; i < len; i++) {
              var item = this.comlist[i];
              if (item._id == json._id) {
                if (item.sublist) {
                  json.content = json.content
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
                  item.sublist.push(json);
                } else {
                  json.content = json.content
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
                  that.$set(item, "sublist", [json]);
                }
              }
            }
          } else {
            let hasKey = this.comlist.find((item) => {
              return item.key == json.key && item.key;
            });

            if (hasKey) {
              hasKey._id = json._id;
              return;
            }

            json.content = json.content
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">");
            this.comlist.push(json);
            if (this.comlist.length > 500) {
              this.comlist.splice(this.comlist.length - 100);
            }

            this.msgScrollBottom();
          }
          break;
        case "my_self_hi": //回复嗨消息
          if (
            (this.say_self.enabled == true || this.say_self.all == 1) &&
            json.replyUserItem_content &&
            json.to_fans_id == this.fans_id
          ) {
            json.module = "text_comment";
            if (json.to_fans_id) {
              this.to_fans_idlist.unshift(json);
            }
            json.content = json.content || "";
            if (json.business_id) {
              for (var i = 0, len = this.comlist.length; i < len; i++) {
                var item = this.comlist[i];
                if (item._id == json._id) {
                  if (item.sublist) {
                    json.content = json.content
                      .replace(/&lt;/g, "<")
                      .replace(/&gt;/g, ">");
                    item.sublist.push(json);
                  } else {
                    json.content = json.content
                      .replace(/&lt;/g, "<")
                      .replace(/&gt;/g, ">");
                    that.$set(item, "sublist", [json]);
                  }
                }
              }
            } else {
              let hasKey = this.comlist.find((item) => {
                return item.key == json.key && item.key;
              });

              if (hasKey) {
                hasKey._id = json._id;
                return;
              }

              json.content = json.content
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">");
              this.comlist.push(json);
              if (this.comlist.length > 500) {
                this.comlist.splice(this.comlist.length - 100);
              }

              this.msgScrollBottom();
            }
          }
          break;
        case "share_comment": // 分享得红包
          this.comlist.push(json);
          break;
        case "redpack_comment": // 抢红包
          this.comlist.push(json);
          break;
        case "gift_comment": // 抢红包
          this.comlist.push(json);
          break;
        case "reward_redpacket_comment": // 主办方红包
          this.comlist.push(json);
          break;
        case "update_verify_code": //
          vxxData.verifyCode = json.content.verify;
          break;
        case "ds_start": // 直播开始了
          that.livestart(json, element);
          this.status = "直播";
          break;
        case "ds_end": // 直播结束了
          this.isShowAttend = false;
          that.livestart(json, element);
          this.status = "回看";
          break;
        case "addLikeNum":
          for (var i = 0, len = this.comlist.length; i < len; i++) {
            var item = this.comlist[i];
            if (item._id == json._id) {
              item.like_num++;
            }
          }
          this.total_like++;
          break;
        case "riseData":
          that.addPerson(json.view_num);
          this.total_like = json.like_num;
          break;
        case "delete_comment":
          for (let i = 0; i < this.comlist.length; i++) {
            var item = this.comlist[i];
            console.log(item._id);
            if (item._id == json._id && json.fans_id != this.fans_id) {
              this.comlist.splice(i, 1);
              break;
            }
          }
          break;
        case "agreeLink": // 老师邀请连麦
          this.linkLive(json);
          break;
        case "linkDown": // 下麦操作
          this.linkDown(json);
          break;
        case "teacherOneKeyLinkMic": {
          //老师一键连麦
          this.onkeyLinkMic(json);
          break;
        }
        case "studentOneKeyLinkMicCB": {
          //学生一键连麦
          this.studentOneKeyLinkMicCB(json);
          break;
        }
        case "system_message_group_introduction":
          {
            console.log(
              "system_message_group_introduction===",
              json.online_num
            );
            if (json.online_num != undefined) {
              this.view_num = json.online_num;
              console.log(
                "system_message_group_introduction===",
                this.view_num
              );
            }
          }
          break;
        case "system_message_group_notification":
          {
            // let content = JSON.parse(json.content);
            // if (content.showConsultTeacher != undefined) {
            //   this.showTeacherTab = content.showConsultTeacher == "yes";
            //   if (!this.showTeacherTab) {
            //     this.commentTab = 1;
            //   }
            // }
          }
          break;
        case "wx_follow_change": //是否显示二维码
          this.isShowFouceQrCode = json.params.wx_show_now == "yes";
          this.isShowFocusQrBtn = json.params.wx_show_now == "yes";
          if (this.isShowFouceQrCode) {
            setTimeout(() => {
              this.isShowFouceQrCode = false;
            }, 5000);
          }
          break;
        case "PERSON_IN_BLACK":
          console.log(json.fans_id_list, this.fans_id, "黑名单");
          if (json.fans_id_list.indexOf(`${this.fans_id}`) > -1) {
            if (json.in_black == "yes") {
              this.isBlack = true;
              clearInterval(this.heartTimer);
              this.heartTimer = null;
              location.reload();
            } else {
              location.reload();
              this.isBlack = false;
            }
          }
          break;
        case "PERSON_KICK_OUT":
          if (json.fans_id == this.fans_id) {
            window.location.href = json.to_web;
          }
          break;
        case "GIFT_CHANGE_STATUS": //送花点赞
          if (json.status == "yes") {
            this.is_show_gift = true;
          } else {
            this.is_show_gift = false;
          }
          break;
        case "shopping_cart": // 购物车  shangpingID[0]
          if (json.status == "yes") {
            this.is_show_cart = true;
            const data = JSON.parse(json.params);
            if (data.length > 0) {
              const { type, shangpingID } = data[0];
              this.showShoppingCartType = type;
              if (type !== "1") {
                // 二、三购物车样式只会有一个商品信息
                this.goodsInfo = shangpingID[0];
                this.goodsIdsList = [this.goodsInfo.id];
              } else {
                // 第一种购物车样式会有多个商品信息，im中只有商品id，需要根据id调接口请求商品信息
                this.goodsInfo = {};
                this.goodsIdsList = shangpingID;
              }
            }
          } else {
            this.goodsInfo = {};
            this.goodsIdsList = [];
            this.is_show_cart = false;
            this.showShoppingCartType = "";
          }
          break;
        case "live_student_synchronization": // 同步微信头像昵称
          let timer = setInterval(() => {
            this.studentList();
            this.$message({
              message: "同步成功",
              type: "success",
            });
            this.xianshiersx = false;
            clearInterval(timer);
          }, 2000);
          break;
        case "CONSULTING_TEACHER_STATUS":
          {
            if (json.status == "yes") {
              this.showTeacherTab = true;
            } else {
              this.showTeacherTab = false;
            }
          }
          break;
        case "comment_on_off": //全员静言
          {
            this.is_all_users_muted = json.status == "0";
          }
          break;
        case "show_teacher_qrcode": //是否显示老师二维码
          {
            if (
              this.direct.bind &&
              this.businessConfigs.ds_bind_in_one_room &&
              json.ds_id != this.ds_id
            ) {
              //主从直播间消息隔离
              return;
            }
            this.isShowTeacherQrCode = this.showVideoQrCode = json.open == 1;
            // if (json.open == 1) {
            //   if (this.$refs.tfPlayer.getPlayerIsfullScreen()) {
            //     this.$refs.tfPlayer.exitFullScreen();
            //   }
            // }
            this.teacher_qrcode_title = json.title || "";
            this.teacher_qrcode_url = json.image || "";

            if (this.teacher_qrcode_url) {
              this.$nextTick(() => {
                let height = this.$refs.add_text_contect.clientHeight;
                if (height == 198) {
                  this.$refs.add_text_contect.style.overflowY = "auto";
                } else {
                  this.$refs.add_text_contect.style.overflowY = "visible";
                }
              });
            } else {
              this.$nextTick(() => {
                let height = this.$refs.add_text_contect1.clientHeight;
                if (height == 400) {
                  this.$refs.add_text_contect1.style.overflowY = "auto";
                } else {
                  this.$refs.add_text_contect1.style.overflowY = "visible";
                }
              });
            }
          }
          break;
        case "say_self": {
          //设置自嗨
          if (
            this.direct.bind &&
            this.businessConfigs.ds_bind_in_one_room &&
            json.ds_id &&
            json.ds_id != this.ds_id
          ) {
            //主从直播间消息隔离
            return;
          }
          this.say_self = {
            enabled: json.status == "yes",
            type: json.params.type,
            all: json.params.all,
          };
        }
        case "notice": //公告
          {
            this.noticeObj = {
              open: json.status == "yes",
              content: json.params.content,
              time: json.params.time,
            };
            if (this.noticeObj.open) {
              this.isNoitceTopShow = true;
              if (this.noticeObj.time != -1) {
                setTimeout(() => {
                  this.isNoitceTopShow = false;
                }, parseInt(this.noticeObj.time || 0) * 1000);
              }
            }
          }
          break;
        case "running_horse": //跑马灯
          //   this.axios.post(tool.baseUrlSchool() + "/stu/courseDirect","ds_id=" + this.ds_id).then(res=>{
          //     if (res.data.code == 200) {
          //       if(res.data.data==0){
          //           let paramsObj;
          //       if (json.params) {
          //         paramsObj = JSON.parse(json.params);
          //       } else {
          //         paramsObj = '';
          //       }
          //       this.runObj = {
          //         open: json.status == "yes",
          //         fontSize: paramsObj?paramsObj.fontSize:'',
          //         fontColor: paramsObj?paramsObj.fontColor:'',
          //         fontTrans: paramsObj?paramsObj.fontTrans/100:''
          //       };
          //       if (this.runObj.open) {
          //         this.runHourseShow = true;
          //       }
          //       }else{
          //        this.getStatus()
          //       }
          //     }
          // })
          if (this.classid) {
            this.getStatus();
            console.log("ehoith98423y8888888888888888888");
          } else {
            console.log("ehoit444444444444444");
            console.log(this.classid, "this.classid");
            let paramsObj;
            if (json.params) {
              paramsObj = JSON.parse(json.params);
            } else {
              paramsObj = "";
            }
            this.runObj = {
              open: json.status == "yes",
              fontSize: paramsObj ? paramsObj.fontSize : "",
              fontColor: paramsObj ? paramsObj.fontColor : "",
              fontTrans: paramsObj ? paramsObj.fontTrans / 100 : "",
              remark: paramsObj ? paramsObj.remark : false,
            };
            if (this.runObj.open) {
              this.runHourseShow = true;
            }
          }

          break;
        case "copyright_statement": //版权声明
          //        this.axios.post(tool.baseUrlSchool() + "/stu/courseDirect","ds_id=" + this.ds_id).then(res=>{
          //     if (res.data.code == 200) {
          //       if(res.data.data==0){
          //           let paramsObj;
          //           if (json.params) {
          //             paramsObj = JSON.parse(json.params);
          //           } else {
          //             paramsObj = '';
          //           }
          //           this.copyrightObj = {
          //             open: json.status == "yes",
          //             inputValue: paramsObj?paramsObj.inputValue:'',
          //             copyrightTrans: paramsObj?paramsObj.copyrightTrans/100:''
          //           };
          //           if (this.copyrightObj.open) {
          //             this.copyrightShow = true;
          //           }
          //       }else{
          //        this.getStatus()
          //       }
          //     }
          // })
          if (this.classid) {
            this.getStatus();
          } else {
            let paramsObj;
            if (json.params) {
              paramsObj = JSON.parse(json.params);
            } else {
              paramsObj = "";
            }
            this.copyrightObj = {
              open: json.status == "yes",
              inputValue: paramsObj ? paramsObj.inputValue : "",
              copyrightTrans: paramsObj ? paramsObj.copyrightTrans / 100 : "",
            };
            if (this.copyrightObj.open) {
              this.copyrightShow = true;
            }
          }
          break;
        case "verify_comment": //评论审核
          {
            if (
              this.direct.bind &&
              this.businessConfigs.ds_bind_in_one_room &&
              json.ds_id &&
              json.ds_id != this.ds_id
            ) {
              //主从直播间消息隔离
              return;
            }
            this.verify_comment = json.status == "yes";
          }
          break;
        case "ds_change_rtc": //直播间改变rtc
          {
            if (this.linkType != 3) {
              setTimeout(() => {
                console.log("切换rtc播放");
                this.$refs.tfPlayer && this.$refs.tfPlayer.changePlayType(1);
              }, 500);
            }
          }
          break;
        case "TXWhiteBoardExt": //画板消息
          {
            if (this.$refs.whiteboard) {
              this.$refs.whiteboard.addMessageSyncData(json.content);
            }
          }
          break;
        case "ds_refresh": //刷新直播间
          {
            setTimeout(() => {
              location.reload();
            }, Math.round(Math.random() * 10) * 1000);
          }
          break;
        case "live_question_publish": //老师发布答题
          {
            if (
              this.$refs.tfPlayer &&
              this.$refs.tfPlayer.getPlayerIsfullScreen()
            ) {
              if (tool.isIPad()) {
                window.location.reload();
              } else {
                this.$refs.tfPlayer.exitFullScreen();
              }
            }
            this.LiveanserObj = json;
            this.isShowLiveAnser = true;
          }
          break;
        case "live_question_end": //老师结束答题
          {
            //qpid
            // if (this.LiveanserObj.qpid == json.qpid) {
            this.isShowLiveAnser = false;
            // }
          }
          break;
        case "fans_live": //用户进入欢迎提示
          const cloneJson = JSON.parse(JSON.stringify(json));
          if (!this.showBubbleWelcomeTimer) {
            this.handleShowBubbleWelcome({
              header: cloneJson.header,
              nick: cloneJson.nick,
            });
          }
          this.saveEnterUserList.push(json);
          if (!this.saveEnterTimer) {
            this.showEnterUser();
          }

          break;
        case "pic_comment": //图片评论功能
          {
            this.piccomment = json.status == "yes";
          }
          break;
        case "tags_update": //标签更新
          {
            if (json.fans_id == this.fans_id) {
              //标签更新
              //标签
              this.updateYunxinTags();
            }
          }
          break;
        case "ds_sign": //签到开始
          {
            console.error(json, "jsonjson");
            console.error(json.status, "jsonjsonarrive_time");
            this.Attend_id = json.id;
            this.Attend_title = json.title;
            this.Attend_Btn = json.sign_reminder;
            this.Attend_status = json.status;
            this.AttendCountdown(json.effective);
            this.isShowAttend = true;
          }
          break;
        case "coupon":
          console.log("coupon", json, "IM消息触发了吗?");
          if (json.status == "yes") {
            this.isShowCoupon = true;
            const data = json.params ? JSON.parse(json.params) : [];
            if (data.length > 0) {
              const { coupontuijianData } = data[0];
              // live_type 1公开课直播
              if (this.isObject(coupontuijianData)) {
                this.axios
                  .post(
                    tool.getTestSchoolApi() +
                      "/fansCoupon/getMyFansLiveCouponInfo",
                    qs.stringify({
                      coupon_id: coupontuijianData.coupon_id,
                      live_id: this.ds_id,
                      live_type: 1,
                    })
                  )
                  .then((res) => {
                    if (res.data.code == 200) {
                      this.couponTuijianData = res.data.data;
                      if (res.data.data.get_condition == 1) {
                        // 无限制
                        this.noCouponVisible = false;
                        this.isRecommendVisible = true;
                      } else {
                        // 有限制
                        if (res.data.data.is_satisfy) {
                          // 限制已达成
                          this.noCouponVisible = false;
                          this.isRecommendVisible = true;
                        } else {
                          // 限制未达成
                          this.isRecommendVisible = false;
                          this.noCouponVisible = true;
                          if (res.data.data.get_condition == 2) {
                            this.lookingTime = res.data.data.second_time;
                            this.setLookTime && clearInterval(this.setLookTime);
                            this.setLookTime = null;
                            // 开始计时了
                            this.setLookTime = setInterval(() => {
                              this.lookingTime += 1;
                            }, 1000);
                          }
                        }
                      }

                      this.showCouponList = false;
                      this.showcouponsGoodList = false;
                      if (res.data.data.state == "0") {
                        this.$set(this.couponTuijianData, "statusType", 1);
                      } else if (res.data.data.state == "1") {
                        this.$set(this.couponTuijianData, "statusType", 2);
                      }
                    }
                  });
              } else {
                this.isRecommendVisible = false;
                this.couponPopFlag = false;
              }
            }
          } else {
            this.isShowCoupon = false;
            this.showCouponList = false;
            this.isRecommendVisible = false;
            this.showcouponsGoodList = false;
            this.couponTuijianData = {};
          }
          break;
        default:
          break;
      }
    },
    async updateYunxinTags() {
      //标签
      let marktags = "";
      try {
        const param1 = "fansId=" + this.fans_id;
        const imDataNet = await this.axios.post(
          tool.baseUrl2() + "/tags/getFromFansId",
          param1,
          { timeout: 3000 }
        );
        let marktagsTmp = imDataNet.data.data[this.fans_id];
        if (marktagsTmp && marktagsTmp.length > 0) {
          marktags = JSON.stringify(marktagsTmp);
        }
        if (this.myYunXinCustom.length > 8) {
          this.myYunXinCustom[8] = marktags;
          handleim.updateYunxinMyCustom(this.myYunXinCustom);
        }
      } catch (error) {
        console.log("标签=error==", error);
      }
    },
    imStatusListener(resp) {
      if (resp.ErrorCode == 1) {
        // 网络恢复，需要重新连接
        this.$message({
          type: "error",
          message: "网络恢复正在重新连接聊天室...",
        });

        if (this.outOfTime == 1) {
          this.outOfTime = 2;
        }
        // 重新加载视频
        if (
          this.playerStatus == 2 &&
          this.initAllData.direct_seeding.play_style == "3"
        ) {
          if (this.outOfTime == 2 && this.linkType == 3) {
            // 连麦操作
            this.$refs.tfPlayer.rtcLiveLeave(() => {
              this.$refs.tfPlayer.rtcLink();
            });
          } else {
            this.linkType = 1;
            this.$refs.tfPlayer.rtcLiveLeave(() => {
              this.$refs.tfPlayer.playVideoClicked();
            });
          }
        }
        return;
      }

      if (resp.ErrorCode == 9999) {
        // 网络断开了
        this.$message({
          type: "error",
          message: "聊天室网络中断，将无法收到消息，请检查网络或刷新页面",
        });
      }
    },
    linkLive(data) {
      if (
        this.initAllData.direct_seeding.play_style == 3 ||
        this.initAllData.direct_seeding.play_style == 2
      ) {
        if (data.content == this.fans_id) {
          if (!this.isRTCSupport) {
            console.log("不能连麦");
            handleim.sendCannotLink("1");
            this.$TFWebLog.putLogs(10007, 1, {
              responseData: "学员接收老师的连麦弹框PC-设备不支持",
            });
            return;
          }

          if (this.playerStatus != 2) {
            handleim.sendCannotLink("2");
            this.$TFWebLog.putLogs(10007, 1, {
              responseData: "学员接收老师的连麦弹框PC-没有观看直播",
            });
            return;
          }
          this.linkType = 2;
          this.lianmai2DialogVisible = true;
          this.$TFWebLog.putLogs(10007, 1, {
            responseData: "学员接收老师的连麦弹框PC",
          });
        }
      }
    },
    linkDown(data) {
      if (data.content == this.fans_id) {
        // 需要下麦操作
        this.$refs.tfPlayer.rtcLinkDown();
        this.$TFWebLog.putLogs(10007, 1, {
          responseData: "老师下麦学员消息PC",
        });
      }
    },
    async getFilef(e) {
      const file = e.target.files[0];
      this.occupyImg = await this.cosUpload(this.uid, file);
    },
    imgcomment() {
      this.visible = !this.visible;
      console.log(this.visible);
      if (this.visible == false) {
        this.occupyImg = "";
      }
    },
    ispay(val) {
      var that = this;
      var option = "ds_id=" + this.ds_id + "&fans_id=" + val;
      that.axios
        .post(tool.baseUrl4() + "/directSeeding/ticket/isPayed", option)
        .then(function (res) {
          if (res.data.code == 200) {
            if (res.data.data.is_pay == 0) {
              that.$alert("请先在手机直播间获取权限再来观看", {
                type: "error",
                showClose: false,
                showConfirmButton: false,
              });
              that.isplay = false;
            }
          } else {
            console.log(res.data.code);
          }
        });
    },
    sendSMS(mobile, type) {
      const self = this;
      let option = "mobile=" + mobile + "&sms_type=" + type;
      this.axios
        .post(tool.baseUrl2() + "/wap/index/sendSMS", option)
        .then(function (data) {
          if (data.data.code == 200) {
            self.$message({
              type: "success",
              message: "短信已发送",
            });
            self.phone_text = "60秒重发";
            const timer = setInterval(() => {
              let i = parseInt(self.phone_text);
              if (i == 1) {
                clearInterval(timer);
                self.phone_text = "获取验证码";
                return;
              }
              self.phone_text = i - 1 + "秒重发";
            }, 1000);
          } else {
            self.$message({
              type: "error",
              message: data.data.message,
            });
          }
        })
        .catch(function (data) {
          console.log("错误" + data);
        });
    },
    watchAccountWiteCommit() {
      if (this.account_white_name == "") {
        this.$message({
          type: "error",
          message: "账号不能为空",
        });
        return;
      }

      if (this.account_white_password == "") {
        this.$message({
          type: "error",
          message: "密码不能为空",
        });
      }

      let that = this;
      const option =
        "ds_id=" +
        this.ds_id +
        "&fans_id=" +
        this.fans_id +
        "&account=" +
        that.account_white_name +
        "&password=" +
        that.account_white_password;
      this.axios
        .post(tool.baseUrl2() + "/customer/whiteList/check", option)
        .then(function (data) {
          if (data.data.code == 200 && data.data.data.result) {
            that.$message({
              type: "success",
              message: "登录成功",
            });
            that.accountwhiteShow = false;
            //开启心跳
            that.getHeartMode();
          } else {
            that.$message({
              type: "error",
              message: "校验失败",
            });
          }
        })
        .catch(function (data) {
          // Toast("网络错误！");
          console.log("错误" + data);
        });
    },
    watchWiteCommit() {
      if (this.phone == "") {
        this.$message({
          type: "error",
          message: "手机号不能为空",
        });
        return;
      }

      if (this.need_check_bool && this.smscode == "") {
        this.$message({
          type: "error",
          message: "短信验证吗不能为空",
        });
        return;
      }

      let that = this;
      const option =
        "ds_id=" +
        this.ds_id +
        "&fans_id=" +
        this.fans_id +
        "&mobile=" +
        that.phone +
        "&code=" +
        that.smscode;
      this.axios
        .post(tool.baseUrl2() + "/wap/index/whiteNumCheck", option, {
          mobile: that.phone,
          code: that.smscode,
        })
        .then(function (data) {
          console.log(data);
          if (data.data.code == 200) {
            that.$message({
              type: "success",
              message: "登记成功",
            });
            that.TelTestShow = false;
            //开启心跳
            that.getHeartMode();
          } else {
            that.$message({
              type: "error",
              message: data.data.message,
            });
            console.log(data.data.message);
          }
        })
        .catch(function (data) {
          // Toast("网络错误！");
          console.log("错误" + data);
        });
    },
    async getGoodsList() {
      // const option = `ds_id=211220&goods_id=[125, 131, 130]`
      console.log("this.goodsIdsList", this.goodsIdsList);
      const ids = JSON.stringify(this.goodsIdsList);
      const option = `ds_id=${this.ds_id}&goods_id=${ids}`;
      try {
        const res = await this.axios.post(
          tool.baseUrl2() + "/api/goods/list",
          option
        );
        // const res = await this.axios.post('http://live.shkt.online/liveapi/api/goods/list', option)
        if (res.data.code === 200) {
          this.goodsList = res.data.data.list;
          this.showGoodsList = true;
          this.goodsList.forEach((item) => {
            this.getGoodsNum(item.id);
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    getCurDomainFn() {
      // 测试域名
      let domain = 'https://u.tenghuiketang.com';
      if (this.goodsDomain) {
        // 自定义域名
        domain = `${this.goodsDomain}`;
      } else {
        if (process.env.BUILD_ENV === "production") {
          // 生产域名
          domain = location.origin;
        }
      }
      return domain;
    },
    showGoodsQrCode(id) {
      var uid = this.uid || this.initAllData.direct_seeding.uid;
      if (!this.goodsQrCodeVisiable) {
        this.goodsQrCodeVisiable = true;
        this.previewLink = `${
          this.getCurDomainFn()
        }/#/goodsDetail?id=${id}&uid=${uid}&ds_id=${this.ds_id}&channel_id=${
          this.channel_id
        }&fans_id=${this.fans_id}&platform=wx&yhtoken=${tool.getCookie(
          "token"
        )}`;
        this.aliPreviewLink = `${
          this.getCurDomainFn()
        }/#/goodsDetail?id=${id}&uid=${uid}&ds_id=${this.ds_id}&channel_id=${
          this.channel_id
        }&fans_id=${this.fans_id}&platform=ali&yhtoken=${tool.getCookie(
          "token"
        )}`;

        this.getflag({ goods_id: id }, (flag) => {
          this.platfrom = "";
          this.activeName = "first";
          if (flag == 1) {
            //0全都有 1 微信 2 支付宝 3小程序
            this.platfrom = "wx";
            this.activeName = "first";
          } else if (flag == 2) {
            this.activeName = "second";
            this.platfrom = "ali";
          }
        });
      }
    },
    async getGoodsNum(id) {
      // const option = `ds_id=209972&goods_id=27`
      const option = `ds_id=${this.ds_id}&goods_id=${id}`;
      const {
        data: { code, data },
      } = await this.axios.post(
        tool.baseUrl2() + "/api/goods/goodsInventory",
        option
      );
      if (code === 200) {
        this.goodsList = this.goodsList.map((item) => {
          if (item.id == data.goods_id) {
            item.count = data.count;
            item.infinite = data.infinite;
          }
          return item;
        });
      }
    },
    compareVideoTime() {
      const cameraTime = this.$refs.tfPlayer.getDuration();
      const courseTime = this.$refs.tfPlayer1.getDuration();
      this.remainingTime = courseTime - cameraTime || 0;
    },
    handlePlayerBtnClick(player) {
      if (
        this.$refs.tfPlayer &&
        this.$refs.tfPlayer1.videoStatus == 1 &&
        player === "camera"
      ) {
        this.$refs.tfPlayer1.playVideoClicked();
      }
      if (
        this.$refs.tfPlayer &&
        this.$refs.tfPlayer.videoStatus == 1 &&
        player === "whiteBoard"
      ) {
        this.$refs.tfPlayer.playVideoClicked();
      }
    },
    playVideo() {
      this.showAutoPlayModal = false;
      this.$refs.tfPlayer.playVideoClicked();
      if (this.showThreeLivePlayer) {
        this.$refs.tfPlayer1.playVideoClicked();
      }
    },
    /**
     * 描述：判断是否有重复的开播消息
     * @param   : json {object}， msg {object}
     **/
    checkShowLiveStartDialog(json, msg) {
      if (msg) {
        switch (json.module) {
          case "ds_start":
            const startMsgId = localStorage.getItem(
              "tengface_start_live_msg_id",
              msg.idClient
            );
            if (startMsgId === msg.idClient) {
              return false;
            }
            localStorage.setItem("tengface_start_live_msg_id", msg.idClient);
            break;
          case "ds_end":
            const endMsgId = localStorage.getItem(
              "tengface_end_live_msg_id",
              msg.idClient
            );
            if (endMsgId === msg.idClient) {
              return false;
            }
            localStorage.setItem("tengface_end_live_msg_id", msg.idClient);
            break;
          default:
            break;
        }
        return true;
      }
      return true;
    },
    // 获取预约信息
    getAppointmentData() {
      var option = "ds_id=" + this.ds_id + "&fans_id=" + this.fans_id;
      this.axios.post(tool.baseUrl4() + "/user/dsBook", option).then((res) => {
        if (res.data.code === 200) {
          this.appointmentData = res.data.data;
          this.isAppointmentCheck = res.data.data.status == 1 ? true : false;
          this.isAppointment = true;
        } else {
          this.isAppointment = false;
        }
      });
    },
    // 关闭公众号弹框时随时获取预约信息
    gzhClose() {
      this.PublicHao = false;
      this.getAppointmentData();
    },
    // 获取时间值
    calculateTimeRemaining(futureDateString) {
      // 创建未来时间的Date对象
      const futureDate = new Date(futureDateString);
      // 创建当前时间的Date对象
      const now = new Date();
      // 确保未来时间晚于当前时间
      if (futureDate <= now) {
        clearInterval(this.interval);
        this.exTime = false;
        return;
      }
      this.exTime = true;
      // 计算剩余时间（毫秒）
      const remainingTimeMillis = futureDate - now;

      // 转换剩余时间为天、小时、分钟和秒
      const days = Math.floor(remainingTimeMillis / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (remainingTimeMillis % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (remainingTimeMillis % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((remainingTimeMillis % (1000 * 60)) / 1000);
      return {
        days,
        hours,
        minutes,
        seconds,
      };
    },
    // 预约成功后关闭回调
    messageClose(type) {
      console.log(type, "type");
      this.isAppointmentDialog = false;
      if (type.type === "success") {
        this.getAppointmentData();
      }
    },
    /**
     * 描述：根据权限获取跑马灯和版权声明
     **/
    setRuningLinght() {
      this.axios
        .post(tool.baseUrlSchool() + "/stu/courseDirect", "ds_id=" + this.ds_id)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data == 0) {
              // 跑马灯
              const runingItem = this.initAllData.ds_func.find(
                (fun) => fun.module == "running_horse"
              );
              if (runingItem) {
                this.runObj = {
                  open: true,
                  fontSize: runingItem.params.fontSize,
                  fontColor: runingItem.params.fontColor,
                  fontTrans: runingItem.params.fontTrans / 100,
                  remark: runingItem.params.remark,
                };
              }
              // 版权声明
              const funItem = this.initAllData.ds_func.find(
                (fun) => fun.module == "copyright_statement"
              );
              if (funItem) {
                this.copyrightObj = {
                  open: true,
                  inputValue: funItem.params.inputValue,
                  copyrightTrans: funItem.params.copyrightTrans / 100,
                };
              }
              console.log(runingItem, funItem, "llllllllllllllllllllllllll");
            } else {
              this.getStatus();
            }
          }
        });
    },
    isObject(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          return true;
        }
      }
      return false;
    },
    /**
     * 描述：校验当前机构状态是否正常，机构可能被禁用或者被删除
     * @return  : {orgStatus} true: 机构状态正常 false：机构状态异常，被禁用或者被删除
     **/
    async checkOrgIsForbidden() {
      return new Promise((resolve, reject) => {
        this.axios
          .post(`${tool.baseUrl2()}/wap/live/getServerTime`, `uid=${this.uid}`)
          .then(({ data: { code, data } }) => {
            this.$TFWebLog.putLogs(10000, 1, { responseData: {
              discription: '机构是否被禁用',
              uId: this.uid,
              channelId: this.channel_id,
              dsId: this.ds_id,
              tId: this.tid,
              code,
              data
            } })
            // stasus: 0: 正常    1: 禁用   2: 删除  如果没有status字段，orgStatus也需要返回true，不要两个判断合并成!data.status，不利于后期维护
            if (code === 200 && (data.status === 0 || !data.status)) {
              resolve({ orgStatus: true });
            } else {
              this.$confirm("该机构已被禁用，直播相关功能限制使用", "提示", {
                showClose: false,
                showConfirmButton: false,
                showCancelButton: false,
                closeOnClickModal: false,
                type: "error",
              });
              // 如果已经登录的用户，清除用户登录信息
              tool.delCookie("userInfo");
              tool.delCookie("token");
              resolve({ orgStatus: false });
            }
          });
      });
    },
    /**
     * 校验当前用户是否已经观看过该直播
     **/
    checkIsSingleWatch() {
      return new Promise(async (resolve, reject) => {
        if (this.isOpenSingleWatch && this.fans_id) {
          // 校验是否已经观看过直播
          const {
            data: { code, data },
          } = await this.axios.post(
            `${tool.getShanHuHyLiveApi()}/caption/singleCheck`,
            `fans_id=${this.fans_id}&ds_id=${this.ds_id}`
          );
          if (code === 200 && data === 1) {
            resolve({ canWatch: false });
          } else {
            resolve({ canWatch: true });
          }
        } else {
          resolve({ canWatch: true });
        }
      });
    },
    /**
     * 获取当前直播在线人数
     **/
    getLiveRoomOnlineUser() {
      return new Promise(async (resolve, reject) => {
        if (this.limitOnlineUser.isOpen && this.limitOnlineUser.num > 0) {
          const {
            data: {
              code,
              data: { list },
            },
          } = await this.axios.post(
            `${tool.baseUrlUser()}/app/index/getOnlineDetailList`,
            `ds_id=${this.ds_id}`
          );
          const audiences = list.filter((user) => !user.teacher);
          if (
            code === 200 &&
            this.limitOnlineUser.num <= audiences.length &&
            this.checkLoginUserIsNotOnlineUser(audiences)
          ) {
            resolve({ status: false, onlineUser: list });
          } else {
            resolve({ status: true, onlineUser: list });
          }
        } else {
          resolve({ status: true, onlineUser: [] });
        }
      });
    },
    /**
     * 校验当前登录的用户是否是在线列表的用户，如果是，则可以继续观看，如果不是，则不能观看
     **/
    checkLoginUserIsNotOnlineUser(list) {
      return list.every((user) => user.fans_id !== this.fans_id);
    },
    /**
     * 描述：更新用户完课和到课标签（type 1完课标签 2到课标签 ）
     **/
    updateUserTag(type) {
      this.axios.post(`${tool.getTestSchoolApi()}/trainCamp/campFollowWechatTag`, `live_id=${this.ds_id}&live_type=1&tag_type=${type}`)
    },
    /**
     * 描述：进入所有直播间用户渠道锁客
     **/
    setUserEnterRoomTag() {
      return new Promise((resolve, reject) => {
        this.axios.post(`${tool.getTestSchoolApi()}/trainCamp/goTrainCampLive`, `live_id=${this.ds_id}&live_type=1&channel_code=${this.channel_id}`).then(({ data: { code, data } }) => {
          // is_locked: true: 已锁客，表示当前用户已经进其他的渠道，需要跳转到锁客页面 false: 未锁客
          if(code === 200 && data) {
            resolve({ isLock: data.is_locked ,is_limit_we_com:data.is_limit_we_com })
          } else {
            resolve({ isLock: false ,is_limit_we_com: false})
          }
        }).catch(() => {
          resolve({ isLock: false ,is_limit_we_com: false })
        })
      })
    },
    /**
     * 描述：检测训练营是否在期限内，不在则不能观看
     **/
     checkCampLiveIsExpired() {
      return new Promise((resolve, reject) => {
        this.axios.post(`${tool.getTestSchoolApi()}/trainCamp/checkTrainCampPeriod`, `live_id=${this.ds_id}&live_type=1`).then(({ data: { code, data } }) => {
          // data（ture：则代表当前直播间已过期，不能观看    false: 可以观看）
          if(code === 200 && data) {
            resolve({ isExpried: true })
            this.$confirm("该训练营直播间已经过了有效期", "提示", {
              showClose: false,
              showConfirmButton: false,
              showCancelButton: false,
              closeOnClickModal: false,
              type: "error",
            })
          } else {
            resolve({ isExpried: false })
          }
        }).catch(() => {
          resolve({ isExpried: false })
        })
      })
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

input {
  outline: none;
}

body {
  background-color: #151515;
}
.chengdan_xibao {
  width: 280px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  text-align: center;
  color: #FF6259;
  margin: 0 auto;
  margin-top: 16px;
  line-height: 20px;
}
.bug-tipsyi {
  display: flex;
  /* align-items: center; */
  position: absolute;
  /* left: -226px; */
  right: 118px;
  width: 300px;
  min-height: 36px;
  background: #4d4d56;
  border-radius: 8px;
  /* min-height: 20px; */
  z-index: 10003;
  transition: all 0.3s;
}
.bug-tipsyi.show {
  right: 118px;
}
.bug-tipsyi.user-buy-goods.hide {
  animation: fadeOut 2s ease-out forwards;
  /* right: 0; */
  /* top: 58%; */
}
.bug-tipsyi.user-buy-goodsyi.hide {
  animation: fadeOut 2s ease-out forwards;
  /* right: 0; */
  /* top: 58%; */
}
@keyframes fadeOut {
  from { opacity: 1; }
  to { opacity: 0; }
}
.bug-tipsyi.user-buy-goodsyi {
  top: 66%;
  left: 16px;
  background: #4d4d56;
  /* animation: fadeOut 0.5s ease-out forwards; */
}
.bug-tipsyi.user-buy-goods {
  /* animation: fadeOut 0.5s ease-out forwards; */
  top: 56%;
  left: 16px;
  background: #4d4d56;
}
.bug-tipsyi.buy-goods-successyi {
  width: fit-content;
  top: 65%;
  background: #4d4d56;
}
.bug-tipsyi.buy-goods-success {
  width: fit-content;
  top: 60%;
  background: #4d4d56;
}
.bug-tipsyi.buy-goods-success.hide {
  opacity: 0;
  /* top: 66%; */
}
.bug-tipsyi img {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  margin-top: 8px;
}
.bug-tipsyi .zhenzam {
  width: 44px;
  height: 17px;
  background: rgba(255,255,255,0.10);
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #ff8982;
  margin-top: 8px;
  margin-left: 4px;
  margin-right: 4px;
  text-align: center;
  line-height: 17px;
}
.bug-tipsyi .tipsyi {
  width: 209px;
  min-height: 20px;
  overflow-wrap: break-word;
  align-items: center;
  margin: 8px 0;
  color: #FF6259;
  font-size: 14px;
  line-height: 20px;
  /* margin-left: 4px; */
}
.weixingz .weixingb {
  height: 20px;
  position: absolute;
  left: 388px;
  top: 24px;
}
.weixingz .weixinbott {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #20242f;
}
.weixingz .weixinhd {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: center;
  color: #20242f;
  padding-top: 54px;
  margin-bottom: 24px;
}
.weixingz >>> .el-dialog__header {
  padding: 0;
}
.weixingz >>> .el-dialog__body {
  padding: 0;
}
.guanbitbewm {
  font-size: 14px;
  font-family: Noto Sans SC, Noto Sans SC-400;
  font-weight: 400;
  text-align: center;
  color: #202020;
  margin-top: 12px;
}
.tbtanzhuang >>> .el-dialog__body {
  height: 250px;
  padding: 0;
}
.tbtanzhuang >>> .custom-confirm .el-dialog__body {
  padding: 0;
}
.tbtanzhuang >>> .el-dialog__header {
  padding: 0;
}
.video-title {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 42px;
  color: #20242f;
  font-size: 18px;
  font-weight: 400;
  padding-top: 10px;
  box-sizing: border-box;
}
.video-title:hover {
  color: #1872ed;
}
.watch-replay {
  width: 88px;
  height: 30px;
  border: 1px solid #1872ed;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  color: #1872ed;
  font-size: 14px;
  font-weight: 400;
}
.watch-living {
  width: 88px;
  height: 30px;
  background: #1872ed;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}
.systbtx {
  text-align: center;
  margin-top: 12px;
  padding-bottom: 20px;
  font-size: 12px;
  font-family: Noto Sans SC, Noto Sans SC-400;
  font-weight: 400;
  color: #202020;
  border-bottom: 1px solid #dee2e9;
}
.Public_gb {
  font-size: 14px;
  font-family: Noto Sans SC, Noto Sans SC-400;
  font-weight: 400;
  color: #202020;
  margin-top: 12px;
  padding-bottom: 12px;
  cursor: pointer;
}
.Public_gz {
  font-size: 12px;
  font-family: Noto Sans SC, Noto Sans SC-400;
  font-weight: 400;
  color: #202020;
  margin-top: 16px;
}
.Public_gk {
  width: 100%;
  height: 0px;
  border-bottom: 1px solid #dee2e9;
  margin-top: 19px;
}
.Public_ewm {
  width: 120px;
  margin: 0 auto;
}
.Public_hz {
  text-align: center;
}
.Public_tk >>> .el-dialog__title {
  font-size: 14px;
  font-family: Noto Sans SC, Noto Sans SC-400;
  font-weight: 400;
  color: #202020;
}
.live {
  min-width: 1220px;
  height: 100%;
  background-color: #151515;
}
.dashang_input {
  width: 172px;
  height: 30px;
  background: linear-gradient(179deg, #ffe6cc 0%, #fbcda1 100%);
  border-radius: 2px;
  color: #faa14e;
  border: none;
  text-align: center;
  padding: 0 5px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
}
.hongbaose input::placeholder {
  color: #faa14e;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
}
.liBackgroundyi {
  border: 1px solid #08c97e;
  height: 40px;
}
.weixinlist {
  width: 158px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #dee2e9;
  text-align: center;
  line-height: 40px;
}
.smhuayu {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.liBackground {
  border: 1px solid #08c97e;
}
.dashanger >>> .el-button--primary {
  line-height: 9px;
}
.dashanger >>> .el-dialog {
  border: none;
  box-shadow: none;
}
.shengminglist >>> .el-dialog__title {
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.shengminglist >>> .el-button--primary {
  color: #fff;
  width: 142px;
  height: 30px;
  background: linear-gradient(126deg, #73aaff 10%, #0053ff 90%);
  border-radius: 15px;
  line-height: 9px;
}
.fuwusheng {
  font-size: 10px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  margin-top: 6px;
}
.hongbaose {
  margin: 0 auto;
  width: 212px;
  height: 122px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 110.28px;
  overflow: hidden;
}
.qianys {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #ff4500;
}
.hongbaose >>> .el-input__inner {
  border: none;
  width: 172px;
  height: 30px;
  background: linear-gradient(179deg, #ffe6cc 0%, #fbcda1 100%);
  border-radius: 2px;
}
.dashangyuan {
  text-align: center;
  line-height: 36px;
  width: 52px;
  height: 36px;
  background: linear-gradient(179deg, #ffe6cc 0%, #fbcda1 100%);
  border-radius: 3px;
  margin-left: 8px;
}
.dashanger >>> .el-dialog {
  background: rgba(0, 0, 0, 0);
  border: none;
}
.dashanghb {
  overflow: hidden;
  width: 316px;
  height: 316px;
  background-image: url(../assets/imgs/hongbao.png);
  background-size: 100% 100%;
}
.index_contain {
  min-width: 1220px;
  /* max-width: 1504px; */
  margin-left: auto;
  margin-right: auto;
  padding: 0 5%;
  width: 100%;
  box-sizing: border-box;
}

.head {
  padding: 20px 0;
}

.head h2 {
  font-size: 24px;
  color: #000;
  line-height: 24px;
  display: inline-block;
}

.head .select {
  font-size: 12px;
  padding: 0px 5px;
  background: #ff8834;
  color: #fff;
  border-radius: 3px;
  line-height: 20px;
  margin: 2px 0 0 6px;
}

.text p {
  margin-top: 10px;
}

.text span {
  margin-right: 10px;
}

.text a {
  color: #1087dc;
}

.tips {
  margin-top: 10px;
}

.tips span {
  margin-right: 10px;
}

.tips p span {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid black;
}

.viewnum {
  text-align: right;
  margin-bottom: 10px;
  float: left;
}

.report {
  margin-right: 10px;
}

.explaner {
  background: #fff;
  padding: 10px 0 30px;
}

.explan {
  /* border: 1px solid #e8e9eb; */
}

.explan .title {
  padding: 10px;
  font-size: 18px;
  /* border-bottom: 1px solid #e8e9eb; */
}

.explan p {
  padding: 10px;
  line-height: 24px;
}

.playbox {
  position: relative;
  display: flex;
}

.auto-play-modal {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  z-index: 102;
}

.user-click-paly-btn {
  width: 114px;
  height: 34px;
  background: linear-gradient(108deg, #73aaff 0%, #0053ff 100%);
  border-radius: 20px;
  border: none;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.user-click-paly-btn .play-content {
  display: flex;
  align-items: center;
}

.user-click-paly-btn img {
  margin-right: 5px;
}

.player {
  flex: 3.6;
  position: relative;
  padding-top: 44%;
  background: black;
}
.player .bubble-wrap {
  position: absolute;
  height: 150px;
  left: 10px;
  bottom: 50px;
  z-index: 999;
  display: flex;
  flex-direction: column-reverse;
}
.player .bubble-wrap .bubble-welcome {
  z-index: 999;
  padding: 3px 10px 3px 4px;
  height: 26px;
  line-height: 26px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  transition: all 0.5s ease;
  margin: 3px 0;
}
.player .bubble-wrap .bubble-welcome img {
  z-index: 999;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.player .bubble-wrap .bubble-welcome span {
  z-index: 999;
  margin-left: 4px;
  color: #ffb302;
}

.player_content {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  text-align: center;
}

.player .appointmentTime {
  position: absolute;
  left: calc(50% - 150px);
  top: 20%;
  width: 300px;
  text-align: center;
  z-index: 999;
}
.timeMessage {
  color: #fff;
  font-size: 16px;
}
/* 预约按钮 */
.appointment {
  position: absolute;
  right: 16px;
  bottom: 216px;
  z-index: 99;
}
.appointment .appointment-confirm {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 46px;
}
.appointment .appointment-confirm img {
  width: 100%;
}
.appointment .appointment-confirm span {
  font-size: 12px;
  margin-top: 6px;
  color: #1872ed;
  text-align: center;
}
.appointment .appointment-confirm .cancel {
  color: #fff;
}

.exactTime {
  margin-top: 14px;
  font-size: 16px;
  color: #fff;
}
.exactTime span {
  font-size: 26px;
  padding-right: 4px;
}

.vcp-poster-pic {
  width: 100%;
}

.reward {
  height: 46px;
  line-height: 46px;
  padding: 0 10px;
  background: #222222;
}

.comment {
  /* flex: 1; */
  width: 360px;
  position: relative;
  overflow: hidden;
  /* padding-bottom: 45%; */
  background-color: #151515;
}

.consultTeacher {
  position: absolute;
  width: 100%;
  top: 40px;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: rgb(54, 54, 54);
  bottom: 139px;
}

.new-comment-tipsmsg {
  position: absolute;
  bottom: 146px;
  right: 0;
  line-height: 24px;
  text-align: center;
  width: 100px;
  height: 24px;
  border-radius: 12px;
  background-color: #ffffff;
  z-index: 1000;
  transform: translate(-50%, 0px);
  cursor: pointer;
}

.list {
  bottom: 139px;
  overflow-y: scroll;
  position: absolute;
  width: 100%;
  top: 40px;
  left: 0;
  box-sizing: border-box;
  background-color: rgb(54, 54, 54);
}

.goods-list {
  bottom: 139px;
  /* overflow-y: auto; */
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0;
  box-sizing: border-box;
  z-index: 2000;
  background-color: rgb(255, 255, 255);
}

.goods-list .close-btn {
  width: 17px;
  position: absolute;
  right: 10px;
  top: 12px;
  cursor: pointer;
}

.list::-webkit-scrollbar {
  display: none;
}

.list li {
  padding: 10px;
  position: relative;
}

.list li:last-child {
  border: none;
}

.list li .headimg {
  width: 36px;
  height: 36px;
  display: block;
  border-radius: 50%;
  overflow: hidden;
}

.list li .headimg img {
  width: 100%;
}

.list .msg {
  padding-left: 50px;
  line-height: 18px;
}

.list .username .list .time {
  color: #6f6e6e;
}

.list .time {
  font-size: 12px;
}

.list .content {
  color: black;
  padding: 10px 0;
  word-break: break-all;
}

.publish {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 139px;
  box-sizing: border-box;
  background-color: #232323;
  padding: 0px 10px;
}

.loginBox {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50px;
  line-height: 50px;
  padding: 0px 10px;
}

.input {
  height: 32px;
  border: none;
  /* background: #545454; */
  color: #aaaa97;
  padding: 0 5px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  width: 80%;
  box-sizing: border-box;
}

.input:focus {
  outline: none;
}

.publish a {
  display: inline-block;
  height: 32px;
  /* background: #999; */
  color: #ccc;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 20%;
  text-align: center;
  margin-left: -2px;
  vertical-align: middle;
}

.publish a:active {
  background: #8b8989;
}

.qrcodebox {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 10000;
}

.qrcodebox .qrcode-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bshare-custom {
  /*margin-top: 20px;*/
}

.input {
  height: 32px;
  border: none;
  background: #e8e9eb;
  color: black;
  padding: 0 5px;
  border-radius: 5px;
  width: 95%;
  margin: auto;
  display: block;
  box-sizing: border-box;
}

.input:focus {
  outline: none;
}

.publish a {
  display: inline-block;
  height: 32px;
  background: #999;
  color: #ccc;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 20%;
  text-align: center;
  margin-left: -2px;
  vertical-align: middle;
  position: relative;
}

.publish a:active {
  background: #8b8989;
}

.publish .bottom-button {
  display: inline-block;
  height: 32px;
  background: #ff8a00;
  color: white;
  border: none;
  outline: none;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 16%;
  text-align: center;
  margin-right: 8px;
  vertical-align: middle;
  cursor: pointer;
  line-height: initial;
  float: right;
}

/*.publish .bottom-button:hover {
    background: rgba(255, 255, 255, .2);
  }*/

.publish .quick-button {
  display: inline-block;
  /* height: 32px; */
  padding: 5px 5px;
  background: #ff8a00;
  color: white;
  border: none;
  outline: none;
  text-align: center;
  margin-left: 5px;
  vertical-align: middle;
  cursor: pointer;
  line-height: initial;
}

.publish .quick {
  position: absolute;
  bottom: 146px;
  width: 80%;
  overflow: auto;
  max-height: 400px;
}

.publish div li {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  /*width: 70%;*/
  background: rgba(0, 0, 0, 0.6);
  margin-bottom: 1px;
  cursor: pointer;
  line-height: 16px;
  padding: 10px 0px;
  padding-left: 10px;
}

.quickArrow {
  width: 30px;
  height: 30px;
  transform: translateX(-50%);
  transform: rotate(45deg);
  /*background-color: rgba(0, 0, 0, .6);*/
  position: absolute;
}

.vcp-player span {
  position: absolute;
  top: 10px;
  left: 20px;
  display: block;
  padding: 10px;
  color: #336688;
}

.phoneQrcode {
  float: left;
  font-size: 18px;
  margin-top: 4px;
  cursor: pointer;
  margin-right: 10px;
  position: relative;
}

#qrcode01 {
  position: relative;
}

#qrcode01 > img {
  width: 100%;
}

/* #qrcode01 {
  position: absolute;
  top: -225px;
  left: 0;
  box-shadow: 0 0 15px #d6d6d6;
  padding: 5px;
  background: white;
  width: 210px;
  z-index: 1000;
} */

/*评论列表*/

.red-pack {
  /*margin-left: 52px;*/
  margin-top: 5px;
  padding-bottom: 15px;
  /*width: 78%;*/
  overflow: hidden;
}

.red-pack-header {
  background-color: #f99c3a;
  min-height: 65px;
  border-radius: 4px;
}

.red-pack-header-radius {
  border-radius: 4px 4px 0px 0px;
}

.red-pack-img {
  float: left;
  height: 40px;
  width: 38px;
  margin-top: 13px;
  margin-left: 15px;
}

.red-pack-title {
  margin-top: 0px;
  color: white;
  /*padding-top: 15px;*/
  padding-right: 10px;
  font-size: 13px;
  margin-left: 60px;
  /*white-space: nowrap;*/
}

.red-pack-desc {
  font-size: 10px;
  margin-top: 3px;
  padding-right: 5px;
  padding-top: 14px;
}

.red-pack-body {
  background-color: #f5f5f5;
  border-radius: 0px 0px 4px 4px;
}

.red-pack-item {
  height: 38px;
  line-height: 38px;
  font-size: 12px;
  margin-left: 15px;
}

.red-pack-item-name {
  color: black;
  font-size: 12px;
  max-width: 170px;
  overflow: hidden;
  height: 38px;
}

.red-pack-item-text {
  color: #555555;
  font-size: 12px;
}

.red-pack-item-money {
  color: #f99c3a;
  font-size: 12px;
}

.red-pack-item-time {
  float: right;
  font-size: 11px;
  color: #ccc;
  margin-right: 10px;
}

.gift {
  width: 25%;
}

/*微信授权二维码*/

#qrcode {
  background: white;
}

/*点赞*/

.tools {
  position: absolute;
  top: 12px;
  right: 0;
}

.zanbar {
  float: right;
  margin-right: 12px;
  color: #343434;
}

.type .zanbar {
  color: #ff0000;
}

.zanbar img {
  width: 14px;
  vertical-align: middle;
  cursor: pointer;
}

.zanbar span {
  vertical-align: middle;
  font-size: 12px;
  color: black;
}

.bshare-more {
  font-size: 16px;
}

.footerbox {
  display: flex;
  background-color: #2d2d2d;
}

.sharebox {
  flex: 4;
  background-color: #2d2d2d;
  color: #cccccc;
  padding: 10px;
}

.bshare-custom #bshare-shareto {
  color: #cccccc !important;
}

#id_test_video,
#webRtcVideoBox {
  width: 100%;
  height: 100%;
}

.pinglunBox {
  position: relative;
}

.boxshow {
  width: 95%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
}

.sublist {
  border-top: #dbdbdb 1px solid;
  font-size: 15px;
  background: #f5f5f5;
}

.sublist .title {
  padding: 10px 10px 0;
  color: #929292;
}

.sublist .title .time {
  font-size: 12px;
}

.sublist-p {
  font-size: 13px;
  padding: 10px;
}

.giftinfo {
  padding-top: 10px;
}

.videoBox {
  margin-top: 20px;
}

.videoBox p {
  font-size: 20px;
  font-weight: bold;
}

.videoBox ul {
  margin-top: 20px;
}

.videoBox li {
  display: inline-block;
  background: white;
  overflow: hidden;
  margin-right: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  /* padding: 10px; */
  /* max-width: 240px; */
}

.videoBox li span {
  display: block;
  word-break: keep-all;
  white-space: nowrap;
  width: 95%;
  margin: auto;
  overflow: hidden;
}

.secectBackground {
  background-color: #f56c6c !important;
  border-radius: 5px;
  color: white;
}

.msg_conent {
  background-color: #ffeb12;
  padding: 12px 15px;
  border: 1px solid #a47214;
  border-radius: 10px;
  word-wrap: break-word;
}

.xinxin1 {
  position: absolute;
  top: 50px;
  left: 20px;
  width: 30px;
}

.xinxin2 {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 20px;
}

.xinxin3 {
  position: absolute;
  bottom: 0px;
  width: 50px;
  right: 0px;
}

.rank {
  position: absolute;
  top: 40px;
  width: 55px;
  left: 0px;
}

.hostman {
  border: 2px solid #ffd800;
}

.liveImg {
  width: 100%;
  height: 100%;
}

.comment .unReadView {
  position: absolute;
  top: 40px;
  right: 20px;
  min-width: 50px;
  max-width: 200px;
  min-height: 30px;
  background-color: white;
  z-index: 3000;
  border-radius: 5px;
  line-height: 30px;
  padding-left: 5px;
  padding-right: 5px;
  word-wrap: break-word;
  word-break: normal;
}

.comment .unReadView .header {
  width: 26px;
  height: 26px;
  border-radius: 13px;
  vertical-align: -8px;
}

.comment .unReadView .sanjiao {
  width: 0px;
  height: 0px;
  border-left: 10px solid rgba(0, 0, 0, 0);
  border-right: 10px solid rgba(0, 0, 0, 0);
  border-bottom: 10px solid #fff;
  position: absolute;
  top: -10px;
  right: 40%;
}

.commentHeader {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 40px;
  z-index: 1;
  background-color: rgb(54, 54, 54);
  border-bottom: 1px solid #f5f5f5;
}

.commentHeader .item {
  float: left;
  display: inline-block;
  width: 50%;
  height: 100%;
  color: white;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  position: relative;
}

.commentHeader .item .redPoint {
  width: 12px;
  height: 12px;
  display: inline-block;
  position: absolute;
  top: 14px;
  left: 15px;
  background-color: red;
  border-radius: 8px;
}

.commentHeader .width100 {
  width: 100%;
}

.commentHeader .select {
  background-color: #f5f5f5;
  color: rgb(54, 54, 54);
}

/* @media only screen and (min-width: 1500px) {
    .comment {
      width: 330px;
    }
    .publish {
      width: 330px;
    }
  } */

.commentimg {
  max-width: 100%;
}

.more {
  text-align: center;
  cursor: pointer;
}

.inputbox {
  position: absolute;
  top: -30px;
  width: 100%;
}

.pinglunimg {
  width: 32px;
}

.imgcommentbox {
  margin-left: 5px;
  display: inline;
}

.player_two,
.player_two > .video-js {
  width: 100%;
  height: 100%;
}

#player-container-id {
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding-top: 56.25%;
  /* 计算方式：播放器以16：9的比率显示，这里的值为 9/16 * 100 = 56.25  */
}

/* 外部容器也需要是自适应的*/
#wrap {
  min-width: 1220px;
  max-width: 1504px;
  width: 80%;
}

/* 设置logo在高分屏的显示样式 */

@media only screen and (min-device-pixel-ratio: 2),
  only screen and (-webkit-min-device-pixel-ratio: 2) {
  .tcp-logo-img {
    width: 50%;
  }
}

.flashbox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: black;
}

.flashbox p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 30px;
  text-align: center;
}

.flashbox p a {
  color: red;
}

.status {
  display: inline-block;
  background-color: #42b983;
  width: 56px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 14px;
  color: white;
  border-radius: 4px;
  vertical-align: middle;
}

.inputText {
  background-color: #373438;
  border: none;
  color: white;
  padding: 10px;
  outline: none;
  resize: none;
}

.baseTab {
  font-size: 18px;
  color: white;
  padding: 10px 0;
  width: 84px;
  text-align: center;
  cursor: pointer;
}

.baseTabActive {
  color: #10dbff;
  border-bottom: 2px solid #10dbff;
}

.loginAction {
  border-bottom: 2px solid #1087dc;
}

.loginbtn {
  margin-top: 30px;
  height: 40px;
  line-height: 40px;
  background: rgba(0, 140, 248, 1);
  border-radius: 30px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  text-align: center;
}
</style>

<style>
.Attend_Box_finsh .el-dialog {
  width: 303px;
  height: 342px;
  background: url(../assets/imgs/签到完成.png) no-repeat;
  background-size: cover;
  box-shadow: none;
}
.Attend_Box_finsh .el-dialog__body {
  padding-top: 140px;
}

.Attend_Box_finsh .Attend_Box_conect {
  margin-top: 50px;
}

.Attend_Box_text {
  height: 29px;
  font-size: 20px;
  font-weight: 500;
  color: #1872ed;
}
.Attend_Box_btn {
  margin-top: 30px;
  height: 40px;
  line-height: 40px;
  background: rgba(0, 140, 248, 1);
  border-radius: 30px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  text-align: center;
}

.Attend_Box .el-dialog {
  width: 303px;
  height: 342px;
  background: url(../assets/imgs/签到.png) no-repeat;
  background-size: cover;
}
.Attend_Box .Attend_Box_conect {
  position: relative;
  margin-top: 50px;
}
.show_time {
  position: absolute;
  top: 60px;
  left: 100px;
  font-size: 24px;
  color: #1872ed;
}
.el-dialog--center .el-dialog__body {
  padding: 0px 25px 0px;
}

.Attend_Box_btn {
  margin-top: 30px;
  height: 40px;
  line-height: 40px;
  background: rgba(0, 140, 248, 1);
  border-radius: 30px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  text-align: center;
}
.Attend_Box circle {
  /*圆环的过渡动画 */
  -webkit-transition: stroke-dasharray 800ms;
  transition: stroke-dasharray 800ms;
}
.el-dialog {
  border-radius: 16px !important;
}

.teacher_ewm .el-dialog {
  border-radius: 16px !important;
  display: flex;
  justify-content: center;
  background: none;
  box-shadow: none;
}
.erweima .el-dialog__header {
  padding: 24px 20px 0px 20px !important;
}
.erweima .el-dialog__body {
  padding: 10px 0px 0px 0px;
}
.parent_bgc {
  width: 320px;
  min-height: 405px;
  max-height: 585px;
  background-color: #fff;
  border-radius: 12px;
}
.text_contect {
  width: 272px;
  min-height: 20px;
  max-height: 198px;
  font-size: 16px;
  letter-spacing: 2px;
  color: rgba(0, 0, 0, 0.85);
  margin-top: 15px;
  margin-left: 24px;
  line-height: 1;
}
.parent_bgc1 {
  width: 320px;
  max-height: 585px;
  background-color: #fff;
  border-radius: 12px;
}
.text_contect1 {
  width: 272px;
  min-height: 170px;
  max-height: 400px;
  font-size: 16px;
  letter-spacing: 2px;
  color: rgba(0, 0, 0, 0.85);
  margin-top: 15px;
  margin-left: 24px;
  line-height: 1;
}
.notice_close {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 232px;
  height: 36px;
  background: linear-gradient(96deg, #73aaff 0%, #0053ff 100%);
  border-radius: 40px;
  margin: 40px 0px 20px 40px;
  cursor: pointer;
}
.text_contect::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.text_contect::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.text_contect::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 5px;
}
.text_contect1::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.text_contect1::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.text_contect1::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 5px;
}
/* .text_contect::-webkit-scrollbar-thumb:hover{
  background: #333;
} */
/* .text_contect::-webkit-scrollbar-corner{
  background: #179a16;
} */
::-moz-scrollbar-button,
::-webkit-scrollbar-button {
  width: 0px;
}

.v-modal {
  opacity: 0.6;
}

.dotDiv {
  border-radius: 6px;
  display: inline-block;
  width: 12px;
  height: 12px;
}

@keyframes myfirst1 {
  0% {
    background: #12c8ff;
  }

  50% {
    background: #68ddff;
  }

  100% {
    background: #a0e9ff;
  }
}

@keyframes myfirst2 {
  0% {
    background: #68ddff;
  }

  50% {
    background: #a0e9ff;
  }

  100% {
    background: #12c8ff;
  }
}

@keyframes myfirst3 {
  0% {
    background: #a0e9ff;
  }

  50% {
    background: #12c8ff;
  }

  100% {
    background: #68ddff;
  }
}

.bottomTips {
  z-index: 3000;
  position: fixed;
  bottom: 0px;
  left: 0px;
  background-color: blanchedalmond;
  width: 100%;
  height: 50px;
}

.bottomTips p {
  position: relative;
  width: 100%;
  line-height: 50px;
  font-size: 18px;
  color: red;
  text-align: center;
}

.bottomTips p a {
  cursor: pointer;
  color: blue;
}

.bottomTips p span {
  position: absolute;
  right: 20px;
  bottom: 0px;
  color: #000;
  cursor: pointer;
}

.unReadViewShowAni {
  animation: showUnReadView 0.5s ease-in, hiddenUnReadView 1s ease-out 3s;
  animation-fill-mode: forwards;
}

.focusBtn {
  display: inline-block;
  vertical-align: top;
  color: white;
  padding-left: 10px;
  height: 17px;
  line-height: 17px;
  cursor: pointer;
}

.content-box_span {
  width: 140px;
  line-height: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

@keyframes showUnReadView {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes hiddenUnReadView {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.zhuTeacher {
  display: inline-block;
  text-align: center;
  color: #ffffff;
  background: red;
  font-size: 12px;
  margin-left: 4px;
  line-height: 13px;
  padding: 3px;
  border-radius: 3px;
}

.contentBox img {
  max-width: 100%;
}

.copyText {
  position: absolute;
  right: -29px;
  top: 10px;
  font-size: 13px;
  color: #1483ff;
  cursor: default;
}

.teacherQr {
  position: absolute;
  top: 7px;
  right: 10px;
  width: 45px;
  height: 45px;
  z-index: 2002;
}

.noticeBar {
  display: flex;
  width: 100%;
  padding: 4px;
  font-size: 14px;
  color: #f5f5f4;
  background: #09a1ff;
  line-height: 22px;
}

.noticeTop {
  position: absolute;
  top: 39px;
  left: 0px;
  z-index: 1999;
}

.imgText img {
  max-width: 100%;
}

.el-message-box__message p {
  font-weight: 700;
  font-size: 16px;
}

.zizhipc {
  overflow: hidden;
  height: 130px;
  background: rgb(21, 21, 21);
  text-align: center;
}

.xinxiyang {
  width: 100px;
  padding-top: 20px;
  display: flex;
  margin: 0 auto;
}

.xiaotan {
  width: 100px;
  height: 22px;
  text-align: center;
  /* border-right: 1px solid #000; */
}

.xiaotanyi {
  width: 100px;
  height: 22px;
  text-align: center;
}

.xiaotan p {
  color: rgb(238, 240, 241);
}

.xiaotanyi p {
  color: rgb(100, 100, 100);
}

.tijiaoanniu {
  width: 130px;
  height: 30px;
  background: #0066ff;
  border: none;
  color: #fff;
  border-radius: 20px;
  margin-top: 20px;
}

.shuruyanz {
  width: 220px;
  height: 40px;
}

.yanzhengmade {
  text-align: center;
  margin-top: 20px;
}

.anquan p {
  color: #000;
  font-weight: 600;
}

.yanzhengma {
  height: 230px;
}

.qiyemc {
  float: left;
  margin-left: 20px;
}

.gongming {
  float: right;
  margin-right: 20px;
}

.touyide {
  height: 68px;
  margin-top: 20px;
  display: flex;
}

.touxiang {
  width: 68px;
  height: 68px;
  border-radius: 34px;
  margin-left: 20px;
}

.tongbu {
  width: 110px;
  height: 30px;
  border: 1px silver solid;
  border-radius: 20px;
  margin-left: 12px;
  margin-top: 16px;
  display: flex;
  line-height: 30px;
}

.xuexijilu {
  width: 500px;
  height: 100px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 4px;
  display: flex;
  border: 1px silver solid;
  /* background: lightblue; */
}

.pc_no_watch_dialog {
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  z-index: 3003;
  background-image: url("../assets/imgs/no_watch_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.pc_no_watch_dialog .pc_no_watch_dialog_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px 16px 16px 16px;
  background-color: #ffffff;
  padding: 10px 0;
  overflow: hidden;
}

.pc_no_watch_dialog .pc_no_watch_dialog_text {
  text-align: center;
  font-size: 24px;
  color: #4b4b4b;
  padding-top: 10px;
  padding-bottom: 30px;
}

.customClass {
  z-index: 3008 !important;
}

.customClassDialog {
  background: linear-gradient(360deg, #a6d3f6 0%, #d3ebff 100%) !important;
  padding: 0px 20px 0px !important;
}

.enterWatchBtn {
  margin-top: 39px;
  background: #008cf8;
  height: 50px;
  line-height: 50px;
  box-shadow: 0px 8px 12px 1px rgba(21, 45, 77, 0.1);
  border-radius: 16px 16px 16px 16px;
  color: #ffffff;
  font-size: 22px;
  cursor: default;
}

.watchbox {
  flex: 1;
  height: 50px;
  line-height: 50px;
  background: #ffffff;
  border-radius: 6px;
  padding: 0 10px;
}
.custom-confirm .el-dialog {
  border-radius: 8px !important;
}
.agreementDialog .el-dialog {
  border-radius: 8px !important;
}
.agreementDialog .el-dialog__body {
  padding-bottom: 10px !important;
}
.custom-confirm .el-dialog__body {
  padding: 10px 34px 10px 44px;
}
.custom-confirm-header {
  display: flex;
  align-items: center;
}

.custom-confirm-header img {
  width: 18px;
  height: 18px;
}

.custom-confirm-header span {
  margin-left: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #202020;
}
.custom-confirm-content {
  color: #202020;
}
.submitBox {
  width: 100%;
  display: flex;
  margin-top: 4px;
  justify-content: flex-end;
  box-sizing: border-box;
}
.submitBox p {
  width: 64px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}
.cancels {
  color: #202020;
  background: #dfe3e8;
}
.submit {
  background: linear-gradient(110deg, #73aaff 0%, #0053ff 100%);
  color: #fff;
  margin-left: 20px;
}
.couponBox {
  position: absolute;
  bottom: 155px;
  right: 16px;
}
.couponBox img {
  cursor: pointer;
  width: 44px;
}
.payment .el-dialog__body {
  padding-top: 10px;
}
.send-btn {
  border: none;
  bottom: 10px;
  right: 10px;
  position: absolute;
  width: 79px;
  height: 31px;
  text-align: center;
  background: linear-gradient(137deg, #73aaff 5%, #0053ff 93%);
  border-radius: 16px;
  font-size: 14px;
  color: white;
}
.bgg1 {
  background: linear-gradient(
    180deg,
    rgba(17, 221, 255, 1) 0%,
    rgba(7, 184, 255, 1) 100%
  );
}
.bgg2 {
  background: linear-gradient(
    180deg,
    rgba(255, 206, 69, 1) 0%,
    rgba(255, 171, 74, 1) 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue